import { Component, ChangeDetectorRef, OnDestroy, input, Output, EventEmitter, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import * as THREE from 'three';
import { FikoAktiviteProfil } from '../FikoAktiviteProfil';
import { FikoSahne } from '../../../../FikoSahne';
import { FikoVektor3D } from '../../../../FikoVektor3d';
import { FikoSecililer } from '../../../../FikoSecililer';
import { occtFaceVertices, faceBrepVertices } from '../../../brep/face-cam-extract';

/**
 * DialogFikoProfilComponent - Profil CAM Dialog
 * 4 TAB SİSTEMİ: Profil | İşleme | Takım | Geçişler
 * @version 22.0.0 - MULTI-TAB SYSTEM
 *
 * Tab 0 - Profil: Geometri seçimi (mevcut)
 * Tab 1 - İşleme: İşleme parametreleri (zHatve, yanalHatve, devir, hızlar)
 * Tab 2 - Takım: Takım tanıtımı (çap, boy, kesme boyu)
 * Tab 3 - Geçişler: Giriş/Çıkış ve ara geçiş parametreleri
 */
@Component({
    selector: 'fikoyt-dialog-fiko-profil',
    standalone: true,
    imports: [CommonModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="cam-dialog" *ngIf="aktivite()">

        <!-- NEON BORDER EFFECT -->
        <div class="neon-border"></div>

        <!-- Header -->
        <div class="d-header">
            <div class="header-glow"></div>
            <div class="title-wrap">
                <svg class="title-icon" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="8" fill="none" stroke="url(#titleGrad)" stroke-width="2"/>
                    <circle cx="12" cy="12" r="4" fill="url(#titleGrad)"/>
                    <defs>
                        <linearGradient id="titleGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stop-color="#0ff"/><stop offset="100%" stop-color="#0af"/>
                        </linearGradient>
                    </defs>
                </svg>
                <span class="title">Profil İşleme</span>
            </div>
            <div class="mode-toggle" (click)="toggleYon()">
                <span class="mode-label" [class.active]="aktivite()!.islemeYontemi === 'Tek Yön'">Tek</span>
                <div class="toggle-track">
                    <div class="toggle-thumb" [class.right]="aktivite()!.islemeYontemi === 'Zik Zak'"></div>
                </div>
                <span class="mode-label" [class.active]="aktivite()!.islemeYontemi === 'Zik Zak'">Zik</span>
            </div>
        </div>

        <!-- ═══════════════════════════════════════════════════════════════════
             TAB HEADER - 4 TAB
             ═══════════════════════════════════════════════════════════════════ -->
        <div class="tab-header">
            <button class="tab-btn" [class.active]="aktifTab === 0" (click)="setTab(0)">
                <svg viewBox="0 0 20 20" class="tab-icon">
                    <ellipse cx="10" cy="10" rx="7" ry="4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-dasharray="3,2"/>
                    <circle cx="10" cy="10" r="2" fill="currentColor"/>
                </svg>
                <span>Profil</span>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 1" (click)="setTab(1)">
                <svg viewBox="0 0 20 20" class="tab-icon">
                    <path d="M3,14 L7,6 L11,10 L17,4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    <circle cx="17" cy="4" r="2" fill="currentColor"/>
                </svg>
                <span>İşleme</span>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 2" (click)="setTab(2)">
                <svg viewBox="0 0 20 20" class="tab-icon">
                    <rect x="8" y="2" width="4" height="12" rx="1" fill="currentColor" opacity="0.7"/>
                    <ellipse cx="10" cy="15" rx="5" ry="2" fill="none" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                <span>Takım</span>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 3" (click)="setTab(3)">
                <svg viewBox="0 0 20 20" class="tab-icon">
                    <path d="M4,16 L4,10 Q4,6 10,6 Q16,6 16,10 L16,16" fill="none" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="4" cy="16" r="2" fill="currentColor"/>
                    <circle cx="16" cy="16" r="2" fill="currentColor"/>
                </svg>
                <span>Geçiş</span>
            </button>
        </div>

        <!-- ═══════════════════════════════════════════════════════════════════
             TAB 0: PROFİL (Mevcut İçerik)
             ═══════════════════════════════════════════════════════════════════ -->
        <ng-container *ngIf="aktifTab === 0">

        <!-- İŞLEME TÜRÜ SEÇİMİ -->
        <div class="type-section">
            <div class="type-buttons">
                <button class="type-btn" [class.active]="islemeTuru === 'duzlem-duzlem'"
                        (click)="setIslemeTuru('duzlem-duzlem')">
                    <div class="type-icon-wrap">
                        <svg viewBox="0 0 40 40" class="type-icon">
                            <defs>
                                <linearGradient id="cyanGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" stop-color="#0ff"/><stop offset="100%" stop-color="#08f"/>
                                </linearGradient>
                                <linearGradient id="orangeGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" stop-color="#f80"/><stop offset="100%" stop-color="#f40"/>
                                </linearGradient>
                            </defs>
                            <rect x="4" y="8" width="32" height="6" rx="2" fill="url(#cyanGrad)" class="icon-shape"/>
                            <rect x="4" y="26" width="32" height="6" rx="2" fill="url(#orangeGrad)" class="icon-shape"/>
                            <line x1="20" y1="14" x2="20" y2="26" stroke="#4df" stroke-width="2" stroke-dasharray="4,3" class="icon-line"/>
                        </svg>
                    </div>
                    <span class="type-label">D-D</span>
                    <div class="type-glow"></div>
                </button>
                <button class="type-btn" [class.active]="islemeTuru === 'cizgi-cizgi'"
                        (click)="setIslemeTuru('cizgi-cizgi')">
                    <div class="type-icon-wrap">
                        <svg viewBox="0 0 40 40" class="type-icon">
                            <path d="M4,12 Q12,4 20,12 Q28,20 36,12" fill="none" stroke="url(#cyanGrad)" stroke-width="4" stroke-linecap="round" class="icon-shape"/>
                            <path d="M4,28 Q12,20 20,28 Q28,36 36,28" fill="none" stroke="url(#orangeGrad)" stroke-width="4" stroke-linecap="round" class="icon-shape"/>
                        </svg>
                    </div>
                    <span class="type-label">Ç-Ç</span>
                    <div class="type-glow"></div>
                </button>
                <button class="type-btn" [class.active]="islemeTuru === 'cizgi-yuzey'"
                        (click)="setIslemeTuru('cizgi-yuzey')">
                    <div class="type-icon-wrap">
                        <svg viewBox="0 0 40 40" class="type-icon">
                            <path d="M4,10 Q12,4 20,10 Q28,16 36,10" fill="none" stroke="url(#cyanGrad)" stroke-width="4" stroke-linecap="round" class="icon-shape"/>
                            <path d="M4,22 Q20,34 36,22 L36,32 Q20,44 4,32 Z" fill="url(#orangeGrad)" opacity="0.8" class="icon-shape"/>
                        </svg>
                    </div>
                    <span class="type-label">Ç-Y</span>
                    <div class="type-glow"></div>
                </button>
                <button class="type-btn" [class.active]="islemeTuru === 'yuzey-yuzey'"
                        (click)="setIslemeTuru('yuzey-yuzey')">
                    <div class="type-icon-wrap">
                        <svg viewBox="0 0 40 40" class="type-icon">
                            <path d="M4,6 Q20,14 36,6 L36,14 Q20,22 4,14 Z" fill="url(#cyanGrad)" opacity="0.8" class="icon-shape"/>
                            <path d="M4,26 Q20,34 36,26 L36,34 Q20,42 4,34 Z" fill="url(#orangeGrad)" opacity="0.8" class="icon-shape"/>
                        </svg>
                    </div>
                    <span class="type-label">Y-Y</span>
                    <div class="type-glow"></div>
                </button>
            </div>
        </div>

        <!-- TAM İNTERAKTİF SVG - TÜM SEÇİMLER ŞEKİLLERLE -->
        <svg viewBox="0 0 280 240" class="main-svg">
            <defs>
                <linearGradient id="gT" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#a06848"/><stop offset="100%" stop-color="#805030"/>
                </linearGradient>
                <linearGradient id="gL" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#503020"/><stop offset="100%" stop-color="#684030"/>
                </linearGradient>
                <linearGradient id="gR" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#806040"/><stop offset="100%" stop-color="#604028"/>
                </linearGradient>
                <linearGradient id="surfTop" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#00ddff"/><stop offset="100%" stop-color="#006688"/>
                </linearGradient>
                <linearGradient id="surfBot" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#ff8866"/><stop offset="100%" stop-color="#884422"/>
                </linearGradient>
                <linearGradient id="checkGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#88ff00"/><stop offset="100%" stop-color="#44aa00"/>
                </linearGradient>
                <linearGradient id="basGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#00ff88"/><stop offset="100%" stop-color="#00cc66"/>
                </linearGradient>
                <linearGradient id="bitGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#ff8844"/><stop offset="100%" stop-color="#cc6622"/>
                </linearGradient>
                <filter id="glow"><feGaussianBlur stdDeviation="2.5" result="b"/>
                    <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
                </filter>
                <filter id="glow-strong"><feGaussianBlur stdDeviation="4" result="b"/>
                    <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
                </filter>
                <filter id="glow-green"><feGaussianBlur stdDeviation="3" result="b"/>
                    <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
                </filter>
            </defs>

            <!-- Background -->
            <rect width="280" height="240" fill="#060a10"/>

            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- DÜZLEM-DÜZLEM MODU -->
            <!-- ═══════════════════════════════════════════════════════ -->
            <ng-container *ngIf="islemeTuru === 'duzlem-duzlem'">
                <!-- Üst Düzlem - Yazı genişliğinde kompakt -->
                <g class="clickable limit-area" (click)="secUstLimit()">
                    <path d="M100,28 L180,28 L190,42 L110,42 Z"
                          [attr.fill]="ustLimitSecili ? 'rgba(0,220,255,0.4)' : 'rgba(0,150,200,0.2)'"
                          [attr.stroke]="ustLimitSecili ? '#0ff' : '#0aa'"
                          [attr.stroke-width]="ustLimitSecili ? 2 : 1"
                          [attr.filter]="ustLimitSecili ? 'url(#glow)' : ''"/>
                    <text x="145" y="39" text-anchor="middle" fill="#0cf" font-size="8" font-weight="bold">ÜST DÜZLEM</text>
                </g>
                <g class="clickable val-edit" (click)="editValue('topZ')">
                    <rect x="195" y="28" width="26" height="14" rx="3" fill="rgba(0,80,100,0.6)" stroke="#088" stroke-width="0.5"/>
                    <text x="208" y="38" text-anchor="middle" fill="#0cf" font-size="8" font-weight="bold">{{topZ}}</text>
                </g>

                <!-- 3D Parça + Check Surface - BÜYÜTÜLMÜŞ -->
                <g transform="translate(140, 108)">
                    <g transform="scale(1.55)">
                        <!-- Check Surface - Parça Etrafında -->
                        <g class="clickable check-area" (click)="secCheck()">
                            <ellipse cx="0" cy="3" rx="68" ry="25"
                                     fill="none"
                                     [attr.stroke]="checkSecili ? '#8f0' : '#453'"
                                     [attr.stroke-width]="checkSecili ? 1.5 : 0.8"
                                     stroke-dasharray="6,3"
                                     [attr.filter]="checkSecili ? 'url(#glow-green)' : ''"/>
                            <text x="0" y="33" text-anchor="middle" [attr.fill]="checkSecili ? '#8f0' : '#564'" font-size="5" font-weight="bold" style="pointer-events:none">CHECK SURFACE</text>
                        </g>

                        <!-- Gölge -->
                        <ellipse cx="0" cy="32" rx="42" ry="9" fill="rgba(0,0,0,0.3)"/>

                        <!-- 3D Parça -->
                        <path d="M-48,14 L-48,-10 L-17,-23 L-17,2 Z" fill="url(#gL)" stroke="#201510" stroke-width="0.7"/>
                        <path d="M48,14 L48,-10 L17,-23 L17,2 Z" fill="url(#gR)" stroke="#201510" stroke-width="0.7"/>
                        <path d="M-48,-10 L-17,-23 L17,-23 L48,-10 L0,2 Z" fill="url(#gT)" stroke="#201510" stroke-width="0.7"/>
                        <ellipse cx="0" cy="-5" rx="20" ry="7" fill="#030303"/>

                        <!-- Profil Konturu + BAŞ/BİT Noktaları -->
                        <g class="clickable profil-kontur" (click)="secProfil()">
                            <ellipse cx="0" cy="-5" [attr.rx]="20 + profilOffset*1.5" [attr.ry]="7 + profilOffset*0.5"
                                     fill="rgba(0,255,200,0.05)"
                                     [attr.stroke]="profilSecili ? '#0ff' : '#0a8'"
                                     [attr.stroke-width]="profilSecili ? 2 : 1"
                                     stroke-dasharray="4,2"
                                     [attr.filter]="profilSecili ? 'url(#glow-strong)' : ''"/>
                            <text x="0" y="-3" text-anchor="middle" dominant-baseline="middle" [attr.fill]="profilSecili ? '#0ff' : '#086'" font-size="5" font-weight="bold" style="pointer-events:none">PROFİL</text>
                        </g>

                        <!-- BAŞ Noktası (Profil üzerinde sol) -->
                        <g class="clickable start-point" (click)="secBaslangic()">
                            <circle [attr.cx]="-20 - profilOffset*1.5" cy="-5" r="5"
                                    [attr.fill]="baslangicSecili ? 'rgba(0,255,136,0.3)' : 'rgba(0,200,100,0.15)'"
                                    [attr.stroke]="baslangicSecili ? '#0f8' : '#084'"
                                    [attr.stroke-width]="baslangicSecili ? 1.5 : 0.8"
                                    [attr.filter]="baslangicSecili ? 'url(#glow-green)' : ''"/>
                            <text [attr.x]="-20 - profilOffset*1.5" y="-3" text-anchor="middle" dominant-baseline="middle"
                                  [attr.fill]="baslangicSecili ? '#0f8' : '#064'" font-size="4" font-weight="bold" style="pointer-events:none">B</text>
                            <text [attr.x]="-20 - profilOffset*1.5" y="-14" text-anchor="middle" fill="#0a6" font-size="4" style="pointer-events:none">BAŞ</text>
                        </g>

                        <!-- BİT Noktası (Profil üzerinde sağ) -->
                        <g class="clickable end-point" (click)="secBitis()">
                            <circle [attr.cx]="20 + profilOffset*1.5" cy="-5" r="5"
                                    [attr.fill]="bitisSecili ? 'rgba(255,136,68,0.3)' : 'rgba(200,100,50,0.15)'"
                                    [attr.stroke]="bitisSecili ? '#f84' : '#853'"
                                    [attr.stroke-width]="bitisSecili ? 1.5 : 0.8"
                                    [attr.filter]="bitisSecili ? 'url(#glow)' : ''"/>
                            <text [attr.x]="20 + profilOffset*1.5" y="-3" text-anchor="middle" dominant-baseline="middle"
                                  [attr.fill]="bitisSecili ? '#f84' : '#642'" font-size="4" font-weight="bold" style="pointer-events:none">S</text>
                            <text [attr.x]="20 + profilOffset*1.5" y="-14" text-anchor="middle" fill="#a64" font-size="4" style="pointer-events:none">BİT</text>
                        </g>

                        <!-- TAKIM YÖNÜ (Tool Direction) -->
                        <g class="clickable tool-dir" (click)="secTakimYonu()">
                            <!-- Ok işareti (arrow) -->
                            <line x1="0" y1="-30" x2="0" y2="-42"
                                  [attr.stroke]="takimYonuSecili ? '#ff0' : '#885'"
                                  [attr.stroke-width]="takimYonuSecili ? 2 : 1.2"
                                  [attr.filter]="takimYonuSecili ? 'url(#glow)' : ''"/>
                            <polygon points="0,-45 -3,-40 3,-40"
                                     [attr.fill]="takimYonuSecili ? '#ff0' : '#885'"
                                     [attr.filter]="takimYonuSecili ? 'url(#glow)' : ''"/>
                            <text x="0" y="-48" text-anchor="middle" fill="#aa8" font-size="4" style="pointer-events:none">YÖN</text>
                        </g>
                    </g>
                </g>

                <!-- Alt Düzlem - Yazı genişliğinde kompakt -->
                <g class="clickable limit-area" (click)="secAltLimit()">
                    <path d="M100,168 L180,168 L190,182 L110,182 Z"
                          [attr.fill]="altLimitSecili ? 'rgba(255,100,80,0.4)' : 'rgba(200,80,60,0.2)'"
                          [attr.stroke]="altLimitSecili ? '#f86' : '#a54'"
                          [attr.stroke-width]="altLimitSecili ? 2 : 1"
                          [attr.filter]="altLimitSecili ? 'url(#glow)' : ''"/>
                    <text x="145" y="179" text-anchor="middle" fill="#f86" font-size="8" font-weight="bold">ALT DÜZLEM</text>
                </g>
                <g class="clickable val-edit" (click)="editValue('bottomZ')">
                    <rect x="195" y="168" width="26" height="14" rx="3" fill="rgba(100,50,30,0.6)" stroke="#854" stroke-width="0.5"/>
                    <text x="208" y="178" text-anchor="middle" fill="#fa8" font-size="8" font-weight="bold">{{bottomZ}}</text>
                </g>

                <!-- BAŞ/BİT Offset Değerleri (Alt Panel) -->
                <g transform="translate(0, 198)">
                    <!-- BAŞ Offset -->
                    <g class="clickable val-edit" (click)="editValue('baslangicOffset')">
                        <rect x="10" y="0" width="55" height="20" rx="4" fill="rgba(0,80,60,0.4)" stroke="#084" stroke-width="1"/>
                        <text x="37" y="8" text-anchor="middle" fill="#0a6" font-size="6">BAŞ OFS</text>
                        <text x="37" y="17" text-anchor="middle" fill="#0f8" font-size="9" font-weight="bold">{{baslangicOffset}}</text>
                    </g>
                    <!-- BAŞ Modu -->
                    <g class="clickable mode-btn" (click)="cycleBaslangicModu()">
                        <rect x="68" y="0" width="22" height="20" rx="4" fill="rgba(0,60,50,0.5)" stroke="#074" stroke-width="1"/>
                        <text x="79" y="13" text-anchor="middle" fill="#0f8" font-size="11" font-weight="bold">{{baslangicModu === 'merkez' ? '●' : baslangicModu === 'icerde' ? '◀' : '▶'}}</text>
                    </g>

                    <!-- Profil Offset (Merkez) -->
                    <g class="clickable val-edit" (click)="editValue('profilOffset')">
                        <rect x="98" y="0" width="48" height="20" rx="4" fill="rgba(0,60,80,0.4)" stroke="#086" stroke-width="1"/>
                        <text x="122" y="8" text-anchor="middle" fill="#0aa" font-size="6">OFS</text>
                        <text x="122" y="17" text-anchor="middle" fill="#0ff" font-size="9" font-weight="bold">{{profilOffset}}</text>
                    </g>

                    <!-- BİT Modu -->
                    <g class="clickable mode-btn" (click)="cycleBitisModu()">
                        <rect x="154" y="0" width="22" height="20" rx="4" fill="rgba(60,40,20,0.5)" stroke="#743" stroke-width="1"/>
                        <text x="165" y="13" text-anchor="middle" fill="#f84" font-size="11" font-weight="bold">{{bitisModu === 'merkez' ? '●' : bitisModu === 'icerde' ? '▶' : '◀'}}</text>
                    </g>
                    <!-- BİT Offset -->
                    <g class="clickable val-edit" (click)="editValue('bitisOffset')">
                        <rect x="179" y="0" width="55" height="20" rx="4" fill="rgba(80,50,30,0.4)" stroke="#853" stroke-width="1"/>
                        <text x="206" y="8" text-anchor="middle" fill="#a64" font-size="6">BİT OFS</text>
                        <text x="206" y="17" text-anchor="middle" fill="#f84" font-size="9" font-weight="bold">{{bitisOffset}}</text>
                    </g>

                    <!-- Check Indicator -->
                    <g class="clickable" (click)="secCheck()">
                        <circle cx="255" y="10" r="8"
                                [attr.fill]="checkSecili ? 'rgba(136,255,0,0.3)' : 'rgba(80,100,40,0.3)'"
                                [attr.stroke]="checkSecili ? '#8f0' : '#564'"
                                stroke-width="1.5"/>
                        <text x="255" y="13" text-anchor="middle" [attr.fill]="checkSecili ? '#8f0' : '#564'" font-size="8" font-weight="bold" style="pointer-events:none">✓</text>
                    </g>
                </g>
            </ng-container>

            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- ÇİZGİ-ÇİZGİ MODU -->
            <!-- ═══════════════════════════════════════════════════════ -->
            <ng-container *ngIf="islemeTuru === 'cizgi-cizgi'">
                <!-- Üst Çizgi (Dalgalı) -->
                <g class="clickable limit-area" (click)="secUstLimit()">
                    <path d="M30,32 Q80,22 130,32 Q180,42 230,32"
                          fill="none"
                          [attr.stroke]="ustLimitSecili ? '#00ffff' : '#00aabb'"
                          [attr.stroke-width]="ustLimitSecili ? 4 : 2.5"
                          stroke-linecap="round"
                          [attr.filter]="ustLimitSecili ? 'url(#glow)' : ''"/>
                    <circle cx="30" cy="32" r="5" [attr.fill]="ustLimitSecili ? '#0ff' : '#088'" stroke="#fff" stroke-width="1"/>
                    <circle cx="230" cy="32" r="5" [attr.fill]="ustLimitSecili ? '#0ff' : '#088'" stroke="#fff" stroke-width="1"/>
                    <text x="130" y="18" text-anchor="middle" fill="#0cf" font-size="8" font-weight="bold">ÜST ÇİZGİ</text>
                </g>
                <g class="clickable val-edit" (click)="editValue('topZ')">
                    <rect x="238" y="24" width="22" height="14" rx="3" fill="rgba(0,80,100,0.6)" stroke="#088" stroke-width="0.5"/>
                    <text x="249" y="34" text-anchor="middle" fill="#0cf" font-size="8" font-weight="bold">{{topZ}}</text>
                </g>

                <!-- 3D Parça + Check + BAŞ/BİT - BÜYÜTÜLMÜŞ -->
                <g transform="translate(140, 105)">
                    <g transform="scale(1.35)">
                        <!-- Check Surface -->
                        <g class="clickable check-area" (click)="secCheck()">
                            <ellipse cx="0" cy="10" rx="68" ry="28" fill="none"
                                     [attr.stroke]="checkSecili ? '#8f0' : '#453'" [attr.stroke-width]="checkSecili ? 1.5 : 0.8"
                                     stroke-dasharray="6,3" [attr.filter]="checkSecili ? 'url(#glow-green)' : ''"/>
                            <text x="0" y="44" text-anchor="middle" [attr.fill]="checkSecili ? '#8f0' : '#564'" font-size="5" font-weight="bold" style="pointer-events:none">CHECK SURFACE</text>
                        </g>
                        <ellipse cx="0" cy="32" rx="42" ry="9" fill="rgba(0,0,0,0.3)"/>
                        <path d="M-48,14 L-48,-10 L-17,-23 L-17,2 Z" fill="url(#gL)" stroke="#201510" stroke-width="0.7"/>
                        <path d="M48,14 L48,-10 L17,-23 L17,2 Z" fill="url(#gR)" stroke="#201510" stroke-width="0.7"/>
                        <path d="M-48,-10 L-17,-23 L17,-23 L48,-10 L0,2 Z" fill="url(#gT)" stroke="#201510" stroke-width="0.7"/>
                        <ellipse cx="0" cy="-5" rx="20" ry="7" fill="#030303"/>
                        <!-- Profil -->
                        <g class="clickable profil-kontur" (click)="secProfil()">
                            <ellipse cx="0" cy="-5" [attr.rx]="20 + profilOffset*1.5" [attr.ry]="7 + profilOffset*0.5"
                                     fill="rgba(0,255,200,0.05)" [attr.stroke]="profilSecili ? '#0ff' : '#0a8'"
                                     [attr.stroke-width]="profilSecili ? 2 : 1" stroke-dasharray="4,2"
                                     [attr.filter]="profilSecili ? 'url(#glow-strong)' : ''"/>
                            <text x="0" y="-3" text-anchor="middle" dominant-baseline="middle" [attr.fill]="profilSecili ? '#0ff' : '#086'" font-size="5" font-weight="bold" style="pointer-events:none">PROFİL</text>
                        </g>
                        <!-- BAŞ/BİT -->
                        <g class="clickable start-point" (click)="secBaslangic()">
                            <circle [attr.cx]="-20 - profilOffset*1.5" cy="-5" r="5"
                                    [attr.fill]="baslangicSecili ? 'rgba(0,255,136,0.3)' : 'rgba(0,200,100,0.15)'"
                                    [attr.stroke]="baslangicSecili ? '#0f8' : '#084'" [attr.stroke-width]="baslangicSecili ? 1.5 : 0.8"
                                    [attr.filter]="baslangicSecili ? 'url(#glow-green)' : ''"/>
                            <text [attr.x]="-20 - profilOffset*1.5" y="-3" text-anchor="middle" [attr.fill]="baslangicSecili ? '#0f8' : '#064'" font-size="4" font-weight="bold" style="pointer-events:none">B</text>
                            <text [attr.x]="-20 - profilOffset*1.5" y="-14" text-anchor="middle" fill="#0a6" font-size="4" style="pointer-events:none">BAŞ</text>
                        </g>
                        <g class="clickable end-point" (click)="secBitis()">
                            <circle [attr.cx]="20 + profilOffset*1.5" cy="-5" r="5"
                                    [attr.fill]="bitisSecili ? 'rgba(255,136,68,0.3)' : 'rgba(200,100,50,0.15)'"
                                    [attr.stroke]="bitisSecili ? '#f84' : '#853'" [attr.stroke-width]="bitisSecili ? 1.5 : 0.8"
                                    [attr.filter]="bitisSecili ? 'url(#glow)' : ''"/>
                            <text [attr.x]="20 + profilOffset*1.5" y="-3" text-anchor="middle" [attr.fill]="bitisSecili ? '#f84' : '#642'" font-size="4" font-weight="bold" style="pointer-events:none">S</text>
                            <text [attr.x]="20 + profilOffset*1.5" y="-14" text-anchor="middle" fill="#a64" font-size="4" style="pointer-events:none">BİT</text>
                        </g>
                        <!-- TAKIM YÖNÜ (Tool Direction) -->
                        <g class="clickable tool-dir" (click)="secTakimYonu()">
                            <line x1="0" y1="-30" x2="0" y2="-42" [attr.stroke]="takimYonuSecili ? '#ff0' : '#885'" [attr.stroke-width]="takimYonuSecili ? 2 : 1.2" [attr.filter]="takimYonuSecili ? 'url(#glow)' : ''"/>
                            <polygon points="0,-45 -3,-40 3,-40" [attr.fill]="takimYonuSecili ? '#ff0' : '#885'" [attr.filter]="takimYonuSecili ? 'url(#glow)' : ''"/>
                            <text x="0" y="-48" text-anchor="middle" fill="#aa8" font-size="4" style="pointer-events:none">YÖN</text>
                        </g>
                    </g>
                </g>

                <!-- Alt Çizgi (Dalgalı) -->
                <g class="clickable limit-area" (click)="secAltLimit()">
                    <path d="M30,175 Q80,165 130,175 Q180,185 230,175"
                          fill="none" [attr.stroke]="altLimitSecili ? '#ff8866' : '#cc5544'"
                          [attr.stroke-width]="altLimitSecili ? 4 : 2.5" stroke-linecap="round"
                          [attr.filter]="altLimitSecili ? 'url(#glow)' : ''"/>
                    <circle cx="30" cy="175" r="5" [attr.fill]="altLimitSecili ? '#f86' : '#854'" stroke="#fff" stroke-width="1"/>
                    <circle cx="230" cy="175" r="5" [attr.fill]="altLimitSecili ? '#f86' : '#854'" stroke="#fff" stroke-width="1"/>
                    <text x="130" y="192" text-anchor="middle" fill="#f86" font-size="8" font-weight="bold">ALT ÇİZGİ</text>
                </g>
                <g class="clickable val-edit" (click)="editValue('bottomZ')">
                    <rect x="238" y="168" width="22" height="14" rx="3" fill="rgba(100,50,30,0.6)" stroke="#854" stroke-width="0.5"/>
                    <text x="249" y="178" text-anchor="middle" fill="#fa8" font-size="8" font-weight="bold">{{bottomZ}}</text>
                </g>

                <!-- Alt Panel - BAŞ/BİT Offset -->
                <g transform="translate(0, 198)">
                    <g class="clickable val-edit" (click)="editValue('baslangicOffset')">
                        <rect x="10" y="0" width="55" height="20" rx="4" fill="rgba(0,80,60,0.4)" stroke="#084"/>
                        <text x="37" y="8" text-anchor="middle" fill="#0a6" font-size="6">BAŞ</text>
                        <text x="37" y="17" text-anchor="middle" fill="#0f8" font-size="9" font-weight="bold">{{baslangicOffset}}</text>
                    </g>
                    <g class="clickable mode-btn" (click)="cycleBaslangicModu()">
                        <rect x="68" y="0" width="22" height="20" rx="4" fill="rgba(0,60,50,0.5)" stroke="#074"/>
                        <text x="79" y="13" text-anchor="middle" fill="#0f8" font-size="11">{{baslangicModu === 'merkez' ? '●' : baslangicModu === 'icerde' ? '◀' : '▶'}}</text>
                    </g>
                    <g class="clickable val-edit" (click)="editValue('profilOffset')">
                        <rect x="98" y="0" width="48" height="20" rx="4" fill="rgba(0,60,80,0.4)" stroke="#086"/>
                        <text x="122" y="8" text-anchor="middle" fill="#0aa" font-size="6">OFS</text>
                        <text x="122" y="17" text-anchor="middle" fill="#0ff" font-size="9" font-weight="bold">{{profilOffset}}</text>
                    </g>
                    <g class="clickable mode-btn" (click)="cycleBitisModu()">
                        <rect x="154" y="0" width="22" height="20" rx="4" fill="rgba(60,40,20,0.5)" stroke="#743"/>
                        <text x="165" y="13" text-anchor="middle" fill="#f84" font-size="11">{{bitisModu === 'merkez' ? '●' : bitisModu === 'icerde' ? '▶' : '◀'}}</text>
                    </g>
                    <g class="clickable val-edit" (click)="editValue('bitisOffset')">
                        <rect x="179" y="0" width="55" height="20" rx="4" fill="rgba(80,50,30,0.4)" stroke="#853"/>
                        <text x="206" y="8" text-anchor="middle" fill="#a64" font-size="6">BİT</text>
                        <text x="206" y="17" text-anchor="middle" fill="#f84" font-size="9" font-weight="bold">{{bitisOffset}}</text>
                    </g>
                    <g class="clickable" (click)="secCheck()">
                        <circle cx="255" y="10" r="8" [attr.fill]="checkSecili ? 'rgba(136,255,0,0.3)' : 'rgba(80,100,40,0.3)'"
                                [attr.stroke]="checkSecili ? '#8f0' : '#564'" stroke-width="1.5"/>
                        <text x="255" y="13" text-anchor="middle" [attr.fill]="checkSecili ? '#8f0' : '#564'" font-size="8" font-weight="bold" style="pointer-events:none">✓</text>
                    </g>
                </g>
            </ng-container>

            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- ÇİZGİ-YÜZEY MODU -->
            <!-- ═══════════════════════════════════════════════════════ -->
            <ng-container *ngIf="islemeTuru === 'cizgi-yuzey'">
                <!-- Üst Çizgi -->
                <g class="clickable limit-area" (click)="secUstLimit()">
                    <path d="M30,32 Q80,22 130,32 Q180,42 230,32"
                          fill="none" [attr.stroke]="ustLimitSecili ? '#00ffff' : '#00aabb'"
                          [attr.stroke-width]="ustLimitSecili ? 4 : 2.5" stroke-linecap="round"
                          [attr.filter]="ustLimitSecili ? 'url(#glow)' : ''"/>
                    <circle cx="30" cy="32" r="5" [attr.fill]="ustLimitSecili ? '#0ff' : '#088'" stroke="#fff" stroke-width="1"/>
                    <circle cx="230" cy="32" r="5" [attr.fill]="ustLimitSecili ? '#0ff' : '#088'" stroke="#fff" stroke-width="1"/>
                    <text x="130" y="18" text-anchor="middle" fill="#0cf" font-size="8" font-weight="bold">ÜST ÇİZGİ</text>
                </g>
                <g class="clickable val-edit" (click)="editValue('topZ')">
                    <rect x="238" y="24" width="22" height="14" rx="3" fill="rgba(0,80,100,0.6)" stroke="#088" stroke-width="0.5"/>
                    <text x="249" y="34" text-anchor="middle" fill="#0cf" font-size="8" font-weight="bold">{{topZ}}</text>
                </g>

                <!-- 3D Parça + Check + BAŞ/BİT - BÜYÜTÜLMÜŞ -->
                <g transform="translate(140, 100)">
                    <g transform="scale(1.35)">
                        <g class="clickable check-area" (click)="secCheck()">
                            <ellipse cx="0" cy="10" rx="68" ry="28" fill="none"
                                     [attr.stroke]="checkSecili ? '#8f0' : '#453'" [attr.stroke-width]="checkSecili ? 1.5 : 0.8"
                                     stroke-dasharray="6,3" [attr.filter]="checkSecili ? 'url(#glow-green)' : ''"/>
                            <text x="0" y="44" text-anchor="middle" [attr.fill]="checkSecili ? '#8f0' : '#564'" font-size="5" font-weight="bold" style="pointer-events:none">CHECK SURFACE</text>
                        </g>
                        <ellipse cx="0" cy="32" rx="42" ry="9" fill="rgba(0,0,0,0.3)"/>
                        <path d="M-48,14 L-48,-10 L-17,-23 L-17,2 Z" fill="url(#gL)" stroke="#201510" stroke-width="0.7"/>
                        <path d="M48,14 L48,-10 L17,-23 L17,2 Z" fill="url(#gR)" stroke="#201510" stroke-width="0.7"/>
                        <path d="M-48,-10 L-17,-23 L17,-23 L48,-10 L0,2 Z" fill="url(#gT)" stroke="#201510" stroke-width="0.7"/>
                        <ellipse cx="0" cy="-5" rx="20" ry="7" fill="#030303"/>
                        <g class="clickable profil-kontur" (click)="secProfil()">
                            <ellipse cx="0" cy="-5" [attr.rx]="20 + profilOffset*1.5" [attr.ry]="7 + profilOffset*0.5"
                                     fill="rgba(0,255,200,0.05)" [attr.stroke]="profilSecili ? '#0ff' : '#0a8'"
                                     [attr.stroke-width]="profilSecili ? 2 : 1" stroke-dasharray="4,2"
                                     [attr.filter]="profilSecili ? 'url(#glow-strong)' : ''"/>
                            <text x="0" y="-3" text-anchor="middle" dominant-baseline="middle" [attr.fill]="profilSecili ? '#0ff' : '#086'" font-size="5" font-weight="bold" style="pointer-events:none">PROFİL</text>
                        </g>
                        <g class="clickable start-point" (click)="secBaslangic()">
                            <circle [attr.cx]="-20 - profilOffset*1.5" cy="-5" r="5"
                                    [attr.fill]="baslangicSecili ? 'rgba(0,255,136,0.3)' : 'rgba(0,200,100,0.15)'"
                                    [attr.stroke]="baslangicSecili ? '#0f8' : '#084'" [attr.stroke-width]="baslangicSecili ? 1.5 : 0.8"
                                    [attr.filter]="baslangicSecili ? 'url(#glow-green)' : ''"/>
                            <text [attr.x]="-20 - profilOffset*1.5" y="-3" text-anchor="middle" [attr.fill]="baslangicSecili ? '#0f8' : '#064'" font-size="4" font-weight="bold" style="pointer-events:none">B</text>
                            <text [attr.x]="-20 - profilOffset*1.5" y="-14" text-anchor="middle" fill="#0a6" font-size="4" style="pointer-events:none">BAŞ</text>
                        </g>
                        <g class="clickable end-point" (click)="secBitis()">
                            <circle [attr.cx]="20 + profilOffset*1.5" cy="-5" r="5"
                                    [attr.fill]="bitisSecili ? 'rgba(255,136,68,0.3)' : 'rgba(200,100,50,0.15)'"
                                    [attr.stroke]="bitisSecili ? '#f84' : '#853'" [attr.stroke-width]="bitisSecili ? 1.5 : 0.8"
                                    [attr.filter]="bitisSecili ? 'url(#glow)' : ''"/>
                            <text [attr.x]="20 + profilOffset*1.5" y="-3" text-anchor="middle" [attr.fill]="bitisSecili ? '#f84' : '#642'" font-size="4" font-weight="bold" style="pointer-events:none">S</text>
                            <text [attr.x]="20 + profilOffset*1.5" y="-14" text-anchor="middle" fill="#a64" font-size="4" style="pointer-events:none">BİT</text>
                        </g>
                        <!-- TAKIM YÖNÜ (Tool Direction) -->
                        <g class="clickable tool-dir" (click)="secTakimYonu()">
                            <line x1="0" y1="-30" x2="0" y2="-42" [attr.stroke]="takimYonuSecili ? '#ff0' : '#885'" [attr.stroke-width]="takimYonuSecili ? 2 : 1.2" [attr.filter]="takimYonuSecili ? 'url(#glow)' : ''"/>
                            <polygon points="0,-45 -3,-40 3,-40" [attr.fill]="takimYonuSecili ? '#ff0' : '#885'" [attr.filter]="takimYonuSecili ? 'url(#glow)' : ''"/>
                            <text x="0" y="-48" text-anchor="middle" fill="#aa8" font-size="4" style="pointer-events:none">YÖN</text>
                        </g>
                    </g>
                </g>

                <!-- Alt Yüzey (eğimli) -->
                <g class="clickable limit-area" (click)="secAltLimit()">
                    <path d="M30,160 Q140,178 250,160 L250,180 Q140,198 30,180 Z"
                          [attr.fill]="altLimitSecili ? 'rgba(255,100,80,0.4)' : 'rgba(200,80,60,0.25)'"
                          [attr.stroke]="altLimitSecili ? '#f86' : '#a54'" [attr.stroke-width]="altLimitSecili ? 2 : 1"
                          [attr.filter]="altLimitSecili ? 'url(#glow)' : ''"/>
                    <text x="140" y="180" text-anchor="middle" dominant-baseline="middle" fill="#fa8" font-size="8" font-weight="bold">ALT YÜZEY</text>
                </g>
                <g class="clickable val-edit" (click)="editValue('bottomZ')">
                    <rect x="253" y="168" width="22" height="14" rx="3" fill="rgba(100,50,30,0.6)" stroke="#854" stroke-width="0.5"/>
                    <text x="264" y="178" text-anchor="middle" fill="#fa8" font-size="8" font-weight="bold">{{bottomZ}}</text>
                </g>

                <!-- Alt Panel -->
                <g transform="translate(0, 198)">
                    <g class="clickable val-edit" (click)="editValue('baslangicOffset')">
                        <rect x="10" y="0" width="55" height="20" rx="4" fill="rgba(0,80,60,0.4)" stroke="#084"/>
                        <text x="37" y="8" text-anchor="middle" fill="#0a6" font-size="6">BAŞ</text>
                        <text x="37" y="17" text-anchor="middle" fill="#0f8" font-size="9" font-weight="bold">{{baslangicOffset}}</text>
                    </g>
                    <g class="clickable mode-btn" (click)="cycleBaslangicModu()">
                        <rect x="68" y="0" width="22" height="20" rx="4" fill="rgba(0,60,50,0.5)" stroke="#074"/>
                        <text x="79" y="13" text-anchor="middle" fill="#0f8" font-size="11">{{baslangicModu === 'merkez' ? '●' : baslangicModu === 'icerde' ? '◀' : '▶'}}</text>
                    </g>
                    <g class="clickable val-edit" (click)="editValue('profilOffset')">
                        <rect x="98" y="0" width="48" height="20" rx="4" fill="rgba(0,60,80,0.4)" stroke="#086"/>
                        <text x="122" y="8" text-anchor="middle" fill="#0aa" font-size="6">OFS</text>
                        <text x="122" y="17" text-anchor="middle" fill="#0ff" font-size="9" font-weight="bold">{{profilOffset}}</text>
                    </g>
                    <g class="clickable mode-btn" (click)="cycleBitisModu()">
                        <rect x="154" y="0" width="22" height="20" rx="4" fill="rgba(60,40,20,0.5)" stroke="#743"/>
                        <text x="165" y="13" text-anchor="middle" fill="#f84" font-size="11">{{bitisModu === 'merkez' ? '●' : bitisModu === 'icerde' ? '▶' : '◀'}}</text>
                    </g>
                    <g class="clickable val-edit" (click)="editValue('bitisOffset')">
                        <rect x="179" y="0" width="55" height="20" rx="4" fill="rgba(80,50,30,0.4)" stroke="#853"/>
                        <text x="206" y="8" text-anchor="middle" fill="#a64" font-size="6">BİT</text>
                        <text x="206" y="17" text-anchor="middle" fill="#f84" font-size="9" font-weight="bold">{{bitisOffset}}</text>
                    </g>
                    <g class="clickable" (click)="secCheck()">
                        <circle cx="255" y="10" r="8" [attr.fill]="checkSecili ? 'rgba(136,255,0,0.3)' : 'rgba(80,100,40,0.3)'"
                                [attr.stroke]="checkSecili ? '#8f0' : '#564'" stroke-width="1.5"/>
                        <text x="255" y="13" text-anchor="middle" [attr.fill]="checkSecili ? '#8f0' : '#564'" font-size="8" font-weight="bold" style="pointer-events:none">✓</text>
                    </g>
                </g>
            </ng-container>

            <!-- ═══════════════════════════════════════════════════════ -->
            <!-- YÜZEY-YÜZEY MODU -->
            <!-- ═══════════════════════════════════════════════════════ -->
            <ng-container *ngIf="islemeTuru === 'yuzey-yuzey'">
                <!-- Üst Yüzey (eğimli) -->
                <g class="clickable limit-area" (click)="secUstLimit()">
                    <path d="M30,22 Q140,40 250,22 L250,40 Q140,58 30,40 Z"
                          [attr.fill]="ustLimitSecili ? 'rgba(0,220,255,0.4)' : 'rgba(0,150,200,0.25)'"
                          [attr.stroke]="ustLimitSecili ? '#0ff' : '#0aa'" [attr.stroke-width]="ustLimitSecili ? 2 : 1"
                          [attr.filter]="ustLimitSecili ? 'url(#glow)' : ''"/>
                    <text x="140" y="40" text-anchor="middle" dominant-baseline="middle" fill="#0cf" font-size="8" font-weight="bold">ÜST YÜZEY</text>
                </g>
                <g class="clickable val-edit" (click)="editValue('topZ')">
                    <rect x="253" y="24" width="22" height="14" rx="3" fill="rgba(0,80,100,0.6)" stroke="#088" stroke-width="0.5"/>
                    <text x="264" y="34" text-anchor="middle" fill="#0cf" font-size="8" font-weight="bold">{{topZ}}</text>
                </g>

                <!-- 3D Parça + Check + BAŞ/BİT - BÜYÜTÜLMÜŞ -->
                <g transform="translate(140, 105)">
                    <g transform="scale(1.35)">
                        <g class="clickable check-area" (click)="secCheck()">
                            <ellipse cx="0" cy="8" rx="68" ry="28" fill="none"
                                     [attr.stroke]="checkSecili ? '#8f0' : '#453'" [attr.stroke-width]="checkSecili ? 1.5 : 0.8"
                                     stroke-dasharray="6,3" [attr.filter]="checkSecili ? 'url(#glow-green)' : ''"/>
                            <text x="0" y="42" text-anchor="middle" [attr.fill]="checkSecili ? '#8f0' : '#564'" font-size="5" font-weight="bold" style="pointer-events:none">CHECK SURFACE</text>
                        </g>
                        <ellipse cx="0" cy="32" rx="42" ry="9" fill="rgba(0,0,0,0.3)"/>
                        <path d="M-48,14 L-48,-10 L-17,-23 L-17,2 Z" fill="url(#gL)" stroke="#201510" stroke-width="0.7"/>
                        <path d="M48,14 L48,-10 L17,-23 L17,2 Z" fill="url(#gR)" stroke="#201510" stroke-width="0.7"/>
                        <path d="M-48,-10 L-17,-23 L17,-23 L48,-10 L0,2 Z" fill="url(#gT)" stroke="#201510" stroke-width="0.7"/>
                        <ellipse cx="0" cy="-5" rx="20" ry="7" fill="#030303"/>
                        <g class="clickable profil-kontur" (click)="secProfil()">
                            <ellipse cx="0" cy="-5" [attr.rx]="20 + profilOffset*1.5" [attr.ry]="7 + profilOffset*0.5"
                                     fill="rgba(0,255,200,0.05)" [attr.stroke]="profilSecili ? '#0ff' : '#0a8'"
                                     [attr.stroke-width]="profilSecili ? 2 : 1" stroke-dasharray="4,2"
                                     [attr.filter]="profilSecili ? 'url(#glow-strong)' : ''"/>
                            <text x="0" y="-3" text-anchor="middle" dominant-baseline="middle" [attr.fill]="profilSecili ? '#0ff' : '#086'" font-size="5" font-weight="bold" style="pointer-events:none">PROFİL</text>
                        </g>
                        <g class="clickable start-point" (click)="secBaslangic()">
                            <circle [attr.cx]="-20 - profilOffset*1.5" cy="-5" r="5"
                                    [attr.fill]="baslangicSecili ? 'rgba(0,255,136,0.3)' : 'rgba(0,200,100,0.15)'"
                                    [attr.stroke]="baslangicSecili ? '#0f8' : '#084'" [attr.stroke-width]="baslangicSecili ? 1.5 : 0.8"
                                    [attr.filter]="baslangicSecili ? 'url(#glow-green)' : ''"/>
                            <text [attr.x]="-20 - profilOffset*1.5" y="-3" text-anchor="middle" [attr.fill]="baslangicSecili ? '#0f8' : '#064'" font-size="4" font-weight="bold" style="pointer-events:none">B</text>
                            <text [attr.x]="-20 - profilOffset*1.5" y="-14" text-anchor="middle" fill="#0a6" font-size="4" style="pointer-events:none">BAŞ</text>
                        </g>
                        <g class="clickable end-point" (click)="secBitis()">
                            <circle [attr.cx]="20 + profilOffset*1.5" cy="-5" r="5"
                                    [attr.fill]="bitisSecili ? 'rgba(255,136,68,0.3)' : 'rgba(200,100,50,0.15)'"
                                    [attr.stroke]="bitisSecili ? '#f84' : '#853'" [attr.stroke-width]="bitisSecili ? 1.5 : 0.8"
                                    [attr.filter]="bitisSecili ? 'url(#glow)' : ''"/>
                            <text [attr.x]="20 + profilOffset*1.5" y="-3" text-anchor="middle" [attr.fill]="bitisSecili ? '#f84' : '#642'" font-size="4" font-weight="bold" style="pointer-events:none">S</text>
                            <text [attr.x]="20 + profilOffset*1.5" y="-14" text-anchor="middle" fill="#a64" font-size="4" style="pointer-events:none">BİT</text>
                        </g>
                        <!-- TAKIM YÖNÜ (Tool Direction) -->
                        <g class="clickable tool-dir" (click)="secTakimYonu()">
                            <line x1="0" y1="-30" x2="0" y2="-42" [attr.stroke]="takimYonuSecili ? '#ff0' : '#885'" [attr.stroke-width]="takimYonuSecili ? 2 : 1.2" [attr.filter]="takimYonuSecili ? 'url(#glow)' : ''"/>
                            <polygon points="0,-45 -3,-40 3,-40" [attr.fill]="takimYonuSecili ? '#ff0' : '#885'" [attr.filter]="takimYonuSecili ? 'url(#glow)' : ''"/>
                            <text x="0" y="-48" text-anchor="middle" fill="#aa8" font-size="4" style="pointer-events:none">YÖN</text>
                        </g>
                    </g>
                </g>

                <!-- Alt Yüzey (eğimli) -->
                <g class="clickable limit-area" (click)="secAltLimit()">
                    <path d="M30,160 Q140,178 250,160 L250,178 Q140,196 30,178 Z"
                          [attr.fill]="altLimitSecili ? 'rgba(255,100,80,0.4)' : 'rgba(200,80,60,0.25)'"
                          [attr.stroke]="altLimitSecili ? '#f86' : '#a54'" [attr.stroke-width]="altLimitSecili ? 2 : 1"
                          [attr.filter]="altLimitSecili ? 'url(#glow)' : ''"/>
                    <text x="140" y="178" text-anchor="middle" dominant-baseline="middle" fill="#fa8" font-size="8" font-weight="bold">ALT YÜZEY</text>
                </g>
                <g class="clickable val-edit" (click)="editValue('bottomZ')">
                    <rect x="253" y="166" width="22" height="14" rx="3" fill="rgba(100,50,30,0.6)" stroke="#854" stroke-width="0.5"/>
                    <text x="264" y="176" text-anchor="middle" fill="#fa8" font-size="8" font-weight="bold">{{bottomZ}}</text>
                </g>

                <!-- Alt Panel -->
                <g transform="translate(0, 198)">
                    <g class="clickable val-edit" (click)="editValue('baslangicOffset')">
                        <rect x="10" y="0" width="55" height="20" rx="4" fill="rgba(0,80,60,0.4)" stroke="#084"/>
                        <text x="37" y="8" text-anchor="middle" fill="#0a6" font-size="6">BAŞ</text>
                        <text x="37" y="17" text-anchor="middle" fill="#0f8" font-size="9" font-weight="bold">{{baslangicOffset}}</text>
                    </g>
                    <g class="clickable mode-btn" (click)="cycleBaslangicModu()">
                        <rect x="68" y="0" width="22" height="20" rx="4" fill="rgba(0,60,50,0.5)" stroke="#074"/>
                        <text x="79" y="13" text-anchor="middle" fill="#0f8" font-size="11">{{baslangicModu === 'merkez' ? '●' : baslangicModu === 'icerde' ? '◀' : '▶'}}</text>
                    </g>
                    <g class="clickable val-edit" (click)="editValue('profilOffset')">
                        <rect x="98" y="0" width="48" height="20" rx="4" fill="rgba(0,60,80,0.4)" stroke="#086"/>
                        <text x="122" y="8" text-anchor="middle" fill="#0aa" font-size="6">OFS</text>
                        <text x="122" y="17" text-anchor="middle" fill="#0ff" font-size="9" font-weight="bold">{{profilOffset}}</text>
                    </g>
                    <g class="clickable mode-btn" (click)="cycleBitisModu()">
                        <rect x="154" y="0" width="22" height="20" rx="4" fill="rgba(60,40,20,0.5)" stroke="#743"/>
                        <text x="165" y="13" text-anchor="middle" fill="#f84" font-size="11">{{bitisModu === 'merkez' ? '●' : bitisModu === 'icerde' ? '▶' : '◀'}}</text>
                    </g>
                    <g class="clickable val-edit" (click)="editValue('bitisOffset')">
                        <rect x="179" y="0" width="55" height="20" rx="4" fill="rgba(80,50,30,0.4)" stroke="#853"/>
                        <text x="206" y="8" text-anchor="middle" fill="#a64" font-size="6">BİT</text>
                        <text x="206" y="17" text-anchor="middle" fill="#f84" font-size="9" font-weight="bold">{{bitisOffset}}</text>
                    </g>
                    <g class="clickable" (click)="secCheck()">
                        <circle cx="255" y="10" r="8" [attr.fill]="checkSecili ? 'rgba(136,255,0,0.3)' : 'rgba(80,100,40,0.3)'"
                                [attr.stroke]="checkSecili ? '#8f0' : '#564'" stroke-width="1.5"/>
                        <text x="255" y="13" text-anchor="middle" [attr.fill]="checkSecili ? '#8f0' : '#564'" font-size="8" font-weight="bold" style="pointer-events:none">✓</text>
                    </g>
                </g>
            </ng-container>

        </svg>

        <!-- EK PARAMETRELER -->
        <div class="params-grid">
            <!-- Z Hatve -->
            <div class="param-item" (click)="editValue('zHatve')">
                <span class="param-label">Z Hatve</span>
                <span class="param-value cyan">{{aktivite()!.zHatve}} mm</span>
            </div>

            <!-- Yanal Hatve -->
            <div class="param-item" (click)="editValue('yanalHatve')">
                <span class="param-label">Yanal Hatve</span>
                <span class="param-value cyan">{{aktivite()!.yanalHatve}} mm</span>
            </div>

            <!-- Kesme Hızı -->
            <div class="param-item" (click)="editValue('kesmeHizi')">
                <span class="param-label">Kesme Hızı</span>
                <span class="param-value cyan">{{kesmeHizi}} m/dk</span>
            </div>
        </div>
        </ng-container>

        <!-- ═══════════════════════════════════════════════════════════════════
             TAB 1: İŞLEME PARAMETRELERİ
             ═══════════════════════════════════════════════════════════════════ -->
        <ng-container *ngIf="aktifTab === 1">
        <div class="tab-content">
            <!-- SVG Görselleştirme: Takım Yolu -->
            <svg viewBox="0 0 280 120" class="tab-svg">
                <defs>
                    <linearGradient id="pathGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#0f8"/><stop offset="50%" stop-color="#0ff"/><stop offset="100%" stop-color="#08f"/>
                    </linearGradient>
                    <filter id="pathGlow"><feGaussianBlur stdDeviation="2" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
                </defs>
                <!-- Parça silüeti -->
                <rect x="60" y="30" width="160" height="60" rx="4" fill="rgba(40,60,80,0.3)" stroke="#345" stroke-width="1"/>
                <!-- Takım yolu animasyonu - Mod'a göre farklı pattern -->
                <path [attr.d]="islemeYoluPath"
                      fill="none" stroke="url(#pathGrad)" stroke-width="2" stroke-linecap="round" filter="url(#pathGlow)"
                      stroke-dasharray="8,4" class="path-anim"/>
                <!-- Yön göstergesi -->
                <text x="140" y="105" text-anchor="middle" fill="#0cf" font-size="9" font-weight="bold">{{aktivite()!.islemeYontemi}}</text>
            </svg>

            <!-- İşleme Yöntemi Butonları -->
            <div class="method-row">
                <button class="method-btn" [class.active]="aktivite()!.islemeYontemi === 'Tek Yön'" (click)="setIslemeYontemi('Tek Yön')">
                    <span class="method-icon">→</span> Tek Yön
                </button>
                <button class="method-btn" [class.active]="aktivite()!.islemeYontemi === 'Zik Zak'" (click)="setIslemeYontemi('Zik Zak')">
                    <span class="method-icon">↔</span> Zik Zak
                </button>
                <button class="method-btn" [class.active]="aktivite()!.islemeYontemi === 'Helisel'" (click)="setIslemeYontemi('Helisel')">
                    <span class="method-icon">◎</span> Helisel
                </button>
            </div>

            <!-- Parametreler Grid -->
            <div class="params-grid-2col">
                <div class="param-card" (click)="editValue('zHatve')">
                    <div class="param-icon">↕</div>
                    <div class="param-info">
                        <span class="param-name">Z Hatve</span>
                        <span class="param-val">{{aktivite()!.zHatve}} mm</span>
                    </div>
                </div>
                <div class="param-card" (click)="editValue('yanalHatve')">
                    <div class="param-icon">↔</div>
                    <div class="param-info">
                        <span class="param-name">Yanal Hatve</span>
                        <span class="param-val">{{aktivite()!.yanalHatve}} mm</span>
                    </div>
                </div>
                <div class="param-card" (click)="editValue('devir')">
                    <div class="param-icon">⟳</div>
                    <div class="param-info">
                        <span class="param-name">Devir</span>
                        <span class="param-val">{{aktivite()!.devir}} rpm</span>
                    </div>
                </div>
                <div class="param-card" (click)="editValue('yanalTekrar')">
                    <div class="param-icon">⟲</div>
                    <div class="param-info">
                        <span class="param-name">Yanal Tekrar</span>
                        <span class="param-val">{{aktivite()!.yanalTekrar}}x</span>
                    </div>
                </div>
            </div>

            <!-- Hız Parametreleri -->
            <div class="section-title">Hız Parametreleri</div>
            <div class="params-grid-3col">
                <div class="param-mini" (click)="editValue('ilerlemeYaklasma')">
                    <span class="mini-label">Yaklaşma</span>
                    <span class="mini-val green">{{aktivite()!.ilerlemeYaklasma}}</span>
                </div>
                <div class="param-mini" (click)="editValue('ilerlemeIsleme')">
                    <span class="mini-label">İşleme</span>
                    <span class="mini-val cyan">{{aktivite()!.ilerlemeIsleme}}</span>
                </div>
                <div class="param-mini" (click)="editValue('ilerlemeUzaklasma')">
                    <span class="mini-label">Uzaklaşma</span>
                    <span class="mini-val orange">{{aktivite()!.ilerlemeUzaklasma}}</span>
                </div>
            </div>

            <!-- Köşe Dönüşleri -->
            <div class="section-title">Köşe Dönüşleri</div>
            <div class="corner-row">
                <button class="corner-btn" [class.active]="aktivite()!.koseDonusler === 'Keskin'" (click)="setKoseDonusler('Keskin')">
                    <svg viewBox="0 0 24 24"><path d="M4,12 L12,12 L12,20" fill="none" stroke="currentColor" stroke-width="2"/></svg>
                    Keskin
                </button>
                <button class="corner-btn" [class.active]="aktivite()!.koseDonusler === 'Dairesel'" (click)="setKoseDonusler('Dairesel')">
                    <svg viewBox="0 0 24 24"><path d="M4,12 Q12,12 12,20" fill="none" stroke="currentColor" stroke-width="2"/></svg>
                    Dairesel
                </button>
                <button class="corner-btn" [class.active]="aktivite()!.koseDonusler === 'Yakinsal'" (click)="setKoseDonusler('Yakinsal')">
                    <svg viewBox="0 0 24 24"><path d="M4,12 C8,12 12,16 12,20" fill="none" stroke="currentColor" stroke-width="2"/></svg>
                    Yakınsal
                </button>
            </div>
        </div>
        </ng-container>

        <!-- ═══════════════════════════════════════════════════════════════════
             TAB 2: TAKIM TANITIMI
             ═══════════════════════════════════════════════════════════════════ -->
        <ng-container *ngIf="aktifTab === 2">
        <div class="tab-content">
            <!-- SVG Takım Görseli -->
            <svg viewBox="0 0 280 150" class="tab-svg tool-svg">
                <defs>
                    <linearGradient id="shaftGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#445"/><stop offset="50%" stop-color="#778"/><stop offset="100%" stop-color="#445"/>
                    </linearGradient>
                    <linearGradient id="cutterGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#668"/><stop offset="50%" stop-color="#aac"/><stop offset="100%" stop-color="#668"/>
                    </linearGradient>
                    <filter id="toolGlow"><feGaussianBlur stdDeviation="1.5" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
                </defs>
                <!-- Takım Şaftı -->
                <rect x="130" y="15" width="20" height="50" rx="2" fill="url(#shaftGrad)" stroke="#556" filter="url(#toolGlow)"/>
                <!-- Kesici Kısım -->
                <rect x="125" y="65" width="30" [attr.height]="30" rx="2" fill="url(#cutterGrad)" stroke="#88a" filter="url(#toolGlow)"/>
                <!-- Kesici Uç -->
                <ellipse cx="140" cy="95" [attr.rx]="aktivite()!.takim?.cap/2 || 5" ry="4" fill="#aac" stroke="#cce"/>
                <!-- Ölçü Çizgileri -->
                <line x1="165" y1="15" x2="165" y2="65" stroke="#0cf" stroke-width="1" stroke-dasharray="3,2"/>
                <text x="175" y="42" fill="#0cf" font-size="8">Boy</text>
                <line x1="165" y1="65" x2="165" y2="95" stroke="#0f8" stroke-width="1" stroke-dasharray="3,2"/>
                <text x="175" y="82" fill="#0f8" font-size="8">Kesme</text>
                <line x1="125" y1="105" x2="155" y2="105" stroke="#f80" stroke-width="1"/>
                <text x="140" y="118" text-anchor="middle" fill="#f80" font-size="8">Çap: {{aktivite()!.takim?.cap || 10}} mm</text>
            </svg>

            <!-- Takım Parametreleri -->
            <div class="params-grid-2col">
                <div class="param-card tool-param" (click)="editValue('takimCap')">
                    <div class="param-icon orange">⌀</div>
                    <div class="param-info">
                        <span class="param-name">Çap</span>
                        <span class="param-val">{{aktivite()!.takim?.cap || 10}} mm</span>
                    </div>
                </div>
                <div class="param-card tool-param" (click)="editValue('takimBoy')">
                    <div class="param-icon cyan">↕</div>
                    <div class="param-info">
                        <span class="param-name">Boy</span>
                        <span class="param-val">{{aktivite()!.takim?.boy || 50}} mm</span>
                    </div>
                </div>
                <div class="param-card tool-param" (click)="editValue('takimKesmeBoy')">
                    <div class="param-icon green">⬍</div>
                    <div class="param-info">
                        <span class="param-name">Kesme Boyu</span>
                        <span class="param-val">{{aktivite()!.takim?.kesmeBoy || 30}} mm</span>
                    </div>
                </div>
                <div class="param-card tool-param" (click)="editValue('takimRadius')">
                    <div class="param-icon purple">◠</div>
                    <div class="param-info">
                        <span class="param-name">Köşe Radius</span>
                        <span class="param-val">{{aktivite()!.takim?.radius || 0}} mm</span>
                    </div>
                </div>
            </div>
        </div>
        </ng-container>

        <!-- ═══════════════════════════════════════════════════════════════════
             TAB 3: GİRİŞ/ÇIKIŞ & GEÇİŞLER - ULTRA KOMPAKT KAPSAMLI
             ═══════════════════════════════════════════════════════════════════ -->
        <ng-container *ngIf="aktifTab === 3">
        <div class="tab-content gecis-tab-v2">

            <!-- ═══ KOMPAKT SVG VİZÜALİZASYON (85px) ═══ -->
            <svg viewBox="0 0 280 85" class="gecis-svg-mini">
                <defs>
                    <linearGradient id="gGrad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stop-color="#0f8"/><stop offset="100%" stop-color="#064"/></linearGradient>
                    <linearGradient id="oGrad" x1="0%" y1="100%" x2="0%" y2="0%"><stop offset="0%" stop-color="#f80"/><stop offset="100%" stop-color="#640"/></linearGradient>
                    <linearGradient id="bGrad" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="transparent"/><stop offset="30%" stop-color="#08f"/><stop offset="70%" stop-color="#08f"/><stop offset="100%" stop-color="transparent"/></linearGradient>
                    <filter id="gG"><feGaussianBlur stdDeviation="2" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
                    <marker id="aG" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto"><path d="M0,0 L6,3 L0,6 Z" fill="#0f8"/></marker>
                    <marker id="aO" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto"><path d="M0,0 L6,3 L0,6 Z" fill="#f80"/></marker>
                </defs>
                <!-- Grid -->
                <pattern id="gP" width="14" height="14" patternUnits="userSpaceOnUse"><path d="M14,0 L0,0 L0,14" fill="none" stroke="rgba(0,150,200,0.06)" stroke-width="0.5"/></pattern>
                <rect width="280" height="85" fill="url(#gP)"/>
                <!-- Güvenli Z -->
                <g class="clickable" (click)="editValue('guvenliZ')">
                    <line x1="15" y1="12" x2="265" y2="12" stroke="url(#bGrad)" stroke-width="1.5" stroke-dasharray="6,3" filter="url(#gG)"/>
                    <text x="140" y="9" text-anchor="middle" fill="#08f" font-size="6" font-weight="bold">Z {{aktivite()!.guvenliZ}}</text>
                </g>
                <!-- Parça -->
                <g transform="translate(140,55)">
                    <ellipse cx="0" cy="18" rx="40" ry="6" fill="rgba(0,0,0,0.25)"/>
                    <path d="M-38,0 L-38,-10 L-22,-18 L22,-18 L38,-10 L38,0 L22,7 L-22,7 Z" fill="#405060" stroke="#567" stroke-width="0.7"/>
                    <path d="M-38,-10 L-22,-18 L22,-18 L38,-10 L0,-3 Z" fill="#506070" stroke="#567" stroke-width="0.5"/>
                    <ellipse cx="0" cy="-6" rx="18" ry="6" fill="rgba(0,200,255,0.12)" stroke="#0cf" stroke-width="0.8" stroke-dasharray="3,2"/>
                </g>
                <!-- Giriş -->
                <g class="clickable" (click)="cycleGirisYontemi()">
                    <path [attr.d]="girisPathMini" fill="none" stroke="url(#gGrad)" stroke-width="2.5" marker-end="url(#aG)" filter="url(#gG)"/>
                    <rect x="8" y="28" width="36" height="14" rx="3" fill="rgba(0,100,60,0.4)" stroke="#0f8" stroke-width="0.8"/>
                    <text x="26" y="38" text-anchor="middle" fill="#0f8" font-size="7" font-weight="bold">{{girisKisaAd}}</text>
                </g>
                <!-- Çıkış -->
                <g class="clickable" (click)="cycleCikisYontemi()">
                    <path [attr.d]="cikisPathMini" fill="none" stroke="url(#oGrad)" stroke-width="2.5" marker-end="url(#aO)" filter="url(#gG)"/>
                    <rect x="236" y="28" width="36" height="14" rx="3" fill="rgba(100,60,0,0.4)" stroke="#f80" stroke-width="0.8"/>
                    <text x="254" y="38" text-anchor="middle" fill="#f80" font-size="7" font-weight="bold">{{cikisKisaAd}}</text>
                </g>
                <!-- Lead indicators -->
                <g class="clickable" (click)="editValue('girisUzunluk')"><text x="18" y="55" fill="#0f8" font-size="5">{{aktivite()!.girisUzunluk}}mm</text></g>
                <g class="clickable" (click)="editValue('cikisUzunluk')"><text x="262" y="55" fill="#f80" font-size="5" text-anchor="end">{{aktivite()!.cikisUzunluk}}mm</text></g>
            </svg>

            <!-- ═══ GİRİŞ SECTION ═══ -->
            <div class="g-section" [class.exp]="girisExpanded">
                <div class="g-header green" (click)="toggleGirisPanel()">
                    <span class="g-title">▼ GİRİŞ</span>
                    <div class="g-chips">
                        <span class="g-chip" [class.act]="aktivite()!.girisYontemi==='Dikey'" (click)="setGirisYontemi('Dikey');$event.stopPropagation()">↓</span>
                        <span class="g-chip" [class.act]="aktivite()!.girisYontemi==='Rampa'" (click)="setGirisYontemi('Rampa');$event.stopPropagation()">╲</span>
                        <span class="g-chip" [class.act]="aktivite()!.girisYontemi==='Helisel'" (click)="setGirisYontemi('Helisel');$event.stopPropagation()">◎</span>
                        <span class="g-chip" [class.act]="aktivite()!.girisYontemi==='Yay'" (click)="setGirisYontemi('Yay');$event.stopPropagation()">⌒</span>
                        <span class="g-chip" [class.act]="aktivite()!.girisYontemi==='Teget'" (click)="setGirisYontemi('Teget');$event.stopPropagation()">→</span>
                    </div>
                </div>
                <div class="g-body" *ngIf="girisExpanded">
                    <div class="g-row">
                        <div class="g-val" (click)="editValue('girisUzunluk')"><span class="g-lbl">Uzun</span><span class="g-num g">{{aktivite()!.girisUzunluk}}</span></div>
                        <div class="g-val" (click)="editValue('girisAcisi')" *ngIf="aktivite()!.girisYontemi==='Rampa'||aktivite()!.girisYontemi==='Teget'"><span class="g-lbl">Açı</span><span class="g-num g">{{girisAcisi}}°</span></div>
                        <div class="g-val" (click)="editValue('girisRadius')" *ngIf="aktivite()!.girisYontemi==='Yay'"><span class="g-lbl">R</span><span class="g-num g">{{girisRadius}}</span></div>
                        <div class="g-val" (click)="editValue('heliselCap')" *ngIf="aktivite()!.girisYontemi==='Helisel'"><span class="g-lbl">Ø</span><span class="g-num g">{{heliselCap}}</span></div>
                        <div class="g-val" (click)="editValue('heliselAdim')" *ngIf="aktivite()!.girisYontemi==='Helisel'"><span class="g-lbl">Adım</span><span class="g-num g">{{heliselAdim}}</span></div>
                    </div>
                    <div class="g-row" *ngIf="aktivite()!.girisYontemi==='Yay'">
                        <div class="g-mini-toggle" (click)="toggleGirisYonu()">
                            <span class="g-lbl">Yön</span>
                            <span class="g-toggle-val" [class.cw]="girisYonuCW">{{girisYonuCW ? 'CW' : 'CCW'}}</span>
                        </div>
                        <div class="g-val" (click)="editValue('girisYayAci')"><span class="g-lbl">Yay°</span><span class="g-num g">{{girisYayAci}}</span></div>
                    </div>
                </div>
            </div>

            <!-- ═══ ÇIKIŞ SECTION ═══ -->
            <div class="g-section" [class.exp]="cikisExpanded">
                <div class="g-header orange" (click)="toggleCikisPanel()">
                    <span class="g-title">▲ ÇIKIŞ</span>
                    <div class="g-chips">
                        <span class="g-chip o" [class.act]="aktivite()!.cikisYontemi==='Dikey'" (click)="setCikisYontemi('Dikey');$event.stopPropagation()">↑</span>
                        <span class="g-chip o" [class.act]="aktivite()!.cikisYontemi==='Rampa'" (click)="setCikisYontemi('Rampa');$event.stopPropagation()">╱</span>
                        <span class="g-chip o" [class.act]="aktivite()!.cikisYontemi==='Yay'" (click)="setCikisYontemi('Yay');$event.stopPropagation()">⌒</span>
                    </div>
                </div>
                <div class="g-body" *ngIf="cikisExpanded">
                    <div class="g-row">
                        <div class="g-val o" (click)="editValue('cikisUzunluk')"><span class="g-lbl">Uzun</span><span class="g-num o">{{aktivite()!.cikisUzunluk}}</span></div>
                        <div class="g-val o" (click)="editValue('cikisAcisi')" *ngIf="aktivite()!.cikisYontemi==='Rampa'"><span class="g-lbl">Açı</span><span class="g-num o">{{cikisAcisi}}°</span></div>
                        <div class="g-val o" (click)="editValue('cikisRadius')" *ngIf="aktivite()!.cikisYontemi==='Yay'"><span class="g-lbl">R</span><span class="g-num o">{{cikisRadius}}</span></div>
                    </div>
                    <div class="g-row" *ngIf="aktivite()!.cikisYontemi==='Yay'">
                        <div class="g-mini-toggle" (click)="toggleCikisYonu()">
                            <span class="g-lbl">Yön</span>
                            <span class="g-toggle-val o" [class.cw]="cikisYonuCW">{{cikisYonuCW ? 'CW' : 'CCW'}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ═══ Z SEVİYELERİ & GEÇİŞ ═══ -->
            <div class="g-section compact">
                <div class="g-header blue"><span class="g-title">⬍ Z & GEÇİŞ</span></div>
                <div class="g-body always">
                    <div class="g-row">
                        <div class="g-val b" (click)="editValue('guvenliZ')"><span class="g-lbl">Güvenli</span><span class="g-num b">{{aktivite()!.guvenliZ}}</span></div>
                        <div class="g-val b" (click)="editValue('araGecisZ')"><span class="g-lbl">Ara Z</span><span class="g-num b">{{araGecisZ}}</span></div>
                        <div class="g-val b" (click)="editValue('yuzeyPayi')"><span class="g-lbl">Yüzey</span><span class="g-num b">{{yuzeyPayi}}</span></div>
                    </div>
                    <div class="g-row">
                        <div class="g-chips-row">
                            <span class="g-chip-lg b" [class.act]="gecisTipi==='Direkt'" (click)="setGecisTipi('Direkt')">Direkt</span>
                            <span class="g-chip-lg b" [class.act]="gecisTipi==='Yumusak'" (click)="setGecisTipi('Yumusak')">Yumuşak</span>
                            <span class="g-chip-lg b" [class.act]="gecisTipi==='Profil'" (click)="setGecisTipi('Profil')">Profil</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ═══ UZATMA & OVERLAP ═══ -->
            <div class="g-section compact">
                <div class="g-header purple"><span class="g-title">↔ UZATMA</span></div>
                <div class="g-body always">
                    <div class="g-row">
                        <div class="g-val p" (click)="editValue('basUzatma')"><span class="g-lbl">Baş</span><span class="g-num p">{{basUzatma}}</span></div>
                        <div class="g-val p" (click)="editValue('sonUzatma')"><span class="g-lbl">Son</span><span class="g-num p">{{sonUzatma}}</span></div>
                        <div class="g-val p" (click)="editValue('overlap')"><span class="g-lbl">Overlap</span><span class="g-num p">{{overlap}}%</span></div>
                        <div class="g-mini-toggle" (click)="toggleOvercut()">
                            <span class="g-lbl">Overcut</span>
                            <span class="g-toggle-mini" [class.on]="overcutEtkin">{{overcutEtkin ? '●' : '○'}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ═══ HIZ PARAMETRELERİ ═══ -->
            <div class="g-section compact">
                <div class="g-header cyan"><span class="g-title">⚡ HIZ</span></div>
                <div class="g-body always">
                    <div class="g-row">
                        <div class="g-val c" (click)="editValue('hizRapid')"><span class="g-lbl">Rapid</span><span class="g-num c">{{hizRapid}}</span></div>
                        <div class="g-val c" (click)="editValue('hizDalma')"><span class="g-lbl">Dalma</span><span class="g-num c">{{hizDalma}}</span></div>
                        <div class="g-val c" (click)="editValue('hizCekme')"><span class="g-lbl">Çekme</span><span class="g-num c">{{hizCekme}}</span></div>
                        <div class="g-val c" (click)="editValue('hizLead')"><span class="g-lbl">Lead</span><span class="g-num c">{{hizLead}}%</span></div>
                    </div>
                </div>
            </div>

            <!-- ═══ FİNİŞ (SON TUR) ═══ -->
            <div class="g-section finish" [class.active]="aktivite()!.sonTurEtkin">
                <div class="g-header" (click)="toggleSonTur()">
                    <span class="g-toggle-sw" [class.on]="aktivite()!.sonTurEtkin">●</span>
                    <span class="g-title">✨ FİNİŞ</span>
                    <span class="g-badge" *ngIf="aktivite()!.sonTurEtkin">ON</span>
                </div>
                <div class="g-body" *ngIf="aktivite()!.sonTurEtkin">
                    <div class="g-row">
                        <div class="g-val f" (click)="editValue('sonTurPayi')"><span class="g-lbl">Pay</span><span class="g-num f">{{aktivite()!.sonTurPayi}}</span></div>
                        <div class="g-val f" (click)="editValue('sonTurIlerleme')"><span class="g-lbl">İlerle</span><span class="g-num f">{{aktivite()!.sonTurIlerleme}}</span></div>
                        <div class="g-val f" (click)="editValue('sonTurDevir')"><span class="g-lbl">Devir</span><span class="g-num f">{{sonTurDevir}}</span></div>
                        <div class="g-mini-toggle" (click)="toggleSonTurAyriGiris()">
                            <span class="g-lbl">AyrıGiriş</span>
                            <span class="g-toggle-mini f" [class.on]="sonTurAyriGiris">{{sonTurAyriGiris ? '●' : '○'}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════
                 PROFESYONEL CAM ÖZELLİKLERİ
                 ═══════════════════════════════════════════════════════════════════ -->

            <!-- ═══ TABS (KÖPRÜ/TUTMA) ═══ -->
            <div class="g-section" [class.active]="tabEtkin">
                <div class="g-header yellow" (click)="toggleTabPanel()">
                    <span class="g-toggle-sw" [class.on]="tabEtkin">●</span>
                    <span class="g-title">◫ TABS (KÖPRÜ)</span>
                    <span class="g-badge" *ngIf="tabEtkin">ON</span>
                </div>
                <div class="g-body" *ngIf="tabEtkin && tabExpanded">
                    <div class="g-row">
                        <div class="g-chips-row">
                            <span class="g-chip-lg y" [class.act]="tabSekli==='Dikdortgen'" (click)="setTabSekli('Dikdortgen')">▬ Dikdörtgen</span>
                            <span class="g-chip-lg y" [class.act]="tabSekli==='Ucgen'" (click)="setTabSekli('Ucgen')">△ Üçgen</span>
                        </div>
                    </div>
                    <div class="g-row">
                        <div class="g-val y" (click)="editValue('tabGenislik')"><span class="g-lbl">Genişlik</span><span class="g-num y">{{tabGenislik}}</span></div>
                        <div class="g-val y" (click)="editValue('tabYukseklik')"><span class="g-lbl">Yükseklik</span><span class="g-num y">{{tabYukseklik}}</span></div>
                    </div>
                    <div class="g-row">
                        <div class="g-chips-row">
                            <span class="g-chip-lg y" [class.act]="tabDagitim==='Sayi'" (click)="setTabDagitim('Sayi')">Sayı</span>
                            <span class="g-chip-lg y" [class.act]="tabDagitim==='Mesafe'" (click)="setTabDagitim('Mesafe')">Mesafe</span>
                        </div>
                    </div>
                    <div class="g-row">
                        <div class="g-val y" *ngIf="tabDagitim==='Sayi'" (click)="editValue('tabSayisi')"><span class="g-lbl">Adet</span><span class="g-num y">{{tabSayisi}}</span></div>
                        <div class="g-val y" *ngIf="tabDagitim==='Mesafe'" (click)="editValue('tabMesafe')"><span class="g-lbl">Mesafe</span><span class="g-num y">{{tabMesafe}}</span></div>
                    </div>
                </div>
            </div>

            <!-- ═══ KÖŞE YAVAŞLAMA ═══ -->
            <div class="g-section" [class.active]="koseYavaslamaEtkin">
                <div class="g-header red" (click)="toggleKosePanel()">
                    <span class="g-toggle-sw" [class.on]="koseYavaslamaEtkin">●</span>
                    <span class="g-title">◿ KÖŞE YAVAŞLAMA</span>
                    <span class="g-badge" *ngIf="koseYavaslamaEtkin">ON</span>
                </div>
                <div class="g-body" *ngIf="koseYavaslamaEtkin && koseExpanded">
                    <div class="g-row">
                        <div class="g-val r" (click)="editValue('koseYavaslamaOrani')"><span class="g-lbl">Oran %</span><span class="g-num r">{{koseYavaslamaOrani}}</span></div>
                        <div class="g-val r" (click)="editValue('koseMinAci')"><span class="g-lbl">Min Açı</span><span class="g-num r">{{koseMinAci}}°</span></div>
                    </div>
                    <div class="g-row">
                        <div class="g-chips-row">
                            <span class="g-chip-lg r" [class.act]="koseYavaslamaTipi==='Tum'" (click)="setKoseYavaslamaTipi('Tum')">Tümü</span>
                            <span class="g-chip-lg r" [class.act]="koseYavaslamaTipi==='Ic'" (click)="setKoseYavaslamaTipi('Ic')">İç</span>
                            <span class="g-chip-lg r" [class.act]="koseYavaslamaTipi==='Dis'" (click)="setKoseYavaslamaTipi('Dis')">Dış</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ═══ FREZE YÖNÜ & KOMPANZASYON ═══ -->
            <div class="g-section compact">
                <div class="g-header magenta"><span class="g-title">⟳ FREZE & KOMP</span></div>
                <div class="g-body always">
                    <div class="g-row">
                        <div class="g-chips-row">
                            <span class="g-chip-lg m" [class.act]="frezeYonu==='Tirmanma'" (click)="setFrezeYonu('Tirmanma')">↻ Climb</span>
                            <span class="g-chip-lg m" [class.act]="frezeYonu==='Konvansiyonel'" (click)="setFrezeYonu('Konvansiyonel')">↺ Konv.</span>
                        </div>
                    </div>
                    <div class="g-row">
                        <div class="g-chips-row">
                            <span class="g-chip-lg m" [class.act]="kompanzasyonTipi==='Bilgisayar'" (click)="setKompanzasyonTipi('Bilgisayar')">PC</span>
                            <span class="g-chip-lg m" [class.act]="kompanzasyonTipi==='Kontrol'" (click)="setKompanzasyonTipi('Kontrol')">CNC</span>
                            <span class="g-chip-lg m" [class.act]="kompanzasyonTipi==='Kapali'" (click)="setKompanzasyonTipi('Kapali')">Kapalı</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ═══ STAY-DOWN / LIFT ═══ -->
            <div class="g-section" [class.active]="stayDownEtkin">
                <div class="g-header teal" (click)="toggleStayDownPanel()">
                    <span class="g-toggle-sw" [class.on]="stayDownEtkin">●</span>
                    <span class="g-title">⤵ STAY-DOWN</span>
                    <span class="g-badge" *ngIf="stayDownEtkin">ON</span>
                </div>
                <div class="g-body" *ngIf="stayDownEtkin && stayDownExpanded">
                    <div class="g-row">
                        <div class="g-val t" (click)="editValue('stayDownMesafe')"><span class="g-lbl">Max Mesafe</span><span class="g-num t">{{stayDownMesafe}}</span></div>
                        <div class="g-val t" (click)="editValue('kaldirmaMesafesi')"><span class="g-lbl">Lift Z</span><span class="g-num t">{{kaldirmaMesafesi}}</span></div>
                    </div>
                </div>
            </div>

            <!-- ═══ YOL YUMUŞATMA ═══ -->
            <div class="g-section" [class.active]="yumusatmaEtkin">
                <div class="g-header lime" (click)="toggleYumusatmaPanel()">
                    <span class="g-toggle-sw" [class.on]="yumusatmaEtkin">●</span>
                    <span class="g-title">〰 YUMUŞATMA</span>
                    <span class="g-badge" *ngIf="yumusatmaEtkin">ON</span>
                </div>
                <div class="g-body" *ngIf="yumusatmaEtkin && yumusatmaExpanded">
                    <div class="g-row">
                        <div class="g-val l" (click)="editValue('yumusatmaRadius')"><span class="g-lbl">Radius</span><span class="g-num l">{{yumusatmaRadius}}</span></div>
                        <div class="g-val l" (click)="editValue('yumusatmaTolerans')"><span class="g-lbl">Tolerans</span><span class="g-num l">{{yumusatmaTolerans}}</span></div>
                    </div>
                </div>
            </div>

        </div>
        </ng-container>

        <!-- INPUT DIALOG (overlay) -->
        <div class="input-overlay" *ngIf="editingField" (click)="cancelEdit()">
            <div class="input-dialog" (click)="$event.stopPropagation()">
                <div class="input-title">{{editingLabel}}</div>
                <input type="number" #editInput
                       [value]="editingValue"
                       (keydown.enter)="saveEdit(editInput.value)"
                       (keydown.escape)="cancelEdit()"
                       step="0.1"
                       autofocus>
                <div class="input-btns">
                    <button class="ok" (click)="saveEdit(editInput.value)">Tamam</button>
                    <button (click)="cancelEdit()">İptal</button>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div *ngIf="aktivite()?.ofsetHesapHatasi" style="font-size:10px; color:#ffb86b; padding:4px 10px;">⚠ {{aktivite()!.ofsetHesapHatasi}}</div>
        <div class="d-footer">
            <button class="btn ok" (click)="kaydet()">Tamam</button>
            <button class="btn" (click)="hesapla()">Önizle</button>
            <button class="btn" (click)="kapa()">İptal</button>
        </div>
    </div>
    `,
    styles: [`
        /* ═══════════════════════════════════════════════════════════════════
           ULTIMATE CYBERPUNK THEME - v20.0.0
           ═══════════════════════════════════════════════════════════════════ */

        .cam-dialog {
            background: linear-gradient(135deg, rgba(8,16,24,0.97) 0%, rgba(4,8,16,0.98) 100%);
            border: none;
            border-radius: 10px;
            width: 260px;
            font: 9px/1.35 'Segoe UI', system-ui, sans-serif;
            color: #d0e8f0;
            box-shadow:
                0 0 0 1px rgba(0,200,255,0.15),
                0 4px 24px rgba(0,0,0,0.6),
                0 0 60px rgba(0,150,200,0.08),
                inset 0 1px 0 rgba(255,255,255,0.05);
            position: relative;
            overflow: hidden;
        }

        /* Neon Border Animasyonu */
        .neon-border {
            position: absolute;
            inset: 0;
            border-radius: 12px;
            padding: 1px;
            background: linear-gradient(135deg, #0ff, #08f, #0ff, #f08, #0ff);
            background-size: 400% 400%;
            animation: borderGlow 8s ease infinite;
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            pointer-events: none;
            opacity: 0.6;
        }
        @keyframes borderGlow {
            0%, 100% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
        }

        /* ═══════════════════════════════════════════════════════════════════
           TAB HEADER
           ═══════════════════════════════════════════════════════════════════ */
        .tab-header {
            display: flex;
            gap: 3px;
            padding: 4px 6px;
            background: rgba(0,20,30,0.6);
            border-bottom: 1px solid rgba(0,150,200,0.2);
        }
        .tab-btn {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
            padding: 4px 3px;
            background: rgba(0,40,60,0.3);
            border: 1px solid rgba(0,100,150,0.2);
            border-radius: 6px;
            color: #567;
            font-size: 8px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
        }
        .tab-btn:hover {
            background: rgba(0,60,80,0.4);
            border-color: rgba(0,150,200,0.4);
            color: #8ac;
        }
        .tab-btn.active {
            background: linear-gradient(135deg, rgba(0,100,140,0.4) 0%, rgba(0,60,100,0.4) 100%);
            border-color: #0cf;
            color: #0ff;
            box-shadow: 0 0 12px rgba(0,200,255,0.25), inset 0 1px 0 rgba(255,255,255,0.1);
        }
        .tab-btn .tab-icon {
            width: 14px;
            height: 14px;
        }

        /* ═══════════════════════════════════════════════════════════════════
           TAB CONTENT
           ═══════════════════════════════════════════════════════════════════ */
        .tab-content {
            padding: 5px;
        }
        .tab-svg {
            width: 100%;
            height: auto;
            margin-bottom: 5px;
            background: rgba(0,20,30,0.3);
            border-radius: 6px;
        }
        .path-anim {
            animation: dashMove 2s linear infinite;
        }
        @keyframes dashMove {
            to { stroke-dashoffset: -24; }
        }

        /* Method Buttons */
        .method-row {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;
        }
        .method-btn {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            padding: 6px 4px;
            background: rgba(0,40,60,0.4);
            border: 1px solid rgba(0,100,150,0.3);
            border-radius: 5px;
            color: #689;
            font-size: 8px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s;
        }
        .method-btn:hover {
            background: rgba(0,60,80,0.5);
            border-color: rgba(0,150,200,0.5);
        }
        .method-btn.active {
            background: linear-gradient(135deg, rgba(0,150,200,0.3) 0%, rgba(0,100,150,0.3) 100%);
            border-color: #0cf;
            color: #0ff;
            box-shadow: 0 0 10px rgba(0,200,255,0.2);
        }
        .method-btn.small {
            padding: 5px 3px;
            font-size: 7px;
        }
        .method-icon {
            font-size: 10px;
        }

        /* Section Titles */
        .section-title {
            font-size: 8px;
            font-weight: 700;
            color: #0cf;
            margin: 8px 0 4px 0;
            padding-left: 4px;
            border-left: 2px solid #0cf;
        }
        .section-title.green { color: #0f8; border-color: #0f8; }
        .section-title.orange { color: #f80; border-color: #f80; }

        /* Params Grid Variants */
        .params-grid-2col {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 6px;
            margin-bottom: 6px;
        }
        .params-grid-3col {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 4px;
            margin-bottom: 6px;
        }

        /* Param Card */
        .param-card {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 6px;
            background: rgba(0,40,60,0.3);
            border: 1px solid rgba(0,100,150,0.25);
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .param-card:hover {
            background: rgba(0,60,80,0.4);
            border-color: rgba(0,200,255,0.4);
            transform: translateY(-1px);
        }
        .param-card.disabled {
            opacity: 0.5;
        }
        .param-icon {
            font-size: 12px;
            color: #0cf;
            min-width: 16px;
            text-align: center;
        }
        .param-icon.orange { color: #f80; }
        .param-icon.green { color: #0f8; }
        .param-icon.cyan { color: #0cf; }
        .param-icon.blue { color: #08f; }
        .param-icon.purple { color: #a6f; }
        .param-icon.active { color: #0f8; }
        .param-info {
            display: flex;
            flex-direction: column;
            gap: 1px;
        }
        .param-name {
            font-size: 7px;
            color: #689;
        }
        .param-val {
            font-size: 10px;
            font-weight: 700;
            color: #0ff;
        }

        /* Mini Param */
        .param-mini {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 5px;
            background: rgba(0,40,60,0.3);
            border: 1px solid rgba(0,100,150,0.2);
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .param-mini:hover {
            background: rgba(0,60,80,0.4);
            border-color: rgba(0,200,255,0.4);
        }
        .mini-label {
            font-size: 6px;
            color: #567;
        }
        .mini-val {
            font-size: 10px;
            font-weight: 700;
            color: #0cf;
        }
        .mini-val.green { color: #0f8; }
        .mini-val.cyan { color: #0cf; }
        .mini-val.orange { color: #f80; }

        /* Corner Buttons */
        .corner-row {
            display: flex;
            gap: 4px;
        }
        .corner-btn {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 3px;
            padding: 6px 4px;
            background: rgba(0,40,60,0.3);
            border: 1px solid rgba(0,100,150,0.25);
            border-radius: 5px;
            color: #689;
            font-size: 7px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .corner-btn svg {
            width: 20px;
            height: 20px;
        }
        .corner-btn:hover {
            background: rgba(0,60,80,0.4);
            border-color: rgba(0,150,200,0.4);
        }
        .corner-btn.active {
            background: rgba(0,100,150,0.3);
            border-color: #0cf;
            color: #0ff;
        }

        /* Inline Param */
        .inline-param {
            padding: 6px 8px;
            background: rgba(0,30,50,0.4);
            border-radius: 4px;
            font-size: 8px;
            color: #689;
            cursor: pointer;
            margin-bottom: 6px;
            transition: all 0.3s;
        }
        .inline-param:hover {
            background: rgba(0,50,70,0.5);
        }
        .inline-param .val {
            font-weight: 700;
            color: #0cf;
        }
        .inline-param .val.green { color: #0f8; }
        .inline-param .val.orange { color: #f80; }

        /* Tool Param specific */
        .tool-param .param-icon {
            font-size: 14px;
        }

        /* ═══════════════════════════════════════════════════════════════════
           GEÇİŞ TAB - ULTRA DİNAMİK STİLLER
           ═══════════════════════════════════════════════════════════════════ */
        .gecis-tab { padding: 6px !important; }

        .gecis-svg {
            width: 100%;
            height: auto;
            background: rgba(0,15,25,0.6);
            border-radius: 8px;
            border: 1px solid rgba(0,150,200,0.15);
            margin-bottom: 8px;
        }
        .gecis-svg .clickable { cursor: pointer; }
        .gecis-svg .clickable:hover { opacity: 0.8; }
        .gecis-svg .z-label { transition: all 0.3s; }
        .gecis-svg .guvenli-z-zone:hover .z-label { fill: #0cf; }
        .gecis-svg .path-line { transition: all 0.3s; }
        .gecis-svg .giris-path:hover .path-line { stroke-width: 4; }
        .gecis-svg .cikis-path:hover .path-line { stroke-width: 4; }

        /* Tool Animation */
        .tool-anim-giris {
            animation: toolMoveGiris 3s ease-in-out infinite;
        }
        .tool-anim-cikis {
            animation: toolMoveCikis 3s ease-in-out infinite;
            animation-delay: 1.5s;
        }
        @keyframes toolMoveGiris {
            0%, 100% { transform: translateY(-20px); opacity: 0.3; }
            50% { transform: translateY(30px); opacity: 1; }
        }
        @keyframes toolMoveCikis {
            0%, 100% { transform: translateY(30px); opacity: 1; }
            50% { transform: translateY(-20px); opacity: 0.3; }
        }

        /* Geçiş Panel */
        .gecis-panel {
            background: rgba(0,30,50,0.4);
            border: 1px solid rgba(0,150,200,0.2);
            border-radius: 8px;
            margin-bottom: 6px;
            overflow: hidden;
            transition: all 0.3s ease;
        }
        .gecis-panel:hover {
            border-color: rgba(0,200,255,0.3);
        }
        .gecis-panel.giris-panel { border-left: 3px solid #0f8; }
        .gecis-panel.cikis-panel { border-left: 3px solid #f80; }
        .gecis-panel.rapid-panel { border-left: 3px solid #08f; }
        .gecis-panel.finish-panel { border-left: 3px solid #a6f; }
        .gecis-panel.finish-panel.active { border-left-color: #0f8; background: rgba(0,50,40,0.3); }

        .panel-header {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 5px 8px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .panel-header:hover { background: rgba(0,60,80,0.3); }
        .panel-header.blue { color: #08f; }
        .panel-header .panel-icon {
            width: 16px; height: 16px;
            color: #0cf;
        }
        .giris-panel .panel-header .panel-icon { color: #0f8; }
        .cikis-panel .panel-header .panel-icon { color: #f80; }
        .panel-header span {
            font-size: 9px;
            font-weight: 600;
            color: #9bc;
        }
        .panel-header .panel-value {
            margin-left: auto;
            font-size: 8px;
            color: #0cf;
            background: rgba(0,150,200,0.15);
            padding: 2px 6px;
            border-radius: 3px;
        }
        .giris-panel .panel-value { color: #0f8; background: rgba(0,200,100,0.15); }
        .cikis-panel .panel-value { color: #f80; background: rgba(200,100,0,0.15); }

        .expand-icon {
            width: 12px; height: 12px;
            color: #567;
            transition: transform 0.3s;
        }
        .expand-icon.expanded { transform: rotate(180deg); }

        .panel-content {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease, padding 0.3s ease;
            padding: 0 10px;
        }
        .panel-content.expanded {
            max-height: 200px;
            padding: 8px 10px;
        }

        /* Method Cards */
        .method-cards {
            display: flex;
            gap: 6px;
            margin-bottom: 8px;
        }
        .method-card {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
            padding: 8px 4px;
            background: rgba(0,50,70,0.3);
            border: 1px solid rgba(0,150,200,0.2);
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.3s;
            color: #689;
        }
        .method-card svg {
            width: 28px;
            height: 28px;
        }
        .method-card span {
            font-size: 7px;
            font-weight: 600;
        }
        .method-card:hover {
            background: rgba(0,80,100,0.4);
            border-color: rgba(0,200,255,0.4);
            transform: translateY(-2px);
        }
        .method-card.active {
            background: linear-gradient(135deg, rgba(0,150,200,0.3) 0%, rgba(0,100,150,0.3) 100%);
            border-color: #0f8;
            color: #0f8;
            box-shadow: 0 0 15px rgba(0,255,136,0.2);
        }
        .method-card.orange.active {
            border-color: #f80;
            color: #f80;
            box-shadow: 0 0 15px rgba(255,136,0,0.2);
        }

        /* Param Slider */
        .param-row { margin-bottom: 6px; }
        .param-slider {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 6px 8px;
            background: rgba(0,40,60,0.3);
            border-radius: 5px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .param-slider:hover { background: rgba(0,60,80,0.4); }
        .param-slider.orange .slider-value { color: #f80; }
        .slider-label {
            font-size: 7px;
            color: #689;
            min-width: 45px;
        }
        .slider-track {
            flex: 1;
            height: 6px;
            background: rgba(0,60,80,0.5);
            border-radius: 3px;
            overflow: hidden;
        }
        .slider-fill {
            height: 100%;
            background: linear-gradient(90deg, #0f8, #0cf);
            border-radius: 3px;
            transition: width 0.3s;
        }
        .slider-track.orange .slider-fill { background: linear-gradient(90deg, #f80, #fa4); }
        .slider-track.purple .slider-fill { background: linear-gradient(90deg, #a6f, #c8f); }
        .slider-value {
            font-size: 9px;
            font-weight: 700;
            color: #0f8;
            min-width: 40px;
            text-align: right;
        }

        /* Rapid Grid */
        .rapid-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 6px;
            padding: 8px;
        }
        .rapid-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
            padding: 8px;
            background: rgba(0,50,80,0.3);
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .rapid-item:hover {
            background: rgba(0,70,100,0.4);
            transform: translateY(-1px);
        }
        .rapid-icon {
            font-size: 14px;
            color: #08f;
        }
        .rapid-info {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
        }
        .rapid-label { font-size: 7px; color: #689; }
        .rapid-value { font-size: 10px; font-weight: 700; color: #08f; }
        .rapid-bar {
            height: 4px;
            background: rgba(0,60,100,0.4);
            border-radius: 2px;
            overflow: hidden;
        }
        .rapid-bar.cyan .rapid-fill { background: #0cf; }
        .rapid-fill {
            height: 100%;
            background: #08f;
            border-radius: 2px;
            transition: width 0.3s;
        }

        /* Toggle Switch */
        .toggle-switch {
            width: 28px;
            height: 14px;
            background: rgba(60,60,80,0.5);
            border-radius: 7px;
            position: relative;
            cursor: pointer;
            transition: all 0.3s;
        }
        .toggle-switch.on {
            background: rgba(0,200,100,0.4);
        }
        .toggle-knob {
            position: absolute;
            top: 2px;
            left: 2px;
            width: 10px;
            height: 10px;
            background: #567;
            border-radius: 50%;
            transition: all 0.3s;
        }
        .toggle-switch.on .toggle-knob {
            left: 16px;
            background: #0f8;
            box-shadow: 0 0 8px #0f8;
        }

        /* Panel Badge */
        .panel-badge {
            font-size: 6px !important;
            font-weight: 700 !important;
            color: #0f8 !important;
            background: rgba(0,200,100,0.2) !important;
            padding: 2px 5px !important;
            border-radius: 3px;
            animation: badgePulse 2s ease infinite;
        }
        @keyframes badgePulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.6; }
        }

        /* Finish Grid */
        .finish-content.expanded { max-height: 100px; }
        .finish-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8px;
        }
        .finish-item {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 8px;
            background: rgba(0,60,50,0.3);
            border: 1px solid rgba(0,200,100,0.2);
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .finish-item:hover {
            background: rgba(0,80,60,0.4);
            border-color: rgba(0,255,136,0.4);
        }
        .finish-icon {
            width: 20px;
            height: 20px;
            color: #0f8;
        }
        .finish-info {
            display: flex;
            flex-direction: column;
        }
        .finish-label { font-size: 6px; color: #689; }
        .finish-value { font-size: 10px; font-weight: 700; color: #0f8; }

        /* ═══════════════════════════════════════════════════════════════════
           GEÇİŞ TAB v2 - ULTRA KOMPAKT STİLLER
           ═══════════════════════════════════════════════════════════════════ */
        .gecis-tab-v2 { padding: 4px !important; }
        .gecis-svg-mini {
            width: 100%; height: 85px;
            background: rgba(0,12,20,0.7);
            border-radius: 6px;
            border: 1px solid rgba(0,150,200,0.12);
            margin-bottom: 4px;
        }
        .gecis-svg-mini .clickable { cursor: pointer; }
        .gecis-svg-mini .clickable:hover { opacity: 0.8; }

        /* Section container */
        .g-section {
            background: rgba(0,25,40,0.35);
            border: 1px solid rgba(0,100,140,0.18);
            border-radius: 5px;
            margin-bottom: 3px;
            overflow: hidden;
            transition: all 0.25s;
        }
        .g-section:hover { border-color: rgba(0,150,200,0.3); }
        .g-section.exp { background: rgba(0,35,55,0.4); }
        .g-section.compact { background: rgba(0,20,35,0.4); }
        .g-section.finish { border-left: 2px solid #555; }
        .g-section.finish.active { border-left-color: #0f8; background: rgba(0,40,35,0.4); }

        /* Section Header */
        .g-header {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 5px 8px;
            cursor: pointer;
            transition: all 0.2s;
        }
        .g-header:hover { background: rgba(0,60,80,0.25); }
        .g-header.green { border-bottom: 1px solid rgba(0,200,100,0.15); }
        .g-header.orange { border-bottom: 1px solid rgba(255,136,0,0.15); }
        .g-header.blue { border-bottom: 1px solid rgba(0,136,255,0.15); }
        .g-header.purple { border-bottom: 1px solid rgba(166,102,255,0.15); }
        .g-header.cyan { border-bottom: 1px solid rgba(0,204,255,0.15); }
        .g-title {
            font-size: 8px;
            font-weight: 700;
            color: #8ab;
        }
        .g-header.green .g-title { color: #0f8; }
        .g-header.orange .g-title { color: #f80; }
        .g-header.blue .g-title { color: #08f; }
        .g-header.purple .g-title { color: #a6f; }
        .g-header.cyan .g-title { color: #0cf; }

        /* Chips */
        .g-chips {
            display: flex;
            gap: 3px;
            margin-left: auto;
        }
        .g-chip {
            width: 18px; height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0,60,80,0.4);
            border: 1px solid rgba(0,150,100,0.25);
            border-radius: 3px;
            color: #567;
            font-size: 9px;
            cursor: pointer;
            transition: all 0.2s;
        }
        .g-chip:hover { background: rgba(0,80,100,0.5); color: #8ac; }
        .g-chip.act {
            background: rgba(0,120,80,0.4);
            border-color: #0f8;
            color: #0f8;
            box-shadow: 0 0 8px rgba(0,255,136,0.25);
        }
        .g-chip.o { border-color: rgba(200,100,0,0.25); }
        .g-chip.o:hover { color: #fa8; }
        .g-chip.o.act {
            background: rgba(120,60,0,0.4);
            border-color: #f80;
            color: #f80;
            box-shadow: 0 0 8px rgba(255,136,0,0.25);
        }
        .g-chips-row {
            display: flex;
            gap: 4px;
            flex: 1;
        }
        .g-chip-lg {
            flex: 1;
            padding: 4px 6px;
            background: rgba(0,50,70,0.4);
            border: 1px solid rgba(0,100,150,0.25);
            border-radius: 4px;
            color: #689;
            font-size: 7px;
            font-weight: 600;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s;
        }
        .g-chip-lg:hover { background: rgba(0,70,90,0.5); }
        .g-chip-lg.b { border-color: rgba(0,136,255,0.25); }
        .g-chip-lg.b:hover { color: #4af; }
        .g-chip-lg.act {
            background: rgba(0,80,120,0.4);
            border-color: #08f;
            color: #08f;
            box-shadow: 0 0 8px rgba(0,136,255,0.25);
        }

        /* Section Body */
        .g-body {
            padding: 6px 8px;
            background: rgba(0,15,25,0.3);
        }
        .g-body.always { padding: 5px 8px; }

        /* Row & Values */
        .g-row {
            display: flex;
            gap: 5px;
            margin-bottom: 4px;
        }
        .g-row:last-child { margin-bottom: 0; }
        .g-val {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1px;
            padding: 4px 6px;
            background: rgba(0,40,60,0.4);
            border: 1px solid rgba(0,100,150,0.2);
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.2s;
        }
        .g-val:hover {
            background: rgba(0,60,80,0.5);
            border-color: rgba(0,200,255,0.4);
            transform: translateY(-1px);
        }
        .g-lbl {
            font-size: 5px;
            color: #567;
            text-transform: uppercase;
        }
        .g-num {
            font-size: 10px;
            font-weight: 700;
            color: #0cf;
        }
        /* Color variants */
        .g-num.g, .g-val.g .g-num { color: #0f8; }
        .g-num.o, .g-val.o .g-num { color: #f80; }
        .g-num.b, .g-val.b .g-num { color: #08f; }
        .g-num.p, .g-val.p .g-num { color: #a6f; }
        .g-num.c, .g-val.c .g-num { color: #0cf; }
        .g-num.f, .g-val.f .g-num { color: #0f8; }
        /* Yeni Profesyonel CAM renkleri */
        .g-num.y, .g-val.y .g-num { color: #fd0; } /* Yellow - Tabs */
        .g-num.r, .g-val.r .g-num { color: #f44; } /* Red - Köşe Yavaşlama */
        .g-num.m, .g-val.m .g-num { color: #f4f; } /* Magenta - Freze/Komp */
        .g-num.t, .g-val.t .g-num { color: #4fd; } /* Teal - Stay-Down */
        .g-num.l, .g-val.l .g-num { color: #8f4; } /* Lime - Yumuşatma */
        .g-val.g { border-color: rgba(0,200,100,0.2); }
        .g-val.o { border-color: rgba(200,100,0,0.2); }
        .g-val.b { border-color: rgba(0,136,255,0.2); }
        .g-val.p { border-color: rgba(166,102,255,0.2); }
        .g-val.c { border-color: rgba(0,204,255,0.2); }
        .g-val.f { border-color: rgba(0,200,100,0.2); }
        /* Yeni Profesyonel CAM border renkleri */
        .g-val.y { border-color: rgba(255,221,0,0.25); }
        .g-val.r { border-color: rgba(255,68,68,0.25); }
        .g-val.m { border-color: rgba(255,68,255,0.25); }
        .g-val.t { border-color: rgba(68,255,221,0.25); }
        .g-val.l { border-color: rgba(136,255,68,0.25); }
        /* Header renkleri - Yeni */
        .g-header.yellow { border-bottom: 1px solid rgba(255,221,0,0.2); }
        .g-header.yellow .g-title { color: #fd0; }
        .g-header.red { border-bottom: 1px solid rgba(255,68,68,0.2); }
        .g-header.red .g-title { color: #f44; }
        .g-header.magenta { border-bottom: 1px solid rgba(255,68,255,0.2); }
        .g-header.magenta .g-title { color: #f4f; }
        .g-header.teal { border-bottom: 1px solid rgba(68,255,221,0.2); }
        .g-header.teal .g-title { color: #4fd; }
        .g-header.lime { border-bottom: 1px solid rgba(136,255,68,0.2); }
        .g-header.lime .g-title { color: #8f4; }
        /* Chip renkleri - Yeni */
        .g-chip-lg.y { border-color: rgba(255,221,0,0.3); color: #aa8; }
        .g-chip-lg.y:hover { color: #fd0; }
        .g-chip-lg.y.act { background: rgba(180,150,0,0.3); border-color: #fd0; color: #fd0; box-shadow: 0 0 8px rgba(255,221,0,0.3); }
        .g-chip-lg.r { border-color: rgba(255,68,68,0.3); color: #a88; }
        .g-chip-lg.r:hover { color: #f66; }
        .g-chip-lg.r.act { background: rgba(180,40,40,0.3); border-color: #f44; color: #f44; box-shadow: 0 0 8px rgba(255,68,68,0.3); }
        .g-chip-lg.m { border-color: rgba(255,68,255,0.3); color: #a8a; }
        .g-chip-lg.m:hover { color: #f6f; }
        .g-chip-lg.m.act { background: rgba(150,40,150,0.3); border-color: #f4f; color: #f4f; box-shadow: 0 0 8px rgba(255,68,255,0.3); }
        .g-chip-lg.t { border-color: rgba(68,255,221,0.3); color: #8aa; }
        .g-chip-lg.t:hover { color: #6fd; }
        .g-chip-lg.t.act { background: rgba(40,150,140,0.3); border-color: #4fd; color: #4fd; box-shadow: 0 0 8px rgba(68,255,221,0.3); }
        .g-chip-lg.l { border-color: rgba(136,255,68,0.3); color: #8a8; }
        .g-chip-lg.l:hover { color: #af6; }
        .g-chip-lg.l.act { background: rgba(80,150,40,0.3); border-color: #8f4; color: #8f4; box-shadow: 0 0 8px rgba(136,255,68,0.3); }

        /* Mini Toggle */
        .g-mini-toggle {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1px;
            padding: 4px 8px;
            background: rgba(0,40,60,0.4);
            border: 1px solid rgba(0,100,150,0.2);
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.2s;
        }
        .g-mini-toggle:hover { background: rgba(0,60,80,0.5); }
        .g-toggle-val {
            font-size: 9px;
            font-weight: 700;
            color: #0f8;
        }
        .g-toggle-val.cw { color: #0cf; }
        .g-toggle-val.o { color: #f80; }
        .g-toggle-val.o.cw { color: #fa4; }
        .g-toggle-sw {
            font-size: 10px;
            color: #555;
            transition: all 0.2s;
        }
        .g-toggle-sw.on {
            color: #0f8;
            text-shadow: 0 0 6px rgba(0,255,136,0.6);
        }
        .g-toggle-mini {
            font-size: 9px;
            font-weight: 700;
            color: #555;
            transition: all 0.2s;
        }
        .g-toggle-mini.on {
            color: #0f8;
            text-shadow: 0 0 4px rgba(0,255,136,0.4);
        }
        .g-toggle-mini.f { color: #555; }
        .g-toggle-mini.f.on { color: #0f8; }

        /* Badge */
        .g-badge {
            font-size: 6px;
            font-weight: 700;
            color: #0f8;
            background: rgba(0,200,100,0.2);
            padding: 2px 5px;
            border-radius: 3px;
            margin-left: auto;
            animation: badgePulse 2s ease infinite;
        }

        /* ═══════════════════════════════════════════════════════════════════
           HEADER
           ═══════════════════════════════════════════════════════════════════ */
        .d-header {
            display: flex; align-items: center; justify-content: space-between;
            padding: 6px 8px;
            background: linear-gradient(180deg, rgba(0,80,100,0.2) 0%, rgba(0,40,60,0.1) 100%);
            border-bottom: 1px solid rgba(0,200,255,0.15);
            position: relative;
        }
        .header-glow {
            position: absolute;
            top: 0; left: 50%;
            transform: translateX(-50%);
            width: 60%;
            height: 2px;
            background: linear-gradient(90deg, transparent, #0ff, transparent);
            filter: blur(1px);
        }
        .title-wrap {
            display: flex; align-items: center; gap: 8px;
        }
        .title-icon {
            width: 14px; height: 14px;
            animation: iconPulse 2s ease-in-out infinite;
        }
        @keyframes iconPulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.1); opacity: 0.8; }
        }
        .title {
            font-size: 11px;
            font-weight: 700;
            background: linear-gradient(90deg, #0ff, #4df);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-shadow: 0 0 20px rgba(0,255,255,0.3);
        }

        /* Toggle Switch */
        .mode-toggle {
            display: flex; align-items: center; gap: 6px;
            cursor: pointer;
            padding: 4px 8px;
            background: rgba(0,30,50,0.6);
            border-radius: 20px;
            border: 1px solid rgba(0,200,255,0.2);
            transition: all 0.3s ease;
        }
        .mode-toggle:hover {
            border-color: rgba(0,200,255,0.4);
            box-shadow: 0 0 15px rgba(0,200,255,0.15);
        }
        .mode-label {
            font-size: 9px;
            font-weight: 600;
            color: #567;
            transition: all 0.3s ease;
        }
        .mode-label.active {
            color: #0ff;
            text-shadow: 0 0 8px rgba(0,255,255,0.5);
        }
        .toggle-track {
            width: 28px; height: 14px;
            background: rgba(0,50,80,0.6);
            border-radius: 7px;
            position: relative;
            border: 1px solid rgba(0,200,255,0.3);
        }
        .toggle-thumb {
            position: absolute;
            top: 2px; left: 2px;
            width: 10px; height: 10px;
            background: linear-gradient(135deg, #0ff, #08f);
            border-radius: 50%;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 0 8px rgba(0,255,255,0.6);
        }
        .toggle-thumb.right {
            left: 16px;
        }

        /* ═══════════════════════════════════════════════════════════════════
           İŞLEME TÜRÜ BUTONLARI
           ═══════════════════════════════════════════════════════════════════ */
        .type-section {
            padding: 5px;
            background: rgba(0,40,60,0.15);
        }
        .type-buttons {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 4px;
        }
        .type-btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 3px;
            padding: 5px 3px;
            background: rgba(0,40,60,0.4);
            border: 1px solid rgba(0,100,150,0.3);
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.25s ease;
            position: relative;
            overflow: hidden;
        }
        .type-btn::before {
            content: '';
            position: absolute;
            inset: 0;
            background: radial-gradient(circle at 50% 0%, rgba(0,200,255,0.15), transparent 70%);
            opacity: 0;
            transition: opacity 0.3s ease;
        }
        .type-btn:hover::before { opacity: 1; }
        .type-btn:hover {
            transform: translateY(-2px);
            border-color: rgba(0,200,255,0.5);
            box-shadow: 0 4px 20px rgba(0,150,200,0.2);
        }
        .type-btn.active {
            background: rgba(0,120,160,0.3);
            border-color: #0cf;
            box-shadow:
                0 0 20px rgba(0,200,255,0.3),
                inset 0 0 20px rgba(0,200,255,0.1);
        }
        .type-btn.active::after {
            content: '';
            position: absolute;
            bottom: 0; left: 10%; right: 10%;
            height: 2px;
            background: linear-gradient(90deg, transparent, #0ff, transparent);
            filter: blur(1px);
        }
        .type-icon-wrap {
            width: 24px; height: 24px;
            display: flex; align-items: center; justify-content: center;
        }
        .type-icon {
            width: 20px; height: 20px;
            transition: transform 0.3s ease;
        }
        .type-btn:hover .type-icon { transform: scale(1.1); }
        .type-btn.active .type-icon { filter: drop-shadow(0 0 4px rgba(0,255,255,0.5)); }
        .type-label {
            font-size: 9px;
            font-weight: 600;
            color: #8ab;
            transition: color 0.3s ease;
        }
        .type-btn.active .type-label {
            color: #0ff;
            text-shadow: 0 0 8px rgba(0,255,255,0.4);
        }
        .type-glow {
            position: absolute;
            inset: 0;
            opacity: 0;
            background: radial-gradient(circle at center, rgba(0,255,255,0.2), transparent 70%);
            transition: opacity 0.3s ease;
        }
        .type-btn.active .type-glow { opacity: 1; animation: glowPulse 2s ease-in-out infinite; }
        @keyframes glowPulse {
            0%, 100% { opacity: 0.5; }
            50% { opacity: 1; }
        }

        /* ═══════════════════════════════════════════════════════════════════
           MAIN SVG - İNTERAKTİF SEÇİMLER
           ═══════════════════════════════════════════════════════════════════ */
        .main-svg {
            display: block; width: 100%; height: 170px;
            background: linear-gradient(180deg, #030508 0%, #050810 100%);
            border-top: 1px solid rgba(0,100,150,0.2);
            border-bottom: 1px solid rgba(0,100,150,0.2);
        }
        .clickable { cursor: pointer; transition: all 0.2s ease; }
        .clickable:hover { filter: brightness(1.3); }
        .profil-kontur:hover ellipse { stroke-width: 4 !important; }
        .limit-area:hover path,
        .limit-area:hover line { stroke-width: 3 !important; filter: brightness(1.4); }
        .pulse { animation: pulse 1.2s ease-in-out infinite; }
        @keyframes pulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.5; transform: scale(0.85); }
        }

        /* SVG İnteraktif Elemanlar */
        .start-point:hover circle, .end-point:hover circle { stroke-width: 2.5 !important; }
        .check-area:hover ellipse { stroke-width: 2.5 !important; }
        .val-edit:hover rect { stroke-width: 1.5 !important; filter: brightness(1.3); }
        .mode-btn:hover rect { filter: brightness(1.4); }

        /* ═══════════════════════════════════════════════════════════════════
           PARAMS GRID
           ═══════════════════════════════════════════════════════════════════ */
        .params-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 4px;
            padding: 5px;
            background: rgba(0,25,40,0.3);
        }
        .param-item {
            display: flex; flex-direction: column;
            padding: 4px 6px;
            background: linear-gradient(135deg, rgba(0,50,70,0.4) 0%, rgba(0,30,50,0.4) 100%);
            border: 1px solid rgba(0,100,150,0.2);
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s ease;
            position: relative;
            overflow: hidden;
        }
        .param-item::before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(0,200,255,0.3), transparent);
            opacity: 0;
            transition: opacity 0.3s ease;
        }
        .param-item:hover::before { opacity: 1; }
        .param-item:hover {
            background: linear-gradient(135deg, rgba(0,70,90,0.5) 0%, rgba(0,40,60,0.5) 100%);
            border-color: rgba(0,200,255,0.4);
            transform: translateY(-1px);
        }
        .param-item.orange { border-color: rgba(200,100,50,0.3); }
        .param-item.orange:hover { border-color: #f86; }
        .param-label {
            font-size: 7px;
            color: #689;
            margin-bottom: 2px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        .param-value {
            font-size: 10px;
            font-weight: 700;
            color: #0cf;
        }
        .param-item.orange .param-value { color: #fa8; }

        /* ═══════════════════════════════════════════════════════════════════
           INPUT OVERLAY
           ═══════════════════════════════════════════════════════════════════ */
        .input-overlay {
            position: absolute; inset: 0;
            background: rgba(0,5,10,0.9);
            backdrop-filter: blur(8px);
            display: flex; align-items: center; justify-content: center;
            z-index: 100;
            border-radius: 12px;
        }
        .input-dialog {
            background: linear-gradient(135deg, rgba(10,30,50,0.98) 0%, rgba(5,15,25,0.98) 100%);
            border: 1px solid rgba(0,200,255,0.4);
            border-radius: 10px;
            padding: 12px 14px;
            min-width: 160px;
            box-shadow:
                0 0 30px rgba(0,200,255,0.2),
                inset 0 1px 0 rgba(255,255,255,0.05);
        }
        .input-title {
            font-size: 11px;
            font-weight: 700;
            background: linear-gradient(90deg, #0ff, #4df);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-bottom: 12px;
            text-align: center;
        }
        .input-dialog input {
            width: 100%; padding: 7px 9px;
            background: rgba(0,20,30,0.8);
            border: 2px solid rgba(0,200,255,0.3);
            border-radius: 6px;
            color: #fff;
            font-size: 13px;
            font-weight: 600;
            text-align: center;
            transition: all 0.3s ease;
        }
        .input-dialog input:focus {
            outline: none;
            border-color: #0ff;
            box-shadow: 0 0 20px rgba(0,255,255,0.2);
        }
        .input-btns {
            display: flex; gap: 8px; margin-top: 12px;
        }
        .input-btns button {
            flex: 1; padding: 8px 0; border-radius: 6px;
            font-size: 10px; font-weight: 700; cursor: pointer;
            background: rgba(0,60,80,0.6);
            border: 1px solid rgba(0,150,200,0.4);
            color: #adf;
            transition: all 0.2s ease;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
        .input-btns button:hover {
            background: rgba(0,80,100,0.7);
            transform: translateY(-1px);
        }
        .input-btns button.ok {
            background: linear-gradient(135deg, rgba(0,160,120,0.6), rgba(0,120,100,0.6));
            border-color: rgba(0,200,150,0.5);
            color: #fff;
        }
        .input-btns button.ok:hover {
            box-shadow: 0 0 15px rgba(0,200,150,0.3);
        }

        /* ═══════════════════════════════════════════════════════════════════
           FOOTER
           ═══════════════════════════════════════════════════════════════════ */
        .d-footer {
            display: flex; gap: 5px; padding: 6px;
            background: linear-gradient(180deg, rgba(0,30,45,0.3) 0%, rgba(0,20,30,0.5) 100%);
            border-radius: 0 0 10px 10px;
        }
        .btn {
            flex: 1; padding: 6px 0; border-radius: 5px;
            background: linear-gradient(135deg, rgba(0,50,70,0.6) 0%, rgba(0,30,50,0.6) 100%);
            border: 1px solid rgba(0,150,200,0.3);
            color: #adf;
            font-size: 10px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.25s ease;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            position: relative;
            overflow: hidden;
        }
        .btn::before {
            content: '';
            position: absolute;
            inset: 0;
            background: linear-gradient(135deg, rgba(0,200,255,0.1), transparent);
            opacity: 0;
            transition: opacity 0.3s ease;
        }
        .btn:hover::before { opacity: 1; }
        .btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(0,150,200,0.2);
        }
        .btn.ok {
            background: linear-gradient(135deg, rgba(0,150,100,0.6) 0%, rgba(0,100,80,0.6) 100%);
            border-color: rgba(0,200,150,0.5);
            color: #fff;
        }
        .btn.ok:hover {
            box-shadow: 0 4px 20px rgba(0,200,150,0.3);
        }
    `]
})
export class DialogFikoProfilComponent implements OnDestroy, AfterViewInit {

    pencere = input<any>();
    anaGosterim = input<any>();
    sahne = input<FikoSahne>();
    aktivite = input<FikoAktiviteProfil>();
    @Output() kapandi = new EventEmitter<void>();

    // İşleme türü: duzlem-duzlem, cizgi-cizgi, cizgi-yuzey, yuzey-yuzey
    islemeTuru: 'duzlem-duzlem' | 'cizgi-cizgi' | 'cizgi-yuzey' | 'yuzey-yuzey' = 'duzlem-duzlem';

    // Seçim durumları
    profilSecili = false;
    ustLimitSecili = false;
    altLimitSecili = false;
    checkSecili = false;
    baslangicSecili = false;  // Profil başlangıç noktası
    bitisSecili = false;       // Profil bitiş noktası
    takimYonuSecili = false;   // Takım yönü seçimi

    // Başlangıç/Bitiş modları ve offset
    baslangicModu: 'merkez' | 'icerde' | 'disarda' = 'merkez';
    bitisModu: 'merkez' | 'icerde' | 'disarda' = 'merkez';
    baslangicOffset = 0;
    bitisOffset = 0;

    // Z değerleri
    topZ = 10;
    bottomZ = -30;

    // Offset değerleri
    profilOffset = 2;
    topOffset = 0;
    bottomOffset = 0;

    // Kesme parametreleri
    kesmeHizi = 150;

    // TAB sistemi
    aktifTab = 0;

    // GEÇİŞ TAB - Panel durumları
    girisExpanded = true;
    cikisExpanded = false;
    girisAnimating = false;
    cikisAnimating = false;

    // Geçiş parametreleri - KAPSAMLI
    rampaAcisi = 15;
    heliselCap = 10;
    heliselAdim = 2;
    araGecisZ = 2;
    yuzeyPayi = 0.5;

    // Giriş parametreleri (genişletilmiş)
    girisAcisi = 15;
    girisRadius = 5;
    girisYonuCW = true;
    girisYayAci = 90;

    // Çıkış parametreleri (genişletilmiş)
    cikisAcisi = 15;
    cikisRadius = 5;
    cikisYonuCW = false;

    // Geçiş tipi
    gecisTipi: 'Direkt' | 'Yumusak' | 'Profil' = 'Direkt';

    // Uzatma & Overlap
    basUzatma = 0;
    sonUzatma = 0;
    overlap = 0;
    overcutEtkin = false;

    // Hız parametreleri (Geçiş için)
    hizRapid = 10000;
    hizDalma = 500;
    hizCekme = 3000;
    hizLead = 100; // yüzde

    // Finiş (son tur) ek parametreler
    sonTurDevir = 4000;
    sonTurAyriGiris = false;

    // === YENİ PROFESYONEL CAM PARAMETRELERİ ===

    // Tabs (Köprü/Tutma) - Parçayı tutmak için
    tabEtkin = false;
    tabSekli: 'Dikdortgen' | 'Ucgen' = 'Dikdortgen';
    tabGenislik = 5;
    tabYukseklik = 2;
    tabSayisi = 4;
    tabMesafe = 50;
    tabDagitim: 'Sayi' | 'Mesafe' = 'Sayi';

    // Köşe Yavaşlama (Corner Slowdown)
    koseYavaslamaEtkin = false;
    koseYavaslamaOrani = 50;
    koseMinAci = 90;
    koseYavaslamaTipi: 'Tum' | 'Ic' | 'Dis' = 'Tum';

    // Kompanzasyon
    kompanzasyonTipi: 'Bilgisayar' | 'Kontrol' | 'Kapali' = 'Bilgisayar';
    kompanzasyonTolereans = 0.05;

    // Stay-Down / Lift
    stayDownEtkin = true;
    stayDownMesafe = 10;
    kaldirmaMesafesi = 2;

    // Yol Yumuşatma (Path Smoothing)
    yumusatmaEtkin = false;
    yumusatmaRadius = 0.5;
    yumusatmaTolerans = 0.01;

    // Freze Yönü (Climb vs Conventional)
    frezeYonu: 'Tirmanma' | 'Konvansiyonel' = 'Tirmanma';

    // Çoklu Finiş Geçişi
    finishGecisSayisi = 1;
    finishStockAzaltma = 0.1;

    // Panel genişletme durumları
    tabExpanded = false;
    koseExpanded = false;
    kompExpanded = false;
    stayDownExpanded = false;
    yumusatmaExpanded = false;

    // SVG Tool pozisyonları
    girisToolY = 10;
    cikisToolY = 50;

    // Edit state
    editingField: string | null = null;
    editingLabel = '';
    editingValue: number = 0;

    // ═══════════════════════════════════════════════════════════════════
    // 3D SEÇİM SİSTEMİ - FikoSecililer Entegrasyonu
    // ═══════════════════════════════════════════════════════════════════

    // FikoSecililer instance (anaGosterim.sahneler[0].secimler)
    private fikoSecililer: FikoSecililer | null = null;

    // Subscription'lar (temizlik için)
    private secimSubscriptions: Subscription[] = [];

    // Aktif seçim modu
    private secimModu: 'profil' | 'ustLimit' | 'altLimit' | 'baslangic' | 'bitis' | 'takimYonu' | null = null;

    // Seçilen geometriler (geçici)
    secilenProfilEdges: any[] = [];
    secilenUstLimitFace: any = null;
    secilenAltLimitFace: any = null;
    secilenTakimYonuFace: any = null;

    // Keyboard event listener (ESC/Enter için)
    private keyDownHandler: ((e: KeyboardEvent) => void) | null = null;

    // Highlight helper
    private highlightMesh: any = null;

    constructor(private cd: ChangeDetectorRef) {}

    ngAfterViewInit() {
        // Aktiviteden mevcut profil noktalarını yükle
        this.loadProfilFromAktivite();
    }

    /**
     * Aktivitedeki profil noktalarını UI'a yükle
     */
    private loadProfilFromAktivite(): void {
        const akt = this.aktivite();
        if (!akt) return;

        // Z değerlerini yükle
        this.topZ = akt.ustZ ?? 10;
        this.bottomZ = akt.altZ ?? -30;
        this.profilOffset = akt.ofsetMiktari ?? 2;

        // Profil noktaları varsa seçili olarak işaretle
        if (akt.profilNoktalar && akt.profilNoktalar.length > 0) {
            this.profilSecili = true;
        }
    }

    get zDepth() { return this.topZ - this.bottomZ; }

    // İşleme türüne göre üst limit label ve icon
    get ustLimitLabel(): string {
        switch (this.islemeTuru) {
            case 'duzlem-duzlem': return 'Üst Düzlem';
            case 'cizgi-cizgi': return 'Üst Çizgi';
            case 'cizgi-yuzey': return 'Üst Çizgi';
            case 'yuzey-yuzey': return 'Üst Yüzey';
            default: return 'Üst Limit';
        }
    }

    get ustLimitIcon(): string {
        switch (this.islemeTuru) {
            case 'duzlem-duzlem': return '▭';
            case 'cizgi-cizgi': return '─';
            case 'cizgi-yuzey': return '─';
            case 'yuzey-yuzey': return '◱';
            default: return '▲';
        }
    }

    // İşleme türüne göre alt limit label ve icon
    get altLimitLabel(): string {
        switch (this.islemeTuru) {
            case 'duzlem-duzlem': return 'Alt Düzlem';
            case 'cizgi-cizgi': return 'Alt Çizgi';
            case 'cizgi-yuzey': return 'Alt Yüzey';
            case 'yuzey-yuzey': return 'Alt Yüzey';
            default: return 'Alt Limit';
        }
    }

    get altLimitIcon(): string {
        switch (this.islemeTuru) {
            case 'duzlem-duzlem': return '▭';
            case 'cizgi-cizgi': return '─';
            case 'cizgi-yuzey': return '◱';
            case 'yuzey-yuzey': return '◱';
            default: return '▼';
        }
    }

    // İşleme yolu SVG path (Tab 1 için)
    get islemeYoluPath(): string {
        const akt = this.aktivite();
        if (!akt) return 'M70,40 L210,40';
        switch (akt.islemeYontemi) {
            case 'Tek Yön':
                // Yatay paralel çizgiler (→)
                return 'M70,40 L210,40 M70,55 L210,55 M70,70 L210,70 M70,85 L210,85';
            case 'Zik Zak':
                // Bağlantılı zikzak pattern (↔)
                return 'M70,40 L210,40 L210,55 L70,55 L70,70 L210,70 L210,85 L70,85';
            case 'Helisel':
                // Yatay çizgiler + çapraz bağlantılar (helisel iniş)
                return 'M70,40 L210,40 L70,55 L210,55 L70,70 L210,70 L70,85 L210,85';
            default:
                return 'M70,40 L210,40 M70,55 L210,55 M70,70 L210,70 M70,85 L210,85';
        }
    }

    // Giriş/Çıkış SVG yolları (Tab 3 için)
    get girisPath(): string {
        const akt = this.aktivite();
        if (!akt) return 'M60,20 L60,40 L80,40';
        switch (akt.girisYontemi) {
            case 'Dikey': return 'M60,20 L60,55';
            case 'Rampa': return 'M40,20 L80,55';
            case 'Helisel': return 'M50,20 Q40,35 50,40 Q60,45 50,55';
            default: return 'M60,20 L60,55';
        }
    }

    get cikisPath(): string {
        const akt = this.aktivite();
        if (!akt) return 'M200,40 L200,20';
        switch (akt.cikisYontemi) {
            case 'Dikey': return 'M220,55 L220,20';
            case 'Rampa': return 'M200,55 L240,20';
            default: return 'M220,55 L220,20';
        }
    }

    // Detaylı Giriş Yolu (Geçiş Tab SVG için)
    get girisPathDetay(): string {
        const akt = this.aktivite();
        if (!akt) return 'M40,28 L40,75';
        const uzunluk = akt.girisUzunluk || 5;
        const scale = uzunluk / 10;
        switch (akt.girisYontemi) {
            case 'Dikey':
                return `M40,28 L40,${28 + 47 * scale}`;
            case 'Rampa':
                return `M25,28 L55,${28 + 47 * scale}`;
            case 'Helisel':
                return `M40,28 Q30,${28 + 15 * scale} 40,${28 + 25 * scale} Q50,${28 + 35 * scale} 40,${28 + 47 * scale}`;
            default:
                return 'M40,28 L40,75';
        }
    }

    // Detaylı Çıkış Yolu (Geçiş Tab SVG için)
    get cikisPathDetay(): string {
        const akt = this.aktivite();
        if (!akt) return 'M240,75 L240,28';
        const uzunluk = akt.cikisUzunluk || 5;
        const scale = uzunluk / 10;
        switch (akt.cikisYontemi) {
            case 'Dikey':
                return `M240,${28 + 47 * scale} L240,28`;
            case 'Rampa':
                return `M225,${28 + 47 * scale} L255,28`;
            default:
                return 'M240,75 L240,28';
        }
    }

    // Mini SVG Giriş Yolu (kompakt görsel için)
    get girisPathMini(): string {
        const akt = this.aktivite();
        if (!akt) return 'M30,15 L30,50';
        switch (akt.girisYontemi) {
            case 'Dikey': return 'M30,15 L30,50';
            case 'Rampa': return 'M20,15 L40,50';
            case 'Helisel': return 'M30,15 Q22,28 30,32 Q38,36 30,42 Q26,48 30,50';
            case 'Yay': return 'M30,15 Q15,32 30,50';
            case 'Teget': return 'M15,15 L35,35 L35,50';
            default: return 'M30,15 L30,50';
        }
    }

    // Mini SVG Çıkış Yolu (kompakt görsel için)
    get cikisPathMini(): string {
        const akt = this.aktivite();
        if (!akt) return 'M250,50 L250,15';
        switch (akt.cikisYontemi) {
            case 'Dikey': return 'M250,50 L250,15';
            case 'Rampa': return 'M240,50 L260,15';
            case 'Yay': return 'M250,50 Q265,32 250,15';
            default: return 'M250,50 L250,15';
        }
    }

    // Giriş yöntemi kısa ad (SVG etiket için)
    get girisKisaAd(): string {
        const akt = this.aktivite();
        if (!akt) return 'DİK';
        switch (akt.girisYontemi) {
            case 'Dikey': return 'DİK';
            case 'Rampa': return 'RMP';
            case 'Helisel': return 'HEL';
            case 'Yay': return 'YAY';
            case 'Teget': return 'TAN';
            default: return 'DİK';
        }
    }

    // Çıkış yöntemi kısa ad (SVG etiket için)
    get cikisKisaAd(): string {
        const akt = this.aktivite();
        if (!akt) return 'DİK';
        switch (akt.cikisYontemi) {
            case 'Dikey': return 'DİK';
            case 'Rampa': return 'RMP';
            case 'Yay': return 'YAY';
            default: return 'DİK';
        }
    }

    // Panel toggle metodları
    toggleGirisPanel() {
        this.girisExpanded = !this.girisExpanded;
        this.cd.detectChanges();
    }

    toggleCikisPanel() {
        this.cikisExpanded = !this.cikisExpanded;
        this.cd.detectChanges();
    }

    // Giriş yöntemi cycle (SVG üzerine tıklayınca) - GENİŞLETİLMİŞ
    cycleGirisYontemi() {
        const akt = this.aktivite();
        if (!akt) return;
        const yontemler: Array<'Dikey' | 'Rampa' | 'Helisel' | 'Yay' | 'Teget'> = ['Dikey', 'Rampa', 'Helisel', 'Yay', 'Teget'];
        const idx = yontemler.indexOf(akt.girisYontemi as any);
        (akt as any).girisYontemi = yontemler[(idx + 1) % yontemler.length];
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Çıkış yöntemi cycle (SVG üzerine tıklayınca) - GENİŞLETİLMİŞ
    cycleCikisYontemi() {
        const akt = this.aktivite();
        if (!akt) return;
        const yontemler: Array<'Dikey' | 'Rampa' | 'Yay'> = ['Dikey', 'Rampa', 'Yay'];
        const idx = yontemler.indexOf(akt.cikisYontemi as any);
        (akt as any).cikisYontemi = yontemler[(idx + 1) % yontemler.length];
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Tab değiştir
    setTab(tabIndex: number) {
        this.aktifTab = tabIndex;
        this.cd.detectChanges();
    }

    // İşleme türü değiştir
    setIslemeTuru(tur: 'duzlem-duzlem' | 'cizgi-cizgi' | 'cizgi-yuzey' | 'yuzey-yuzey') {
        this.islemeTuru = tur;
        // Tür değişince seçimleri sıfırla
        this.ustLimitSecili = false;
        this.altLimitSecili = false;
        this.cd.detectChanges();
    }

    // İşleme yöntemini değiştir (Tek Yön <-> Zik Zak)
    toggleYon() {
        const akt = this.aktivite();
        if (akt) {
            akt.islemeYontemi = akt.islemeYontemi === 'Tek Yön' ? 'Zik Zak' : 'Tek Yön';
        }
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // İşleme yöntemi ayarla (Tab 1)
    setIslemeYontemi(yontem: 'Tek Yön' | 'Zik Zak' | 'Helisel') {
        const akt = this.aktivite();
        if (akt) akt.islemeYontemi = yontem;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Köşe dönüşleri ayarla (Tab 1)
    setKoseDonusler(mod: 'Keskin' | 'Dairesel' | 'Yakinsal') {
        const akt = this.aktivite();
        if (akt) akt.koseDonusler = mod;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Giriş yöntemi ayarla (Tab 3) - GENİŞLETİLMİŞ
    setGirisYontemi(yontem: 'Dikey' | 'Rampa' | 'Helisel' | 'Yay' | 'Teget') {
        const akt = this.aktivite();
        if (akt) (akt as any).girisYontemi = yontem;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Çıkış yöntemi ayarla (Tab 3) - GENİŞLETİLMİŞ
    setCikisYontemi(yontem: 'Dikey' | 'Rampa' | 'Yay') {
        const akt = this.aktivite();
        if (akt) (akt as any).cikisYontemi = yontem;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Geçiş tipi ayarla
    setGecisTipi(tip: 'Direkt' | 'Yumusak' | 'Profil') {
        this.gecisTipi = tip;
        this.cd.detectChanges();
    }

    // Giriş yay yönü toggle
    toggleGirisYonu() {
        this.girisYonuCW = !this.girisYonuCW;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Çıkış yay yönü toggle
    toggleCikisYonu() {
        this.cikisYonuCW = !this.cikisYonuCW;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Overcut toggle
    toggleOvercut() {
        this.overcutEtkin = !this.overcutEtkin;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Son tur ayrı giriş toggle
    toggleSonTurAyriGiris() {
        this.sonTurAyriGiris = !this.sonTurAyriGiris;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // Son tur toggle (Tab 3)
    toggleSonTur() {
        const akt = this.aktivite();
        if (akt) akt.sonTurEtkin = !akt.sonTurEtkin;
        this.cd.detectChanges();
        this.otomatikHesapla(); // 🔧 PRODUCTION-READY: Otomatik takım yolu güncelleme
    }

    // ═══════════════════════════════════════════════════════════════════
    // PROFESYONEL CAM ÖZELLİKLERİ - Toggle & Setter Metodları
    // ═══════════════════════════════════════════════════════════════════

    // --- TABS (KÖPRÜ) ---
    toggleTabPanel() {
        if (!this.tabEtkin) {
            this.tabEtkin = true;
            this.tabExpanded = true;
        } else {
            this.tabExpanded = !this.tabExpanded;
        }
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    toggleTabEtkin() {
        this.tabEtkin = !this.tabEtkin;
        const akt = this.aktivite();
        if (akt) akt.tabEtkin = this.tabEtkin;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    setTabSekli(sekil: 'Dikdortgen' | 'Ucgen') {
        this.tabSekli = sekil;
        const akt = this.aktivite();
        if (akt) akt.tabSekli = sekil;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    setTabDagitim(dagitim: 'Sayi' | 'Mesafe') {
        this.tabDagitim = dagitim;
        const akt = this.aktivite();
        if (akt) akt.tabDagitim = dagitim;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    // --- KÖŞE YAVAŞLAMA ---
    toggleKosePanel() {
        if (!this.koseYavaslamaEtkin) {
            this.koseYavaslamaEtkin = true;
            this.koseExpanded = true;
        } else {
            this.koseExpanded = !this.koseExpanded;
        }
        const akt = this.aktivite();
        if (akt) akt.koseYavaslamaEtkin = this.koseYavaslamaEtkin;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    setKoseYavaslamaTipi(tip: 'Tum' | 'Ic' | 'Dis') {
        this.koseYavaslamaTipi = tip;
        const akt = this.aktivite();
        if (akt) akt.koseYavaslamaTipi = tip;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    // --- FREZE YÖNÜ ---
    setFrezeYonu(yon: 'Tirmanma' | 'Konvansiyonel') {
        this.frezeYonu = yon;
        const akt = this.aktivite();
        if (akt) akt.frezeYonu = yon;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    // --- KOMPANZASYON ---
    setKompanzasyonTipi(tip: 'Bilgisayar' | 'Kontrol' | 'Kapali') {
        this.kompanzasyonTipi = tip;
        const akt = this.aktivite();
        if (akt) akt.kompanzasyonTipi = tip;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    // --- STAY-DOWN ---
    toggleStayDownPanel() {
        if (!this.stayDownEtkin) {
            this.stayDownEtkin = true;
            this.stayDownExpanded = true;
        } else {
            this.stayDownExpanded = !this.stayDownExpanded;
        }
        const akt = this.aktivite();
        if (akt) akt.stayDownEtkin = this.stayDownEtkin;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    // --- YUMUŞATMA ---
    toggleYumusatmaPanel() {
        if (!this.yumusatmaEtkin) {
            this.yumusatmaEtkin = true;
            this.yumusatmaExpanded = true;
        } else {
            this.yumusatmaExpanded = !this.yumusatmaExpanded;
        }
        const akt = this.aktivite();
        if (akt) akt.yumusatmaEtkin = this.yumusatmaEtkin;
        this.cd.detectChanges();
        this.otomatikHesapla();
    }

    // ═══════════════════════════════════════════════════════════════════
    // PROFİL SEÇİMİ - 3D Edge/Curve Seçimi
    // ═══════════════════════════════════════════════════════════════════

    /**
     * Profil seçim modunu aç/kapat
     * 3D sahneden edge'ler seçilerek profil oluşturulur
     */
    secProfil() {
        if (this.secimModu === 'profil') {
            // Seçim modunu kapat
            this.secimModunuKapat();
            return;
        }

        // Diğer seçim modlarını kapat
        this.secimModunuKapat();

        this.profilSecili = true;
        this.secimModu = 'profil';
        this.secilenProfilEdges = [];

        // Canvas'ı al ve seçim modunu başlat
        this.baslat3DSecim('edge');

        // Bilgi mesajı
        console.log('[CAM] Profil seçim modu aktif - Edge\'leri tıklayarak profil oluşturun. ESC ile iptal.');
        this.cd.detectChanges();
    }

    // ═══════════════════════════════════════════════════════════════════
    // ÜST LİMİT SEÇİMİ - Face/Plane Seçimi
    // ═══════════════════════════════════════════════════════════════════

    /**
     * Üst limit seçim modunu aç/kapat
     * Z üst sınırı için yüzey veya düzlem seçimi
     */
    secUstLimit() {
        if (this.secimModu === 'ustLimit') {
            this.secimModunuKapat();
            return;
        }

        this.secimModunuKapat();

        this.ustLimitSecili = true;
        this.secimModu = 'ustLimit';

        // İşleme türüne göre seçim tipi
        const secimTipi = this.islemeTuru.startsWith('cizgi') ? 'edge' : 'face';
        this.baslat3DSecim(secimTipi);

        console.log(`[CAM] Üst limit seçim modu aktif - ${secimTipi === 'face' ? 'Yüzey' : 'Çizgi'} seçin. ESC ile iptal.`);
        this.cd.detectChanges();
    }

    // ═══════════════════════════════════════════════════════════════════
    // ALT LİMİT SEÇİMİ - Face/Plane Seçimi
    // ═══════════════════════════════════════════════════════════════════

    /**
     * Alt limit seçim modunu aç/kapat
     * Z alt sınırı için yüzey veya düzlem seçimi
     */
    secAltLimit() {
        if (this.secimModu === 'altLimit') {
            this.secimModunuKapat();
            return;
        }

        this.secimModunuKapat();

        this.altLimitSecili = true;
        this.secimModu = 'altLimit';

        // İşleme türüne göre seçim tipi
        const secimTipi = this.islemeTuru.endsWith('yuzey') ? 'face' : 'edge';
        this.baslat3DSecim(secimTipi);

        console.log(`[CAM] Alt limit seçim modu aktif - ${secimTipi === 'face' ? 'Yüzey' : 'Çizgi'} seçin. ESC ile iptal.`);
        this.cd.detectChanges();
    }

    // ═══════════════════════════════════════════════════════════════════
    // CHECK SURFACE SEÇİMİ
    // ═══════════════════════════════════════════════════════════════════

    secCheck() {
        this.checkSecili = !this.checkSecili;
        this.cd.detectChanges();
    }

    // ═══════════════════════════════════════════════════════════════════
    // BAŞLANGIÇ/BİTİŞ NOKTA SEÇİMİ
    // ═══════════════════════════════════════════════════════════════════

    /**
     * Profil başlangıç noktası seçimi
     */
    secBaslangic() {
        if (this.secimModu === 'baslangic') {
            this.secimModunuKapat();
            return;
        }

        this.secimModunuKapat();
        this.baslangicSecili = true;
        this.secimModu = 'baslangic';
        this.baslat3DSecim('vertex');

        console.log('[CAM] Başlangıç noktası seçim modu - Profil üzerinde bir nokta seçin. ESC ile iptal.');
        this.cd.detectChanges();
    }

    /**
     * Profil bitiş noktası seçimi
     */
    secBitis() {
        if (this.secimModu === 'bitis') {
            this.secimModunuKapat();
            return;
        }

        this.secimModunuKapat();
        this.bitisSecili = true;
        this.secimModu = 'bitis';
        this.baslat3DSecim('vertex');

        console.log('[CAM] Bitiş noktası seçim modu - Profil üzerinde bir nokta seçin. ESC ile iptal.');
        this.cd.detectChanges();
    }

    // ═══════════════════════════════════════════════════════════════════
    // TAKIM YÖNÜ SEÇİMİ - Face Normal Seçimi
    // ═══════════════════════════════════════════════════════════════════

    /**
     * Takım yönü seçim modunu aç/kapat
     * 3D sahneden bir yüzey seçilerek takım yönü (normal) belirlenir
     */
    secTakimYonu() {
        if (this.secimModu === 'takimYonu') {
            this.secimModunuKapat();
            return;
        }

        this.secimModunuKapat();
        this.takimYonuSecili = true;
        this.secimModu = 'takimYonu';
        this.baslat3DSecim('face');

        console.log('[CAM] Takım yönü seçim modu aktif - Yüzey seçerek takım yönünü belirleyin. ESC ile iptal.');
        this.cd.detectChanges();
    }

    // ═══════════════════════════════════════════════════════════════════
    // 3D SEÇİM MOTORU - FikoSecililer Entegrasyonu
    // ═══════════════════════════════════════════════════════════════════

    /**
     * 3D seçim modunu başlat - FikoSecililer kullanarak
     * @param tip - Seçim tipi: 'edge' (çizgi), 'face' (yüzey), 'vertex' (nokta)
     */
    private baslat3DSecim(tip: 'edge' | 'face' | 'vertex'): void {
        const anaGosterim = this.anaGosterim();
        if (!anaGosterim?.sahneler?.[0]) {
            console.warn('[CAM] Sahne bulunamadı');
            return;
        }

        // FikoSecililer'i al (anaGosterim.sahneler[0].secimler)
        this.fikoSecililer = anaGosterim.sahneler[0].secimler;
        if (!this.fikoSecililer) {
            console.warn('[CAM] FikoSecililer bulunamadı');
            return;
        }

        // Önceki subscription'ları temizle
        this.secimSubscriptionTemizle();

        // FikoSecililer'i yapılandır - cetvel gibi
        this.fikoSecililer.aktif = true;
        this.fikoSecililer.kaliciSecimModu = true;
        this.fikoSecililer.hoverHighlightEnabled = true;
        this.fikoSecililer.temizle();

        // Seçim tipine göre filtre ayarla
        switch (tip) {
            case 'edge':
                this.fikoSecililer.filitreler = ['LineSegments', 'LineSegments2', 'Line2', 'LineGeometry', 'Line', 'Mesh'];
                break;
            case 'face':
                this.fikoSecililer.filitreler = ['Mesh'];
                break;
            case 'vertex':
                this.fikoSecililer.filitreler = ['Points', 'Mesh'];
                break;
        }

        // Tıklama event'ini dinle
        const tiklandiSub = this.fikoSecililer.tiklandi.subscribe((kesisim: any) => {
            if (kesisim) {
                console.log('[CAM] Seçim algılandı:', kesisim?.object?.type);
                this.handleFikoSecimKesisim(kesisim, tip);
            }
        });
        this.secimSubscriptions.push(tiklandiSub);

        // Hover event'ini dinle
        const uzerindeSub = this.fikoSecililer.uzerinde.subscribe((kesisim: any) => {
            if (kesisim && anaGosterim.ciz) {
                anaGosterim.ciz();
            }
        });
        this.secimSubscriptions.push(uzerindeSub);

        // Keyboard handler (ESC/Enter)
        this.keyDownHandler = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                this.secimModunuKapat();
            } else if (e.key === 'Enter') {
                this.secimOnayla();
            }
        };
        document.addEventListener('keydown', this.keyDownHandler);

        // Cursor değiştir
        const canvas = anaGosterim?.sunucu?.domElement as HTMLCanvasElement;
        if (canvas) {
            canvas.style.cursor = 'crosshair';
        }

        console.log(`[CAM] FikoSecililer ${tip} seçim modu aktif`);
    }

    /**
     * FikoSecililer kesişim sonucunu işle
     */
    private handleFikoSecimKesisim(kesisim: any, tip: 'edge' | 'face' | 'vertex'): void {
        if (!kesisim) return;

        // Intersection bilgilerini düzenle
        const intersection = this.kesisimBilgisiDuzenle(kesisim, tip);

        switch (this.secimModu) {
            case 'profil':
                this.handleProfilSecim(intersection);
                break;
            case 'ustLimit':
                this.handleUstLimitSecim(intersection);
                break;
            case 'altLimit':
                this.handleAltLimitSecim(intersection);
                break;
            case 'baslangic':
                this.handleBaslangicSecim(intersection);
                break;
            case 'bitis':
                this.handleBitisSecim(intersection);
                break;
            case 'takimYonu':
                this.handleTakimYonuSecim(intersection);
                break;
        }
    }

    /**
     * FikoSecililer kesişim bilgisini dialog formatına dönüştür
     */
    private kesisimBilgisiDuzenle(kesisim: any, tip: 'edge' | 'face' | 'vertex'): any {
        // FikoSecililer'den gelen kesişim bilgisi
        const obj = kesisim.altObje || kesisim.object;
        const point = kesisim.point?.clone() || new THREE.Vector3();

        if (tip === 'face') {
            // Yüzey seçimi
            return {
                point: point,
                faceIndex: kesisim.faceIndex,
                object: obj,
                normal: kesisim.normal?.clone() || kesisim.face?.normal?.clone(),
                z: point.z
            };
        } else if (tip === 'edge') {
            // Edge seçimi - FikoSecililer'den gelen highlight geometrisini kullan
            const vertices = this.edgeVerticesFromKesisim(kesisim);
            return {
                point: point,
                vertices: vertices,
                object: obj,
                faceIndex: kesisim.faceIndex
            };
        } else if (tip === 'vertex') {
            // Vertex seçimi
            return {
                point: point,
                object: obj
            };
        }

        return kesisim;
    }

    /**
     * Kesişim bilgisinden edge vertex'lerini çıkar
     * FikoSecililer'in sonSecilenHighlightGeometri özelliğini öncelikli kullanır
     *
     * 🔧 PRODUCTION-READY: Akıllı koordinat sistemi tespiti
     * - kesisim.point WORLD koordinatlarında (raycast sonucu)
     * - Highlight geometrisi LOCAL veya WORLD olabilir
     * - Mesafe kontrolü ile otomatik tespit ve düzeltme
     */
    private edgeVerticesFromKesisim(kesisim: any): THREE.Vector3[] {
        const vertices: THREE.Vector3[] = [];
        const obj = kesisim.altObje || kesisim.object;
        const worldPoint = kesisim.point?.clone(); // WORLD koordinatlarında (raycast sonucu)

        console.log('[CAM-DEBUG] ═══════════════════════════════════════');
        console.log('[CAM-DEBUG] Edge Vertex Çıkarma Başladı');
        console.log('[CAM-DEBUG] Raycast Point (WORLD):', worldPoint ? `(${worldPoint.x.toFixed(2)}, ${worldPoint.y.toFixed(2)}, ${worldPoint.z.toFixed(2)})` : 'YOK');
        console.log('[CAM-DEBUG] Object:', obj?.name || obj?.type || 'YOK');

        // 🎯 ÖNCELİKLİ: FikoSecililer'in highlight geometrisini kullan
        if (this.fikoSecililer?.sonSecilenHighlightGeometri) {
            const geom = this.fikoSecililer.sonSecilenHighlightGeometri.clone();
            const pos = geom.attributes?.position;

            if (pos && pos.count > 0) {
                // Önce RAW koordinatları al (transform uygulamadan)
                const rawVertices: THREE.Vector3[] = [];
                for (let i = 0; i < pos.count; i++) {
                    const v = new THREE.Vector3().fromBufferAttribute(pos, i);
                    if (!isNaN(v.x) && !isNaN(v.y) && !isNaN(v.z)) {
                        rawVertices.push(v);
                    }
                }

                if (rawVertices.length > 0) {
                    // 🧠 AKILLI TESPİT: Koordinat sistemini kontrol et
                    // kesisim.point ile raw koordinatlar arasındaki mesafeyi kontrol et
                    let needsTransform = false;

                    if (worldPoint && obj) {
                        // En yakın raw vertex'in mesafesini bul
                        let minDistRaw = Infinity;
                        for (const rv of rawVertices) {
                            const dist = rv.distanceTo(worldPoint);
                            if (dist < minDistRaw) minDistRaw = dist;
                        }

                        console.log('[CAM-DEBUG] Raw koordinat mesafesi:', minDistRaw.toFixed(2), 'mm');

                        // Eğer raw koordinatlar çok uzaksa (>50mm), transform gerekli
                        // Bu eşik değeri, tipik CAD toleranslarından çok büyük
                        if (minDistRaw > 50) {
                            needsTransform = true;
                            console.log('[CAM-DEBUG] Transform GEREKLİ - koordinatlar uzak');
                        } else {
                            console.log('[CAM-DEBUG] Transform GEREKLİ DEĞİL - koordinatlar yakın');
                        }
                    }

                    // Transform uygula (gerekiyorsa)
                    if (needsTransform && obj) {
                        // 🔧 Önce matrixWorld'ü güncelle (stale olabilir!)
                        if (typeof obj.updateWorldMatrix === 'function') {
                            obj.updateWorldMatrix(true, false);
                        }

                        const matrix = (obj as any).matrixWorld;
                        if (matrix) {
                            for (const v of rawVertices) {
                                v.applyMatrix4(matrix);
                            }
                            console.log('[CAM-DEBUG] Transform uygulandı');
                        }
                    }

                    // Son doğrulama: Transform sonrası mesafe kontrolü
                    if (worldPoint) {
                        let minDistFinal = Infinity;
                        for (const v of rawVertices) {
                            const dist = v.distanceTo(worldPoint);
                            if (dist < minDistFinal) minDistFinal = dist;
                        }
                        console.log('[CAM-DEBUG] Final koordinat mesafesi:', minDistFinal.toFixed(2), 'mm');

                        // Hala çok uzaksa uyar
                        if (minDistFinal > 100) {
                            console.warn('[CAM-DEBUG] ⚠️ Koordinatlar hala uzak! Olası transform sorunu.');
                        }
                    }

                    console.log('[CAM-DEBUG] Vertex sayısı:', rawVertices.length);
                    console.log('[CAM-DEBUG] İlk vertex:', rawVertices[0] ? `(${rawVertices[0].x.toFixed(2)}, ${rawVertices[0].y.toFixed(2)}, ${rawVertices[0].z.toFixed(2)})` : 'YOK');
                    console.log('[CAM-DEBUG] ═══════════════════════════════════════');

                    return rawVertices;
                }
            }
        }

        // Fallback: LineSegments tipinde ise doğrudan çizgi vertex'lerini al
        if (obj?.type === 'LineSegments' || obj?.type === 'LineSegments2' || obj?.type === 'Line2') {
            const geom = obj.geometry;
            if (geom?.attributes?.position) {
                const pos = geom.attributes.position;
                const worldMatrix = obj.matrixWorld;

                // Tüm çizgi vertex'lerini al
                for (let i = 0; i < pos.count; i++) {
                    const v = new THREE.Vector3().fromBufferAttribute(pos, i);
                    if (worldMatrix) v.applyMatrix4(worldMatrix);
                    if (!isNaN(v.x) && !isNaN(v.y) && !isNaN(v.z)) {
                        vertices.push(v);
                    }
                }
                if (vertices.length > 0) {
                    console.log('[CAM] LineSegments geometrisinden', vertices.length, 'vertex alındı');
                    return vertices;
                }
            }
        }

        // Fallback: Mesh'ten face vertex'lerini al (kenar tespiti)
        if (obj?.type === 'Mesh' && kesisim.faceIndex !== undefined) {
            const geom = obj.geometry;
            const pos = geom?.attributes?.position;
            const indices = geom?.index;

            if (pos) {
                const worldMatrix = obj.matrixWorld;
                const faceStart = kesisim.faceIndex * 3;

                if (indices) {
                    // Indexed geometry
                    if (faceStart + 2 < indices.count) {
                        const v0Idx = indices.getX(faceStart);
                        const v1Idx = indices.getX(faceStart + 1);
                        const v2Idx = indices.getX(faceStart + 2);

                        const maxIdx = Math.max(v0Idx, v1Idx, v2Idx);
                        if (maxIdx < pos.count) {
                            const v0 = new THREE.Vector3().fromBufferAttribute(pos, v0Idx);
                            const v1 = new THREE.Vector3().fromBufferAttribute(pos, v1Idx);
                            const v2 = new THREE.Vector3().fromBufferAttribute(pos, v2Idx);

                            if (worldMatrix) {
                                v0.applyMatrix4(worldMatrix);
                                v1.applyMatrix4(worldMatrix);
                                v2.applyMatrix4(worldMatrix);
                            }

                            if (!isNaN(v0.x)) vertices.push(v0);
                            if (!isNaN(v1.x)) vertices.push(v1);
                            if (!isNaN(v2.x)) vertices.push(v2);
                        }
                    }
                } else {
                    // Non-indexed geometry
                    if (faceStart + 2 < pos.count) {
                        const v0 = new THREE.Vector3().fromBufferAttribute(pos, faceStart);
                        const v1 = new THREE.Vector3().fromBufferAttribute(pos, faceStart + 1);
                        const v2 = new THREE.Vector3().fromBufferAttribute(pos, faceStart + 2);

                        if (worldMatrix) {
                            v0.applyMatrix4(worldMatrix);
                            v1.applyMatrix4(worldMatrix);
                            v2.applyMatrix4(worldMatrix);
                        }

                        if (!isNaN(v0.x)) vertices.push(v0);
                        if (!isNaN(v1.x)) vertices.push(v1);
                        if (!isNaN(v2.x)) vertices.push(v2);
                    }
                }
            }
        }

        // Vertex bulunamadıysa tıklanan noktayı kullan
        if (vertices.length === 0 && worldPoint) {
            console.warn('[CAM] Vertex bulunamadı, tıklanan nokta kullanılıyor');
            vertices.push(worldPoint);
        }

        return vertices;
    }

    /**
     * Seçim subscription'larını temizle
     */
    private secimSubscriptionTemizle(): void {
        this.secimSubscriptions.forEach(sub => {
            if (sub && !sub.closed) {
                sub.unsubscribe();
            }
        });
        this.secimSubscriptions = [];
    }

    /** OCCT gerçek BREP CAM aktif mi (parça STEP shape'inden exact LINE/ARC kontur). */
    occtCamAktif = true;

    /**
     * Profil seçimi işle - Edge'leri topla ve AKILLI BİRLEŞTİR
     *
     * Profesyonel CAM sistemi gibi:
     * 1. Yeni edge'i mevcut profille en yakın uçtan birleştir
     * 2. Gerekirse yönü ters çevir
     * 3. Bağlantı noktalarını otomatik belirle
     * 4. Z değerlerini seçilen geometriden otomatik hesapla
     *
     * 🔧 PRODUCTION-READY: Geliştirilmiş Z hesaplama ve çoklu yüzey desteği
     */
    private async handleProfilSecim(intersection: any): Promise<void> {
        // Vertices kontrolü - edge veya face kenarı
        let vertices = intersection.vertices;
        let isFromFace = false;

        // Eğer vertices yoksa ve face seçildiyse, face sınırını çıkart.
        // Tier: 1) OCCT gerçek BREP (exact LINE/ARC) 2) mesh-brep sıralı loop 3) tek üçgen (eski)
        if (!vertices || vertices.length === 0) {
            if (intersection.faceIndex !== undefined && intersection.object) {
                const obj = intersection.object, fi = intersection.faceIndex, pt = intersection.point;
                if (this.occtCamAktif) {
                    const occt = await occtFaceVertices(obj, fi, pt);
                    if (occt && occt.length >= 3) vertices = occt;
                }
                if (!vertices || vertices.length < 3) {
                    const brep = faceBrepVertices(obj, fi);
                    if (brep.length >= 3) vertices = brep;
                }
                if (!vertices || vertices.length < 3) vertices = this.faceKenarlariniCikar(intersection);
                isFromFace = true;
                console.log('[CAM] Face sınırından vertices:', vertices?.length || 0);
            }
        }

        if (!vertices || vertices.length === 0) {
            console.warn('[CAM] Seçimden vertex çıkarılamadı');
            return;
        }

        const akt = this.aktivite();
        if (!akt) return;

        // Yeni profil noktaları ekle - NaN kontrolü ile
        const yeniNoktalar: FikoVektor3D[] = [];
        let minZ = Infinity;
        let maxZ = -Infinity;

        for (const v of vertices) {
            // NaN ve undefined kontrolü
            if (v && typeof v.x === 'number' && typeof v.y === 'number' &&
                !isNaN(v.x) && !isNaN(v.y) && isFinite(v.x) && isFinite(v.y)) {
                // Z değerini kaydet (limit hesaplaması için)
                const z = typeof v.z === 'number' && !isNaN(v.z) ? v.z : 0;
                if (z < minZ) minZ = z;
                if (z > maxZ) maxZ = z;

                // Z = 0 düzlemine projekte et (2D profil için)
                yeniNoktalar.push(new FikoVektor3D(v.x, v.y, 0));
            } else {
                console.warn('[CAM] Geçersiz vertex atlandı:', v);
            }
        }

        if (yeniNoktalar.length === 0) {
            console.warn('[CAM] Seçilen edge\'den geçerli nokta çıkarılamadı');
            return;
        }

        // 🔧 Z LİMİTLERİNİ HER ZAMAN HESAPLA
        // İlk seçimde ayarla, sonraki seçimlerde genişlet
        if (isFinite(maxZ) && isFinite(minZ)) {
            if (this.secilenProfilEdges.length === 0) {
                // İlk seçim - Z değerlerini ayarla
                if (Math.abs(maxZ - minZ) < 0.1) {
                    // Tek Z değeri varsa (düz çizgi), varsayılan derinlik ekle
                    this.topZ = maxZ + 5;  // 5mm yukarı
                    this.bottomZ = maxZ - 10; // 10mm aşağı (varsayılan kesim derinliği)
                } else {
                    this.topZ = maxZ + 2; // Biraz pay ekle
                    this.bottomZ = minZ;
                }
                console.log(`[CAM] Z limitleri ayarlandı (ilk): üst=${this.topZ.toFixed(1)}, alt=${this.bottomZ.toFixed(1)}`);
            } else {
                // Sonraki seçimler - aralığı genişlet (gerekirse)
                const newTopZ = Math.max(this.topZ, maxZ + 2);
                const newBottomZ = Math.min(this.bottomZ, minZ);
                if (newTopZ !== this.topZ || newBottomZ !== this.bottomZ) {
                    this.topZ = newTopZ;
                    this.bottomZ = newBottomZ;
                    console.log(`[CAM] Z limitleri genişletildi: üst=${this.topZ.toFixed(1)}, alt=${this.bottomZ.toFixed(1)}`);
                }
            }
            akt.ustZ = this.topZ;
            akt.altZ = this.bottomZ;
        }

        // 🔧 GÜNCELLEME: Z derinliği minimum kontrolü
        // Eğer Z aralığı çok küçükse (< zHatve), varsayılan derinlik ekle
        const zAralik = this.topZ - this.bottomZ;
        const minDerinlik = Math.max(akt.zHatve * 2, 5); // En az 2 pas veya 5mm
        if (zAralik < minDerinlik) {
            this.bottomZ = this.topZ - minDerinlik;
            akt.altZ = this.bottomZ;
            console.log(`[CAM] Z derinliği artırıldı (min ${minDerinlik}mm): alt=${this.bottomZ.toFixed(1)}`);
        }

        // 🧠 AKILLI BİRLEŞTİRME: Edge'leri en yakın uçlarından bağla
        if (akt.profilNoktalar.length === 0) {
            // İlk edge - direkt ekle
            akt.profilNoktalar = yeniNoktalar;
            console.log('[CAM] İlk edge eklendi:', yeniNoktalar.length, 'nokta');
        } else {
            // Mevcut profil var - yüzey için özel işlem
            if (isFromFace) {
                // Yüzey seçimi: Birleştirme yerine profil sınırını genişlet
                const birlestirilmis = this.faceProfilleriBlestir(akt.profilNoktalar, yeniNoktalar);
                akt.profilNoktalar = birlestirilmis;
                console.log('[CAM] Face profili birleştirildi. Toplam:', birlestirilmis.length, 'nokta');
            } else {
                // Edge seçimi: Akıllı birleştir
                const birlestirilmis = this.birlesikProfilOlustur(akt.profilNoktalar, yeniNoktalar);
                akt.profilNoktalar = birlestirilmis;
                console.log('[CAM] Edge birleştirildi. Toplam:', birlestirilmis.length, 'nokta');
            }
        }

        // Seçilen edge'leri kaydet
        this.secilenProfilEdges.push(intersection);
        this.profilSecili = true;
        // Yüz seçiminden gelen kontur KESİN kapalı — offset kapalı-poligon modunda yapılır (açık-bant üretimini önler)
        if (isFromFace) akt.profilKapali = true;

        console.log('[CAM] Profil güncellendi:', akt.profilNoktalar.map(n => `(${n.x.toFixed(1)}, ${n.y.toFixed(1)})`).join(' -> '));

        // Görüntüyü güncelle
        this.anaGosterim()?.ciz?.();
        this.cd.detectChanges();

        // 🔧 PRODUCTION-READY: Profil değiştiğinde otomatik önizleme
        this.otomatikHesapla();
    }

    /**
     * Face (yüzey) kenarlarını profil noktaları olarak çıkar
     * Mesh üçgeninden kenar vertex'lerini alır
     *
     * 🔧 PRODUCTION-READY: Komşu face'lerle birlikte sınır tespiti
     */
    private faceKenarlariniCikar(intersection: any): THREE.Vector3[] {
        const vertices: THREE.Vector3[] = [];
        const obj = intersection.object;
        const faceIndex = intersection.faceIndex;

        if (!obj?.geometry || faceIndex === undefined) {
            return vertices;
        }

        try {
            const geometry = obj.geometry;
            const position = geometry.attributes?.position;
            const index = geometry.index;

            if (!position) return vertices;

            let idx0: number, idx1: number, idx2: number;

            if (index) {
                // İndeksli geometri
                idx0 = index.getX(faceIndex * 3);
                idx1 = index.getX(faceIndex * 3 + 1);
                idx2 = index.getX(faceIndex * 3 + 2);
            } else {
                // İndekssiz geometri
                idx0 = faceIndex * 3;
                idx1 = faceIndex * 3 + 1;
                idx2 = faceIndex * 3 + 2;
            }

            // Vertex'leri al ve world koordinatlarına dönüştür
            const v0 = new THREE.Vector3().fromBufferAttribute(position, idx0);
            const v1 = new THREE.Vector3().fromBufferAttribute(position, idx1);
            const v2 = new THREE.Vector3().fromBufferAttribute(position, idx2);

            // World matris uygula
            if (obj.matrixWorld) {
                obj.updateWorldMatrix(true, false);
                v0.applyMatrix4(obj.matrixWorld);
                v1.applyMatrix4(obj.matrixWorld);
                v2.applyMatrix4(obj.matrixWorld);
            }

            // Üçgen kenarlarını sıralı ekle (kapalı döngü)
            vertices.push(v0.clone(), v1.clone(), v2.clone(), v0.clone());

            console.log('[CAM] Face kenarları çıkarıldı:', vertices.length, 'vertex');

        } catch (e) {
            console.warn('[CAM] Face kenar çıkarma hatası:', e);
        }

        return vertices;
    }

    /**
     * Çoklu face profillerini birleştir
     * Dış sınır (convex hull benzeri) oluşturur
     *
     * 🔧 PRODUCTION-READY: Çoklu yüzey seçimi için özel algoritma
     */
    private faceProfilleriBlestir(mevcut: FikoVektor3D[], yeni: FikoVektor3D[]): FikoVektor3D[] {
        // Tüm noktaları topla
        const tumNoktalar: FikoVektor3D[] = [...mevcut, ...yeni];

        // Duplicate noktaları kaldır (tolerans ile)
        const benzersiz: FikoVektor3D[] = [];
        const tolerans = 0.1; // mm

        for (const p of tumNoktalar) {
            let isDuplicate = false;
            for (const b of benzersiz) {
                const dist = Math.sqrt(Math.pow(p.x - b.x, 2) + Math.pow(p.y - b.y, 2));
                if (dist < tolerans) {
                    isDuplicate = true;
                    break;
                }
            }
            if (!isDuplicate) {
                benzersiz.push(p);
            }
        }

        // Eğer 3'ten az nokta varsa, birleştirme yapma
        if (benzersiz.length < 3) {
            return tumNoktalar;
        }

        // Convex Hull hesapla (Graham Scan)
        const hull = this.convexHull(benzersiz);

        // Hull'u kapatarak döndür
        if (hull.length > 0) {
            hull.push(hull[0].clone());
        }

        console.log(`[CAM] Face birleştirme: ${tumNoktalar.length} nokta → ${hull.length} nokta (convex hull)`);

        return hull;
    }

    /**
     * Convex Hull hesapla (Graham Scan algoritması)
     * 2D noktalar için dış sınır poligonu oluşturur
     */
    private convexHull(noktalar: FikoVektor3D[]): FikoVektor3D[] {
        if (noktalar.length < 3) return [...noktalar];

        // En alttaki (en küçük Y), eşitse en soldaki (en küçük X) noktayı bul
        let startIdx = 0;
        for (let i = 1; i < noktalar.length; i++) {
            if (noktalar[i].y < noktalar[startIdx].y ||
                (noktalar[i].y === noktalar[startIdx].y && noktalar[i].x < noktalar[startIdx].x)) {
                startIdx = i;
            }
        }

        const startPoint = noktalar[startIdx];

        // Cross product hesaplama
        const cross = (o: FikoVektor3D, a: FikoVektor3D, b: FikoVektor3D): number => {
            return (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
        };

        // Mesafe hesaplama
        const dist2 = (a: FikoVektor3D, b: FikoVektor3D): number => {
            return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2);
        };

        // Diğer noktaları açıya göre sırala
        const sortedNoktalar = noktalar
            .filter((_, i) => i !== startIdx)
            .sort((a, b) => {
                const crossVal = cross(startPoint, a, b);
                if (Math.abs(crossVal) < 0.0001) {
                    // Aynı açıda - mesafeye göre sırala
                    return dist2(startPoint, a) - dist2(startPoint, b);
                }
                return crossVal > 0 ? -1 : 1; // CCW sıralama
            });

        // Graham Scan
        const hull: FikoVektor3D[] = [startPoint];

        for (const p of sortedNoktalar) {
            // Sağa dönüş yapan noktaları kaldır
            while (hull.length > 1 && cross(hull[hull.length - 2], hull[hull.length - 1], p) <= 0) {
                hull.pop();
            }
            hull.push(p);
        }

        return hull;
    }

    /**
     * İki edge'i akıllıca birleştir - En yakın uçlardan bağla
     *
     * 4 olası bağlantı:
     * 1. mevcutSon -> yeniBas (normal)
     * 2. mevcutSon -> yeniSon (yeniyi ters çevir)
     * 3. mevcutBas -> yeniBas (mevcut ters çevir)
     * 4. mevcutBas -> yeniSon (ikisini de ters çevir)
     */
    private birlesikProfilOlustur(mevcut: FikoVektor3D[], yeni: FikoVektor3D[]): FikoVektor3D[] {
        if (mevcut.length === 0) return [...yeni];
        if (yeni.length === 0) return [...mevcut];

        // Uç noktaları
        const mevcutBas = mevcut[0];
        const mevcutSon = mevcut[mevcut.length - 1];
        const yeniBas = yeni[0];
        const yeniSon = yeni[yeni.length - 1];

        // 4 mesafeyi hesapla
        const mesafe = (a: FikoVektor3D, b: FikoVektor3D) =>
            Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));

        const d1 = mesafe(mevcutSon, yeniBas); // Normal bağlantı
        const d2 = mesafe(mevcutSon, yeniSon); // Yeniyi ters çevir
        const d3 = mesafe(mevcutBas, yeniBas); // Mevcut ters çevir
        const d4 = mesafe(mevcutBas, yeniSon); // İkisini ters çevir

        // En yakın bağlantıyı bul
        const minD = Math.min(d1, d2, d3, d4);
        const tolerans = 50; // mm - bu mesafeden fazla uzaksa uyar

        console.log(`[CAM-Birleştir] Mesafeler: d1=${d1.toFixed(2)}, d2=${d2.toFixed(2)}, d3=${d3.toFixed(2)}, d4=${d4.toFixed(2)} (min=${minD.toFixed(2)})`);

        if (minD > tolerans) {
            console.warn(`[CAM] Edge'ler arası mesafe çok fazla: ${minD.toFixed(2)}mm - Yine de birleştiriliyor`);
        }

        // En kısa mesafeye göre birleştir
        if (minD === d1) {
            // Normal: mevcut + yeni
            console.log('[CAM-Birleştir] Normal birleştirme (mevcutSon -> yeniBas)');
            return [...mevcut, ...yeni];
        } else if (minD === d2) {
            // Yeniyi ters çevir: mevcut + yeni.reverse()
            console.log('[CAM-Birleştir] Yeni edge ters çevrildi (mevcutSon -> yeniSon)');
            return [...mevcut, ...[...yeni].reverse()];
        } else if (minD === d3) {
            // Mevcut ters çevir: mevcut.reverse() + yeni = yeni + mevcut.reverse()
            console.log('[CAM-Birleştir] Mevcut edge ters çevrildi (mevcutBas -> yeniBas)');
            return [...yeni, ...[...mevcut].reverse()];
        } else {
            // İkisini ters çevir: yeni.reverse() + mevcut.reverse() = mevcut başa yeni sona (ters)
            console.log('[CAM-Birleştir] Her iki edge ters çevrildi (mevcutBas -> yeniSon)');
            return [[...yeni].reverse(), ...[...mevcut].reverse()].flat();
        }
    }

    /**
     * Üst limit seçimi işle
     */
    private handleUstLimitSecim(intersection: any): void {
        if (!intersection.point) return;

        // Seçilen yüzeyin Z değerini üst limit olarak ayarla
        this.topZ = intersection.point.z;
        this.secilenUstLimitFace = intersection;

        // Aktiviteye kaydet
        const akt = this.aktivite();
        if (akt) {
            akt.ustZ = this.topZ;
        }

        console.log('[CAM] Üst limit ayarlandı:', this.topZ.toFixed(2));

        // Seçim modunu kapat
        this.secimModunuKapat();
    }

    /**
     * Alt limit seçimi işle
     */
    private handleAltLimitSecim(intersection: any): void {
        if (!intersection.point) return;

        // Seçilen yüzeyin Z değerini alt limit olarak ayarla
        this.bottomZ = intersection.point.z;
        this.secilenAltLimitFace = intersection;

        // Aktiviteye kaydet
        const akt = this.aktivite();
        if (akt) {
            akt.altZ = this.bottomZ;
        }

        console.log('[CAM] Alt limit ayarlandı:', this.bottomZ.toFixed(2));

        // Seçim modunu kapat
        this.secimModunuKapat();
    }

    /**
     * Başlangıç noktası seçimi işle
     */
    private handleBaslangicSecim(intersection: any): void {
        if (!intersection.point) return;

        const akt = this.aktivite();
        if (!akt || akt.profilNoktalar.length === 0) {
            console.warn('[CAM] Önce profil seçimi yapın');
            return;
        }

        // Seçilen noktaya en yakın profil noktasını bul
        const secilenNokta = new FikoVektor3D(intersection.point.x, intersection.point.y, 0);
        let minDist = Infinity;
        let minIdx = 0;

        for (let i = 0; i < akt.profilNoktalar.length; i++) {
            const p = akt.profilNoktalar[i];
            const dist = Math.sqrt(Math.pow(p.x - secilenNokta.x, 2) + Math.pow(p.y - secilenNokta.y, 2));
            if (dist < minDist) {
                minDist = dist;
                minIdx = i;
            }
        }

        // Profil noktalarını başlangıç noktasından başlayacak şekilde döndür
        const rotated = [
            ...akt.profilNoktalar.slice(minIdx),
            ...akt.profilNoktalar.slice(0, minIdx)
        ];
        akt.profilNoktalar = rotated;

        console.log('[CAM] Başlangıç noktası ayarlandı:', minIdx);
        this.secimModunuKapat();
    }

    /**
     * Bitiş noktası seçimi işle
     */
    private handleBitisSecim(intersection: any): void {
        // Bitiş noktası genellikle kapalı profillerde başlangıçla aynıdır
        // Açık profillerde son nokta olarak belirlenir
        console.log('[CAM] Bitiş noktası seçildi');
        this.secimModunuKapat();
    }

    /**
     * Takım yönü seçimi işle
     * Seçilen yüzeyin normal vektörünü takım yönü olarak kullan
     */
    private handleTakimYonuSecim(intersection: any): void {
        if (!intersection) return;

        // Normal vektörü al
        let normal = intersection.normal;
        if (!normal) {
            // Face'in normal'ını manuel hesapla
            const face = intersection.face;
            if (face?.normal) {
                normal = face.normal.clone();
            } else {
                // Varsayılan: Z yukarı
                normal = new THREE.Vector3(0, 0, 1);
                console.warn('[CAM] Normal bulunamadı, varsayılan (0,0,1) kullanılıyor');
            }
        }

        // World space'e dönüştür (objenin rotasyonunu uygula)
        const mesh = intersection.object;
        if (mesh?.matrixWorld) {
            const normalMatrix = new THREE.Matrix3().getNormalMatrix(mesh.matrixWorld);
            normal.applyMatrix3(normalMatrix).normalize();
        }

        // NaN kontrolü
        if (isNaN(normal.x) || isNaN(normal.y) || isNaN(normal.z)) {
            console.warn('[CAM] Normal NaN değer içeriyor, varsayılan kullanılıyor');
            normal = new THREE.Vector3(0, 0, 1);
        }

        // Aktiviteye kaydet
        const akt = this.aktivite();
        if (akt) {
            akt.takimYonu = new FikoVektor3D(normal.x, normal.y, normal.z);
            console.log('[CAM] Takım yönü ayarlandı:',
                `(${normal.x.toFixed(3)}, ${normal.y.toFixed(3)}, ${normal.z.toFixed(3)})`);
        }

        this.secilenTakimYonuFace = intersection;
        this.secimModunuKapat();
        this.cd.detectChanges();
    }

    /**
     * Seçimi onayla ve aktiviteye kaydet
     */
    private secimOnayla(): void {
        const akt = this.aktivite();
        if (!akt) return;

        if (this.secimModu === 'profil' && akt.profilNoktalar.length > 0) {
            console.log('[CAM] Profil seçimi onaylandı:', akt.profilNoktalar.length, 'nokta');
            // Takım yolunu hesapla
            akt.hesapla();
        }

        this.secimModunuKapat();
        this.anaGosterim()?.ciz?.();
    }

    /**
     * Seçim modunu kapat ve temizle - FikoSecililer cleanup
     */
    private secimModunuKapat(): void {
        const anaGosterim = this.anaGosterim();
        const canvas = anaGosterim?.sunucu?.domElement as HTMLCanvasElement;

        // Cursor'u varsayılana döndür
        if (canvas) {
            canvas.style.cursor = 'default';
        }

        // Keyboard handler'ı kaldır
        if (this.keyDownHandler) {
            document.removeEventListener('keydown', this.keyDownHandler);
            this.keyDownHandler = null;
        }

        // FikoSecililer subscription'larını temizle
        this.secimSubscriptionTemizle();

        // FikoSecililer'i deaktive et ve temizle
        if (this.fikoSecililer) {
            this.fikoSecililer.aktif = false;
            this.fikoSecililer.temizle();
            this.fikoSecililer = null;
        }

        // Seçim durumlarını güncelle
        if (this.secimModu === 'profil') this.profilSecili = this.secilenProfilEdges.length > 0;
        if (this.secimModu === 'ustLimit') this.ustLimitSecili = this.secilenUstLimitFace !== null;
        if (this.secimModu === 'altLimit') this.altLimitSecili = this.secilenAltLimitFace !== null;
        if (this.secimModu === 'baslangic') this.baslangicSecili = false;
        if (this.secimModu === 'bitis') this.bitisSecili = false;
        if (this.secimModu === 'takimYonu') this.takimYonuSecili = this.secilenTakimYonuFace !== null;

        this.secimModu = null;

        // 3D sahneyi güncelle
        anaGosterim?.ciz?.();
        this.cd.detectChanges();
    }

    /**
     * Seçimi tamamen temizle
     */
    temizleSecim(tip: 'profil' | 'ustLimit' | 'altLimit' | 'hepsi'): void {
        const akt = this.aktivite();

        if (tip === 'profil' || tip === 'hepsi') {
            this.profilSecili = false;
            this.secilenProfilEdges = [];
            if (akt) akt.profilNoktalar = [];
        }

        if (tip === 'ustLimit' || tip === 'hepsi') {
            this.ustLimitSecili = false;
            this.secilenUstLimitFace = null;
            if (akt) akt.ustZ = 10;
            this.topZ = 10;
        }

        if (tip === 'altLimit' || tip === 'hepsi') {
            this.altLimitSecili = false;
            this.secilenAltLimitFace = null;
            if (akt) akt.altZ = -30;
            this.bottomZ = -30;
        }

        this.anaGosterim()?.ciz?.();
        this.cd.detectChanges();
    }

    // Başlangıç modu döngüsü: merkez -> icerde -> disarda -> merkez
    cycleBaslangicModu() {
        const modlar: Array<'merkez' | 'icerde' | 'disarda'> = ['merkez', 'icerde', 'disarda'];
        const simdikiIndex = modlar.indexOf(this.baslangicModu);
        this.baslangicModu = modlar[(simdikiIndex + 1) % modlar.length];
        this.cd.detectChanges();
    }

    // Bitiş modu döngüsü: merkez -> icerde -> disarda -> merkez
    cycleBitisModu() {
        const modlar: Array<'merkez' | 'icerde' | 'disarda'> = ['merkez', 'icerde', 'disarda'];
        const simdikiIndex = modlar.indexOf(this.bitisModu);
        this.bitisModu = modlar[(simdikiIndex + 1) % modlar.length];
        this.cd.detectChanges();
    }

    // Değer düzenleme - input dialog aç
    editValue(field: string) {
        this.editingField = field;
        const akt = this.aktivite();

        const labels: Record<string, string> = {
            'topZ': 'Üst Limit Z',
            'bottomZ': 'Alt Limit Z',
            'profilOffset': 'Profil Offset',
            'topOffset': 'Üst Offset',
            'bottomOffset': 'Alt Offset',
            'baslangicOffset': 'Başlangıç Offset',
            'bitisOffset': 'Bitiş Offset',
            'zHatve': 'Z Hatve (mm)',
            'yanalHatve': 'Yanal Hatve (mm)',
            'kesmeHizi': 'Kesme Hızı (m/dk)',
            // Tab 1 - İşleme
            'devir': 'Devir (rpm)',
            'yanalTekrar': 'Yanal Tekrar',
            'ilerlemeYaklasma': 'Yaklaşma İlerleme',
            'ilerlemeIsleme': 'İşleme İlerleme',
            'ilerlemeUzaklasma': 'Uzaklaşma İlerleme',
            // Tab 2 - Takım
            'takimCap': 'Takım Çapı (mm)',
            'takimBoy': 'Takım Boyu (mm)',
            'takimKesmeBoy': 'Kesme Boyu (mm)',
            'takimRadius': 'Köşe Radius (mm)',
            // Tab 3 - Geçişler (KAPSAMLI)
            'girisUzunluk': 'Giriş Uzunluğu (mm)',
            'cikisUzunluk': 'Çıkış Uzunluğu (mm)',
            'guvenliZ': 'Güvenli Z (mm)',
            'araGecisZ': 'Ara Geçiş Z (mm)',
            'yuzeyPayi': 'Yüzey Payı (mm)',
            'rampaAcisi': 'Rampa Açısı (°)',
            'heliselCap': 'Helisel Çap (mm)',
            'heliselAdim': 'Helisel Adım (mm)',
            'girisAcisi': 'Giriş Açısı (°)',
            'girisRadius': 'Giriş Radius (mm)',
            'girisYayAci': 'Giriş Yay Açısı (°)',
            'cikisAcisi': 'Çıkış Açısı (°)',
            'cikisRadius': 'Çıkış Radius (mm)',
            'basUzatma': 'Baş Uzatma (mm)',
            'sonUzatma': 'Son Uzatma (mm)',
            'overlap': 'Overlap (%)',
            'hizRapid': 'Rapid Hız',
            'hizDalma': 'Dalma Hızı',
            'hizCekme': 'Çekme Hızı',
            'hizLead': 'Lead Hız (%)',
            'sonTurPayi': 'Son Tur Payı (mm)',
            'sonTurIlerleme': 'Son Tur İlerleme',
            'sonTurDevir': 'Son Tur Devir (rpm)',
            // Profesyonel CAM Özellikleri
            'tabGenislik': 'Tab Genişlik (mm)',
            'tabYukseklik': 'Tab Yükseklik (mm)',
            'tabSayisi': 'Tab Sayısı',
            'tabMesafe': 'Tab Mesafesi (mm)',
            'koseYavaslamaOrani': 'Köşe Yavaşlama Oranı (%)',
            'koseMinAci': 'Minimum Köşe Açısı (°)',
            'stayDownMesafe': 'Stay-Down Mesafesi (mm)',
            'kaldirmaMesafesi': 'Kaldırma Mesafesi (mm)',
            'yumusatmaRadius': 'Yumuşatma Radius (mm)',
            'yumusatmaTolerans': 'Yumuşatma Tolerans (mm)',
            'kompanzasyonTolereans': 'Kompanzasyon Tolerans (mm)',
            'finishGecisSayisi': 'Finiş Geçiş Sayısı',
            'finishStockAzaltma': 'Finiş Stock Azaltma (mm)'
        };
        this.editingLabel = labels[field] || field;

        // Mevcut değeri al
        switch (field) {
            case 'topZ': this.editingValue = this.topZ; break;
            case 'bottomZ': this.editingValue = this.bottomZ; break;
            case 'profilOffset': this.editingValue = this.profilOffset; break;
            case 'topOffset': this.editingValue = this.topOffset; break;
            case 'bottomOffset': this.editingValue = this.bottomOffset; break;
            case 'baslangicOffset': this.editingValue = this.baslangicOffset; break;
            case 'bitisOffset': this.editingValue = this.bitisOffset; break;
            case 'zHatve': this.editingValue = akt?.zHatve || 1; break;
            case 'yanalHatve': this.editingValue = akt?.yanalHatve || 0.5; break;
            case 'kesmeHizi': this.editingValue = this.kesmeHizi; break;
            case 'devir': this.editingValue = akt?.devir || 3000; break;
            case 'yanalTekrar': this.editingValue = akt?.yanalTekrar || 1; break;
            case 'ilerlemeYaklasma': this.editingValue = akt?.ilerlemeYaklasma || 3000; break;
            case 'ilerlemeIsleme': this.editingValue = akt?.ilerlemeIsleme || 1500; break;
            case 'ilerlemeUzaklasma': this.editingValue = akt?.ilerlemeUzaklasma || 5000; break;
            case 'takimCap': this.editingValue = akt?.takim?.cap || 10; break;
            case 'takimBoy': this.editingValue = akt?.takim?.boy || 50; break;
            case 'takimKesmeBoy': this.editingValue = akt?.takim?.kesmeBoy || 30; break;
            case 'takimRadius': this.editingValue = akt?.takim?.radius || 0; break;
            // Tab 3 - Geçişler (KAPSAMLI)
            case 'girisUzunluk': this.editingValue = akt?.girisUzunluk || 5; break;
            case 'cikisUzunluk': this.editingValue = akt?.cikisUzunluk || 5; break;
            case 'guvenliZ': this.editingValue = akt?.guvenliZ || 5; break;
            case 'araGecisZ': this.editingValue = this.araGecisZ; break;
            case 'yuzeyPayi': this.editingValue = this.yuzeyPayi; break;
            case 'rampaAcisi': this.editingValue = this.rampaAcisi; break;
            case 'heliselCap': this.editingValue = this.heliselCap; break;
            case 'heliselAdim': this.editingValue = this.heliselAdim; break;
            case 'girisAcisi': this.editingValue = this.girisAcisi; break;
            case 'girisRadius': this.editingValue = this.girisRadius; break;
            case 'girisYayAci': this.editingValue = this.girisYayAci; break;
            case 'cikisAcisi': this.editingValue = this.cikisAcisi; break;
            case 'cikisRadius': this.editingValue = this.cikisRadius; break;
            case 'basUzatma': this.editingValue = this.basUzatma; break;
            case 'sonUzatma': this.editingValue = this.sonUzatma; break;
            case 'overlap': this.editingValue = this.overlap; break;
            case 'hizRapid': this.editingValue = this.hizRapid; break;
            case 'hizDalma': this.editingValue = this.hizDalma; break;
            case 'hizCekme': this.editingValue = this.hizCekme; break;
            case 'hizLead': this.editingValue = this.hizLead; break;
            case 'sonTurPayi': this.editingValue = akt?.sonTurPayi || 0.2; break;
            case 'sonTurIlerleme': this.editingValue = akt?.sonTurIlerleme || 800; break;
            case 'sonTurDevir': this.editingValue = this.sonTurDevir; break;
            // Profesyonel CAM parametreleri
            case 'tabGenislik': this.editingValue = this.tabGenislik; break;
            case 'tabYukseklik': this.editingValue = this.tabYukseklik; break;
            case 'tabSayisi': this.editingValue = this.tabSayisi; break;
            case 'tabMesafe': this.editingValue = this.tabMesafe; break;
            case 'koseYavaslamaOrani': this.editingValue = this.koseYavaslamaOrani; break;
            case 'koseMinAci': this.editingValue = this.koseMinAci; break;
            case 'stayDownMesafe': this.editingValue = this.stayDownMesafe; break;
            case 'kaldirmaMesafesi': this.editingValue = this.kaldirmaMesafesi; break;
            case 'yumusatmaRadius': this.editingValue = this.yumusatmaRadius; break;
            case 'yumusatmaTolerans': this.editingValue = this.yumusatmaTolerans; break;
            case 'kompanzasyonTolereans': this.editingValue = this.kompanzasyonTolereans; break;
            case 'finishGecisSayisi': this.editingValue = this.finishGecisSayisi; break;
            case 'finishStockAzaltma': this.editingValue = this.finishStockAzaltma; break;
        }

        this.cd.detectChanges();

        // Focus input
        setTimeout(() => {
            const input = document.querySelector('.input-dialog input') as HTMLInputElement;
            if (input) {
                input.focus();
                input.select();
            }
        }, 50);
    }

    // Değeri kaydet
    saveEdit(value: string) {
        const num = parseFloat(value);
        if (isNaN(num)) {
            this.cancelEdit();
            return;
        }
        const akt = this.aktivite();

        switch (this.editingField) {
            case 'topZ': this.topZ = num; break;
            case 'bottomZ': this.bottomZ = num; break;
            case 'profilOffset': this.profilOffset = Math.max(0, num); break;
            case 'topOffset': this.topOffset = num; break;
            case 'bottomOffset': this.bottomOffset = num; break;
            case 'baslangicOffset': this.baslangicOffset = num; break;
            case 'bitisOffset': this.bitisOffset = num; break;
            case 'zHatve': if (akt) akt.zHatve = num; break;
            case 'yanalHatve': if (akt) akt.yanalHatve = num; break;
            case 'kesmeHizi': this.kesmeHizi = num; break;
            case 'devir': if (akt) akt.devir = num; break;
            case 'yanalTekrar': if (akt) akt.yanalTekrar = Math.max(1, Math.floor(num)); break;
            case 'ilerlemeYaklasma': if (akt) akt.ilerlemeYaklasma = num; break;
            case 'ilerlemeIsleme': if (akt) akt.ilerlemeIsleme = num; break;
            case 'ilerlemeUzaklasma': if (akt) akt.ilerlemeUzaklasma = num; break;
            case 'takimCap': if (akt?.takim) akt.takim.cap = num; break;
            case 'takimBoy': if (akt?.takim) akt.takim.boy = num; break;
            case 'takimKesmeBoy': if (akt?.takim) akt.takim.kesmeBoy = num; break;
            case 'takimRadius': if (akt?.takim) akt.takim.radius = num; break;
            // Tab 3 - Geçişler (KAPSAMLI)
            case 'girisUzunluk': if (akt) akt.girisUzunluk = num; break;
            case 'cikisUzunluk': if (akt) akt.cikisUzunluk = num; break;
            case 'guvenliZ': if (akt) akt.guvenliZ = num; break;
            case 'araGecisZ': this.araGecisZ = Math.max(0.5, num); break;
            case 'yuzeyPayi': this.yuzeyPayi = Math.max(0, num); break;
            case 'rampaAcisi': this.rampaAcisi = Math.max(1, Math.min(45, num)); break;
            case 'heliselCap': this.heliselCap = Math.max(1, num); break;
            case 'heliselAdim': this.heliselAdim = Math.max(0.1, num); break;
            case 'girisAcisi': this.girisAcisi = Math.max(1, Math.min(90, num)); break;
            case 'girisRadius': this.girisRadius = Math.max(0.5, num); break;
            case 'girisYayAci': this.girisYayAci = Math.max(10, Math.min(180, num)); break;
            case 'cikisAcisi': this.cikisAcisi = Math.max(1, Math.min(90, num)); break;
            case 'cikisRadius': this.cikisRadius = Math.max(0.5, num); break;
            case 'basUzatma': this.basUzatma = Math.max(0, num); break;
            case 'sonUzatma': this.sonUzatma = Math.max(0, num); break;
            case 'overlap': this.overlap = Math.max(0, Math.min(100, num)); break;
            case 'hizRapid': this.hizRapid = Math.max(100, num); break;
            case 'hizDalma': this.hizDalma = Math.max(10, num); break;
            case 'hizCekme': this.hizCekme = Math.max(100, num); break;
            case 'hizLead': this.hizLead = Math.max(10, Math.min(200, num)); break;
            case 'sonTurPayi': if (akt) akt.sonTurPayi = num; break;
            case 'sonTurIlerleme': if (akt) akt.sonTurIlerleme = num; break;
            case 'sonTurDevir': this.sonTurDevir = Math.max(100, num); break;
            // Profesyonel CAM parametreleri
            case 'tabGenislik':
                this.tabGenislik = Math.max(1, num);
                if (akt) akt.tabGenislik = this.tabGenislik;
                break;
            case 'tabYukseklik':
                this.tabYukseklik = Math.max(0.5, num);
                if (akt) akt.tabYukseklik = this.tabYukseklik;
                break;
            case 'tabSayisi':
                this.tabSayisi = Math.max(1, Math.floor(num));
                if (akt) akt.tabSayisi = this.tabSayisi;
                break;
            case 'tabMesafe':
                this.tabMesafe = Math.max(5, num);
                if (akt) akt.tabMesafe = this.tabMesafe;
                break;
            case 'koseYavaslamaOrani':
                this.koseYavaslamaOrani = Math.max(10, Math.min(100, num));
                if (akt) akt.koseYavaslamaOrani = this.koseYavaslamaOrani;
                break;
            case 'koseMinAci':
                this.koseMinAci = Math.max(10, Math.min(180, num));
                if (akt) akt.koseMinAci = this.koseMinAci;
                break;
            case 'stayDownMesafe':
                this.stayDownMesafe = Math.max(1, num);
                if (akt) akt.stayDownMesafe = this.stayDownMesafe;
                break;
            case 'kaldirmaMesafesi':
                this.kaldirmaMesafesi = Math.max(0.5, num);
                if (akt) akt.kaldirmaMesafesi = this.kaldirmaMesafesi;
                break;
            case 'yumusatmaRadius':
                this.yumusatmaRadius = Math.max(0.1, num);
                if (akt) akt.yumusatmaRadius = this.yumusatmaRadius;
                break;
            case 'yumusatmaTolerans':
                this.yumusatmaTolerans = Math.max(0.001, num);
                if (akt) akt.yumusatmaTolerans = this.yumusatmaTolerans;
                break;
            case 'kompanzasyonTolereans':
                this.kompanzasyonTolereans = Math.max(0.001, num);
                if (akt) akt.kompanzasyonTolereans = this.kompanzasyonTolereans;
                break;
            case 'finishGecisSayisi':
                this.finishGecisSayisi = Math.max(1, Math.floor(num));
                if (akt) akt.finishGecisSayisi = this.finishGecisSayisi;
                break;
            case 'finishStockAzaltma':
                this.finishStockAzaltma = Math.max(0.01, num);
                if (akt) akt.finishStockAzaltma = this.finishStockAzaltma;
                break;
        }

        this.editingField = null;
        this.cd.detectChanges();

        // 🔧 PRODUCTION-READY: Parametre değiştiğinde otomatik takım yolu güncelleme
        this.otomatikHesapla();
    }

    /**
     * 🔧 PRODUCTION-READY: Otomatik hesaplama (debounced)
     * Parametre değişikliklerinde takım yolunu otomatik günceller
     */
    private hesaplaDebounceTimer: any = null;
    private otomatikHesapla(): void {
        // Debounce: 300ms bekle (çok sık hesaplama yapılmasını önle)
        if (this.hesaplaDebounceTimer) {
            clearTimeout(this.hesaplaDebounceTimer);
        }

        this.hesaplaDebounceTimer = setTimeout(() => {
            const akt = this.aktivite();
            if (akt && akt.profilNoktalar && akt.profilNoktalar.length >= 2) {
                console.log('[CAM] Otomatik hesaplama tetiklendi');
                this.hesapla();
            }
        }, 300);
    }

    // Edit iptal
    cancelEdit() {
        this.editingField = null;
        this.cd.detectChanges();
    }

    kaydet() {
        const akt = this.aktivite();
        if (!akt) {
            this.kapa();
            return;
        }

        // ═══════════════════════════════════════════════════════════════════
        // TEMEL PARAMETRELER (Tab 0)
        // ═══════════════════════════════════════════════════════════════════
        akt.ofsetMiktari = this.profilOffset;
        akt.ustZ = this.topZ;
        akt.altZ = this.bottomZ;

        // ═══════════════════════════════════════════════════════════════════
        // GEÇİŞ PARAMETRELERİ (Tab 3) - TÜM PARAMETRELER
        // ═══════════════════════════════════════════════════════════════════

        // Giriş parametreleri
        akt.girisRampaAcisi = this.rampaAcisi;
        akt.girisHeliselCap = this.heliselCap;
        akt.girisHeliselAdim = this.heliselAdim;
        akt.girisYayRadius = this.girisRadius;
        akt.girisYayAci = this.girisYayAci;
        akt.girisYonuCW = this.girisYonuCW;
        akt.girisTegetUzunluk = akt.girisUzunluk;

        // Çıkış parametreleri
        akt.cikisRampaAcisi = this.cikisAcisi;
        akt.cikisYayRadius = this.cikisRadius;
        akt.cikisYonuCW = this.cikisYonuCW;

        // Düzlem ve geçiş
        akt.araGecisZ = this.araGecisZ;
        akt.yuzeyPayi = this.yuzeyPayi;
        akt.gecisTipi = this.gecisTipi;

        // Uzatma & Overlap
        akt.basUzatma = this.basUzatma;
        akt.sonUzatma = this.sonUzatma;
        akt.overlap = this.overlap;
        akt.overcutEtkin = this.overcutEtkin;

        // Hız parametreleri
        akt.hizRapid = this.hizRapid;
        akt.ilerlemeDalma = this.hizDalma;
        akt.ilerlemeCekme = this.hizCekme;
        akt.ilerlemeLead = this.hizLead;

        // Son tur ek parametreleri
        akt.sonTurDevir = this.sonTurDevir;
        akt.sonTurAyriGiris = this.sonTurAyriGiris;

        // ═══════════════════════════════════════════════════════════════════
        // PROFESYONEL CAM PARAMETRELERİ
        // ═══════════════════════════════════════════════════════════════════

        // Tabs (Köprü/Tutma)
        akt.tabEtkin = this.tabEtkin;
        akt.tabSekli = this.tabSekli;
        akt.tabGenislik = this.tabGenislik;
        akt.tabYukseklik = this.tabYukseklik;
        akt.tabSayisi = this.tabSayisi;
        akt.tabMesafe = this.tabMesafe;
        akt.tabDagitim = this.tabDagitim;

        // Köşe Yavaşlama
        akt.koseYavaslamaEtkin = this.koseYavaslamaEtkin;
        akt.koseYavaslamaOrani = this.koseYavaslamaOrani;
        akt.koseMinAci = this.koseMinAci;
        akt.koseYavaslamaTipi = this.koseYavaslamaTipi;

        // Kompanzasyon
        akt.kompanzasyonTipi = this.kompanzasyonTipi;
        akt.kompanzasyonTolereans = this.kompanzasyonTolereans;

        // Stay-Down / Lift
        akt.stayDownEtkin = this.stayDownEtkin;
        akt.stayDownMesafe = this.stayDownMesafe;
        akt.kaldirmaMesafesi = this.kaldirmaMesafesi;

        // Yol Yumuşatma
        akt.yumusatmaEtkin = this.yumusatmaEtkin;
        akt.yumusatmaRadius = this.yumusatmaRadius;
        akt.yumusatmaTolerans = this.yumusatmaTolerans;

        // Freze Yönü
        akt.frezeYonu = this.frezeYonu;

        // Çoklu Finiş
        akt.finishGecisSayisi = this.finishGecisSayisi;
        akt.finishStockAzaltma = this.finishStockAzaltma;

        // ═══════════════════════════════════════════════════════════════════
        // UI GÜNCELLEMESİ
        // ═══════════════════════════════════════════════════════════════════
        this.anaGosterim()?.FikoYT?.degisti?.emit();
        this.anaGosterim()?.ciz?.();
        this.kapa();
    }

    hesapla() {
        const akt = this.aktivite();
        if (!akt) return;

        // Tüm parametreleri aktiviteye aktar
        akt.ofsetMiktari = this.profilOffset;
        akt.ustZ = this.topZ;
        akt.altZ = this.bottomZ;

        // Giriş parametreleri
        akt.girisRampaAcisi = this.rampaAcisi;
        akt.girisHeliselCap = this.heliselCap;
        akt.girisHeliselAdim = this.heliselAdim;
        akt.girisYayRadius = this.girisRadius;
        akt.girisYayAci = this.girisYayAci;
        akt.girisYonuCW = this.girisYonuCW;
        akt.girisTegetUzunluk = akt.girisUzunluk;

        // Çıkış parametreleri
        akt.cikisRampaAcisi = this.cikisAcisi;
        akt.cikisYayRadius = this.cikisRadius;
        akt.cikisYonuCW = this.cikisYonuCW;

        // Düzlem ve geçiş
        akt.araGecisZ = this.araGecisZ;
        akt.yuzeyPayi = this.yuzeyPayi;
        akt.gecisTipi = this.gecisTipi;

        // Uzatma & Overlap
        akt.basUzatma = this.basUzatma;
        akt.sonUzatma = this.sonUzatma;
        akt.overlap = this.overlap;
        akt.overcutEtkin = this.overcutEtkin;

        // Hız parametreleri
        akt.hizRapid = this.hizRapid;
        akt.ilerlemeDalma = this.hizDalma;
        akt.ilerlemeCekme = this.hizCekme;
        akt.ilerlemeLead = this.hizLead;

        // Son tur ek parametreleri
        akt.sonTurDevir = this.sonTurDevir;
        akt.sonTurAyriGiris = this.sonTurAyriGiris;

        // Profesyonel CAM parametreleri
        akt.tabEtkin = this.tabEtkin;
        akt.tabSekli = this.tabSekli;
        akt.tabGenislik = this.tabGenislik;
        akt.tabYukseklik = this.tabYukseklik;
        akt.tabSayisi = this.tabSayisi;
        akt.tabMesafe = this.tabMesafe;
        akt.tabDagitim = this.tabDagitim;
        akt.koseYavaslamaEtkin = this.koseYavaslamaEtkin;
        akt.koseYavaslamaOrani = this.koseYavaslamaOrani;
        akt.koseMinAci = this.koseMinAci;
        akt.koseYavaslamaTipi = this.koseYavaslamaTipi;
        akt.kompanzasyonTipi = this.kompanzasyonTipi;
        akt.kompanzasyonTolereans = this.kompanzasyonTolereans;
        akt.stayDownEtkin = this.stayDownEtkin;
        akt.stayDownMesafe = this.stayDownMesafe;
        akt.kaldirmaMesafesi = this.kaldirmaMesafesi;
        akt.yumusatmaEtkin = this.yumusatmaEtkin;
        akt.yumusatmaRadius = this.yumusatmaRadius;
        akt.yumusatmaTolerans = this.yumusatmaTolerans;
        akt.frezeYonu = this.frezeYonu;
        akt.finishGecisSayisi = this.finishGecisSayisi;
        akt.finishStockAzaltma = this.finishStockAzaltma;

        // Hesapla
        akt.hesapla();
        this.anaGosterim()?.ciz?.();
    }

    kapa() {
        const p = this.pencere();
        p?.instance?.kapa?.() || p?.kapa?.();
        this.kapandi.emit();
    }

    ngOnDestroy() {
        // Seçim modunu kapat ve event listener'ları temizle
        this.secimModunuKapat();
    }
}
